export default [{
    children: [{
        children: [{
            label: "東城區",
            value: "110101"
        }, {
            label: "西城區",
            value: "110102"
        }, {
            label: "朝陽區",
            value: "110105"
        }, {
            label: "豐臺區",
            value: "110106"
        }, {
            label: "石景山區",
            value: "110107"
        }, {
            label: "海澱區",
            value: "110108"
        }, {
            label: "門頭溝區",
            value: "110109"
        }, {
            label: "房山區",
            value: "110111"
        }, {
            label: "通州區",
            value: "110112"
        }, {
            label: "順義區",
            value: "110113"
        }, {
            label: "昌平區",
            value: "110114"
        }, {
            label: "大興區",
            value: "110115"
        }, {
            label: "懷柔區",
            value: "110116"
        }, {
            label: "平谷區",
            value: "110117"
        }, {
            label: "密雲區",
            value: "110118"
        }, {
            label: "延慶區",
            value: "110119"
        }
        ],
        label: "市轄區",
        value: "110100"
    }
    ],
    label: "北京市",
    value: "110000"
}, {
    children: [{
        children: [{
            label: "和平區",
            value: "120101"
        }, {
            label: "河東區",
            value: "120102"
        }, {
            label: "河西區",
            value: "120103"
        }, {
            label: "南開區",
            value: "120104"
        }, {
            label: "河北區",
            value: "120105"
        }, {
            label: "紅橋區",
            value: "120106"
        }, {
            label: "東麗區",
            value: "120110"
        }, {
            label: "西青區",
            value: "120111"
        }, {
            label: "津南區",
            value: "120112"
        }, {
            label: "北辰區",
            value: "120113"
        }, {
            label: "武清區",
            value: "120114"
        }, {
            label: "寶坻區",
            value: "120115"
        }, {
            label: "濱海新區",
            value: "120116"
        }, {
            label: "寧河區",
            value: "120117"
        }, {
            label: "靜海區",
            value: "120118"
        }, {
            label: "薊州區",
            value: "120119"
        }
        ],
        label: "市轄區",
        value: "120100"
    }
    ],
    label: "天津市",
    value: "120000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "130101"
        }, {
            label: "長安區",
            value: "130102"
        }, {
            label: "橋西區",
            value: "130104"
        }, {
            label: "新華區",
            value: "130105"
        }, {
            label: "井陘礦區",
            value: "130107"
        }, {
            label: "裕華區",
            value: "130108"
        }, {
            label: "槁城區",
            value: "130109"
        }, {
            label: "鹿泉區",
            value: "130110"
        }, {
            label: "欒城區",
            value: "130111"
        }, {
            label: "井陘縣",
            value: "130121"
        }, {
            label: "正定縣",
            value: "130123"
        }, {
            label: "行唐縣",
            value: "130125"
        }, {
            label: "靈壽縣",
            value: "130126"
        }, {
            label: "高邑縣",
            value: "130127"
        }, {
            label: "深澤縣",
            value: "130128"
        }, {
            label: "贊皇縣",
            value: "130129"
        }, {
            label: "無極縣",
            value: "130130"
        }, {
            label: "平山縣",
            value: "130131"
        }, {
            label: "元氏縣",
            value: "130132"
        }, {
            label: "趙縣",
            value: "130133"
        }, {
            label: "晉州市",
            value: "130183"
        }, {
            label: "新樂市",
            value: "130184"
        }
        ],
        label: "石家莊市",
        value: "130100"
    }, {
        children: [{
            label: "市轄區",
            value: "130201"
        }, {
            label: "路南區",
            value: "130202"
        }, {
            label: "路北區",
            value: "130203"
        }, {
            label: "古冶區",
            value: "130204"
        }, {
            label: "開平區",
            value: "130205"
        }, {
            label: "豐南區",
            value: "130207"
        }, {
            label: "豐潤區",
            value: "130208"
        }, {
            label: "曹妃甸區",
            value: "130209"
        }, {
            label: "灤縣",
            value: "130223"
        }, {
            label: "灤南縣",
            value: "130224"
        }, {
            label: "樂亭縣",
            value: "130225"
        }, {
            label: "遷西縣",
            value: "130227"
        }, {
            label: "玉田縣",
            value: "130229"
        }, {
            label: "遵化市",
            value: "130281"
        }, {
            label: "遷安市",
            value: "130283"
        }
        ],
        label: "唐山市",
        value: "130200"
    }, {
        children: [{
            label: "市轄區",
            value: "130301"
        }, {
            label: "海港區",
            value: "130302"
        }, {
            label: "山海關區",
            value: "130303"
        }, {
            label: "北戴河區",
            value: "130304"
        }, {
            label: "撫寧區",
            value: "130306"
        }, {
            label: "青龍滿族自治縣",
            value: "130321"
        }, {
            label: "昌黎縣",
            value: "130322"
        }, {
            label: "盧龍縣",
            value: "130324"
        }
        ],
        label: "秦皇島市",
        value: "130300"
    }, {
        children: [{
            label: "市轄區",
            value: "130401"
        }, {
            label: "邯山區",
            value: "130402"
        }, {
            label: "叢臺區",
            value: "130403"
        }, {
            label: "復興區",
            value: "130404"
        }, {
            label: "峰峰礦區",
            value: "130406"
        }, {
            label: "邯鄲縣",
            value: "130421"
        }, {
            label: "臨漳縣",
            value: "130423"
        }, {
            label: "成安縣",
            value: "130424"
        }, {
            label: "大名縣",
            value: "130425"
        }, {
            label: "涉縣",
            value: "130426"
        }, {
            label: "磁縣",
            value: "130427"
        }, {
            label: "肥鄉縣",
            value: "130428"
        }, {
            label: "永年縣",
            value: "130429"
        }, {
            label: "邱縣",
            value: "130430"
        }, {
            label: "雞澤縣",
            value: "130431"
        }, {
            label: "廣平縣",
            value: "130432"
        }, {
            label: "館陶縣",
            value: "130433"
        }, {
            label: "魏縣",
            value: "130434"
        }, {
            label: "曲周縣",
            value: "130435"
        }, {
            label: "武安市",
            value: "130481"
        }
        ],
        label: "邯鄲市",
        value: "130400"
    }, {
        children: [{
            label: "市轄區",
            value: "130501"
        }, {
            label: "橋東區",
            value: "130502"
        }, {
            label: "橋西區",
            value: "130503"
        }, {
            label: "邢臺縣",
            value: "130521"
        }, {
            label: "臨城縣",
            value: "130522"
        }, {
            label: "內丘縣",
            value: "130523"
        }, {
            label: "柏鄉縣",
            value: "130524"
        }, {
            label: "隆堯縣",
            value: "130525"
        }, {
            label: "任縣",
            value: "130526"
        }, {
            label: "南和縣",
            value: "130527"
        }, {
            label: "寧晉縣",
            value: "130528"
        }, {
            label: "巨鹿縣",
            value: "130529"
        }, {
            label: "新河縣",
            value: "130530"
        }, {
            label: "廣宗縣",
            value: "130531"
        }, {
            label: "平鄉縣",
            value: "130532"
        }, {
            label: "威縣",
            value: "130533"
        }, {
            label: "清河縣",
            value: "130534"
        }, {
            label: "臨西縣",
            value: "130535"
        }, {
            label: "南宮市",
            value: "130581"
        }, {
            label: "沙河市",
            value: "130582"
        }
        ],
        label: "邢臺市",
        value: "130500"
    }, {
        children: [{
            label: "市轄區",
            value: "130601"
        }, {
            label: "競秀區",
            value: "130602"
        }, {
            label: "蓮池區",
            value: "130606"
        }, {
            label: "滿城區",
            value: "130607"
        }, {
            label: "清苑區",
            value: "130608"
        }, {
            label: "徐水區",
            value: "130609"
        }, {
            label: "淶水縣",
            value: "130623"
        }, {
            label: "阜平縣",
            value: "130624"
        }, {
            label: "定興縣",
            value: "130626"
        }, {
            label: "唐縣",
            value: "130627"
        }, {
            label: "高陽縣",
            value: "130628"
        }, {
            label: "容城縣",
            value: "130629"
        }, {
            label: "淶源縣",
            value: "130630"
        }, {
            label: "望都縣",
            value: "130631"
        }, {
            label: "安新縣",
            value: "130632"
        }, {
            label: "易縣",
            value: "130633"
        }, {
            label: "曲陽縣",
            value: "130634"
        }, {
            label: "蠡縣",
            value: "130635"
        }, {
            label: "順平縣",
            value: "130636"
        }, {
            label: "博野縣",
            value: "130637"
        }, {
            label: "雄縣",
            value: "130638"
        }, {
            label: "涿州市",
            value: "130681"
        }, {
            label: "安國市",
            value: "130683"
        }, {
            label: "高碑店市",
            value: "130684"
        }
        ],
        label: "保定市",
        value: "130600"
    }, {
        children: [{
            label: "市轄區",
            value: "130701"
        }, {
            label: "橋東區",
            value: "130702"
        }, {
            label: "橋西區",
            value: "130703"
        }, {
            label: "宣化區",
            value: "130705"
        }, {
            label: "下花園區",
            value: "130706"
        }, {
            label: "萬全區",
            value: "130708"
        }, {
            label: "崇禮區",
            value: "130709"
        }, {
            label: "張北縣",
            value: "130722"
        }, {
            label: "康保縣",
            value: "130723"
        }, {
            label: "沽源縣",
            value: "130724"
        }, {
            label: "尚義縣",
            value: "130725"
        }, {
            label: "蔚縣",
            value: "130726"
        }, {
            label: "陽原縣",
            value: "130727"
        }, {
            label: "懷安縣",
            value: "130728"
        }, {
            label: "懷來縣",
            value: "130730"
        }, {
            label: "涿鹿縣",
            value: "130731"
        }, {
            label: "赤城縣",
            value: "130732"
        }
        ],
        label: "張家口市",
        value: "130700"
    }, {
        children: [{
            label: "市轄區",
            value: "130801"
        }, {
            label: "雙橋區",
            value: "130802"
        }, {
            label: "雙灤區",
            value: "130803"
        }, {
            label: "鷹手營子礦區",
            value: "130804"
        }, {
            label: "承德縣",
            value: "130821"
        }, {
            label: "興隆縣",
            value: "130822"
        }, {
            label: "平泉縣",
            value: "130823"
        }, {
            label: "灤平縣",
            value: "130824"
        }, {
            label: "隆化縣",
            value: "130825"
        }, {
            label: "豐寧滿族自治縣",
            value: "130826"
        }, {
            label: "寬城滿族自治縣",
            value: "130827"
        }, {
            label: "圍場滿族蒙古族自治縣",
            value: "130828"
        }
        ],
        label: "承德市",
        value: "130800"
    }, {
        children: [{
            label: "市轄區",
            value: "130901"
        }, {
            label: "新華區",
            value: "130902"
        }, {
            label: "運河區",
            value: "130903"
        }, {
            label: "滄縣",
            value: "130921"
        }, {
            label: "青縣",
            value: "130922"
        }, {
            label: "東光縣",
            value: "130923"
        }, {
            label: "海興縣",
            value: "130924"
        }, {
            label: "鹽山縣",
            value: "130925"
        }, {
            label: "肅寧縣",
            value: "130926"
        }, {
            label: "南皮縣",
            value: "130927"
        }, {
            label: "吳橋縣",
            value: "130928"
        }, {
            label: "獻縣",
            value: "130929"
        }, {
            label: "孟村回族自治縣",
            value: "130930"
        }, {
            label: "泊頭市",
            value: "130981"
        }, {
            label: "任丘市",
            value: "130982"
        }, {
            label: "黃驊市",
            value: "130983"
        }, {
            label: "河間市",
            value: "130984"
        }
        ],
        label: "滄州市",
        value: "130900"
    }, {
        children: [{
            label: "市轄區",
            value: "131001"
        }, {
            label: "安次區",
            value: "131002"
        }, {
            label: "廣陽區",
            value: "131003"
        }, {
            label: "固安縣",
            value: "131022"
        }, {
            label: "永清縣",
            value: "131023"
        }, {
            label: "香河縣",
            value: "131024"
        }, {
            label: "大城縣",
            value: "131025"
        }, {
            label: "文安縣",
            value: "131026"
        }, {
            label: "大廠回族自治縣",
            value: "131028"
        }, {
            label: "霸州市",
            value: "131081"
        }, {
            label: "三河市",
            value: "131082"
        }
        ],
        label: "廊坊市",
        value: "131000"
    }, {
        children: [{
            label: "市轄區",
            value: "131101"
        }, {
            label: "桃城區",
            value: "131102"
        }, {
            label: "冀州區",
            value: "131103"
        }, {
            label: "棗強縣",
            value: "131121"
        }, {
            label: "武邑縣",
            value: "131122"
        }, {
            label: "武強縣",
            value: "131123"
        }, {
            label: "饒陽縣",
            value: "131124"
        }, {
            label: "安平縣",
            value: "131125"
        }, {
            label: "故城縣",
            value: "131126"
        }, {
            label: "景縣",
            value: "131127"
        }, {
            label: "阜城縣",
            value: "131128"
        }, {
            label: "深州市",
            value: "131182"
        }
        ],
        label: "衡水市",
        value: "131100"
    }, {
        children: [{
            label: "定州市",
            value: "139001"
        }, {
            label: "辛集市",
            value: "139002"
        }
        ],
        label: "省直轄縣級行政區劃",
        value: "139000"
    }
    ],
    label: "河北省",
    value: "130000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "140101"
        }, {
            label: "小店區",
            value: "140105"
        }, {
            label: "迎澤區",
            value: "140106"
        }, {
            label: "杏花嶺區",
            value: "140107"
        }, {
            label: "尖草坪區",
            value: "140108"
        }, {
            label: "萬柏林區",
            value: "140109"
        }, {
            label: "晉源區",
            value: "140110"
        }, {
            label: "清徐縣",
            value: "140121"
        }, {
            label: "陽曲縣",
            value: "140122"
        }, {
            label: "婁煩縣",
            value: "140123"
        }, {
            label: "古交市",
            value: "140181"
        }
        ],
        label: "太原市",
        value: "140100"
    }, {
        children: [{
            label: "市轄區",
            value: "140201"
        }, {
            label: "城區",
            value: "140202"
        }, {
            label: "礦區",
            value: "140203"
        }, {
            label: "南郊區",
            value: "140211"
        }, {
            label: "新榮區",
            value: "140212"
        }, {
            label: "陽高縣",
            value: "140221"
        }, {
            label: "天鎮縣",
            value: "140222"
        }, {
            label: "廣靈縣",
            value: "140223"
        }, {
            label: "靈丘縣",
            value: "140224"
        }, {
            label: "渾源縣",
            value: "140225"
        }, {
            label: "左雲縣",
            value: "140226"
        }, {
            label: "大同縣",
            value: "140227"
        }
        ],
        label: "大同市",
        value: "140200"
    }, {
        children: [{
            label: "市轄區",
            value: "140301"
        }, {
            label: "城區",
            value: "140302"
        }, {
            label: "礦區",
            value: "140303"
        }, {
            label: "郊區",
            value: "140311"
        }, {
            label: "平定縣",
            value: "140321"
        }, {
            label: "盂縣",
            value: "140322"
        }
        ],
        label: "陽泉市",
        value: "140300"
    }, {
        children: [{
            label: "市轄區",
            value: "140401"
        }, {
            label: "城區",
            value: "140402"
        }, {
            label: "郊區",
            value: "140411"
        }, {
            label: "長治縣",
            value: "140421"
        }, {
            label: "襄垣縣",
            value: "140423"
        }, {
            label: "屯留縣",
            value: "140424"
        }, {
            label: "平順縣",
            value: "140425"
        }, {
            label: "黎城縣",
            value: "140426"
        }, {
            label: "壺關縣",
            value: "140427"
        }, {
            label: "長子縣",
            value: "140428"
        }, {
            label: "武鄉縣",
            value: "140429"
        }, {
            label: "沁縣",
            value: "140430"
        }, {
            label: "沁源縣",
            value: "140431"
        }, {
            label: "潞城市",
            value: "140481"
        }
        ],
        label: "長治市",
        value: "140400"
    }, {
        children: [{
            label: "市轄區",
            value: "140501"
        }, {
            label: "城區",
            value: "140502"
        }, {
            label: "沁水縣",
            value: "140521"
        }, {
            label: "陽城縣",
            value: "140522"
        }, {
            label: "陵川縣",
            value: "140524"
        }, {
            label: "澤州縣",
            value: "140525"
        }, {
            label: "高平市",
            value: "140581"
        }
        ],
        label: "晉城市",
        value: "140500"
    }, {
        children: [{
            label: "市轄區",
            value: "140601"
        }, {
            label: "朔城區",
            value: "140602"
        }, {
            label: "平魯區",
            value: "140603"
        }, {
            label: "山陰縣",
            value: "140621"
        }, {
            label: "應縣",
            value: "140622"
        }, {
            label: "右玉縣",
            value: "140623"
        }, {
            label: "懷仁縣",
            value: "140624"
        }
        ],
        label: "朔州市",
        value: "140600"
    }, {
        children: [{
            label: "市轄區",
            value: "140701"
        }, {
            label: "榆次區",
            value: "140702"
        }, {
            label: "榆社縣",
            value: "140721"
        }, {
            label: "左權縣",
            value: "140722"
        }, {
            label: "和順縣",
            value: "140723"
        }, {
            label: "昔陽縣",
            value: "140724"
        }, {
            label: "壽陽縣",
            value: "140725"
        }, {
            label: "太谷縣",
            value: "140726"
        }, {
            label: "祁縣",
            value: "140727"
        }, {
            label: "平遙縣",
            value: "140728"
        }, {
            label: "靈石縣",
            value: "140729"
        }, {
            label: "介休市",
            value: "140781"
        }
        ],
        label: "晉中市",
        value: "140700"
    }, {
        children: [{
            label: "市轄區",
            value: "140801"
        }, {
            label: "鹽湖區",
            value: "140802"
        }, {
            label: "臨猗縣",
            value: "140821"
        }, {
            label: "萬榮縣",
            value: "140822"
        }, {
            label: "聞喜縣",
            value: "140823"
        }, {
            label: "稷山縣",
            value: "140824"
        }, {
            label: "新絳縣",
            value: "140825"
        }, {
            label: "絳縣",
            value: "140826"
        }, {
            label: "垣曲縣",
            value: "140827"
        }, {
            label: "夏縣",
            value: "140828"
        }, {
            label: "平陸縣",
            value: "140829"
        }, {
            label: "芮城縣",
            value: "140830"
        }, {
            label: "永濟市",
            value: "140881"
        }, {
            label: "河津市",
            value: "140882"
        }
        ],
        label: "運城市",
        value: "140800"
    }, {
        children: [{
            label: "市轄區",
            value: "140901"
        }, {
            label: "忻府區",
            value: "140902"
        }, {
            label: "定襄縣",
            value: "140921"
        }, {
            label: "五臺縣",
            value: "140922"
        }, {
            label: "代縣",
            value: "140923"
        }, {
            label: "繁峙縣",
            value: "140924"
        }, {
            label: "寧武縣",
            value: "140925"
        }, {
            label: "靜樂縣",
            value: "140926"
        }, {
            label: "神池縣",
            value: "140927"
        }, {
            label: "五寨縣",
            value: "140928"
        }, {
            label: "岢嵐縣",
            value: "140929"
        }, {
            label: "河曲縣",
            value: "140930"
        }, {
            label: "保德縣",
            value: "140931"
        }, {
            label: "偏關縣",
            value: "140932"
        }, {
            label: "原平市",
            value: "140981"
        }
        ],
        label: "忻州市",
        value: "140900"
    }, {
        children: [{
            label: "市轄區",
            value: "141001"
        }, {
            label: "堯都區",
            value: "141002"
        }, {
            label: "曲沃縣",
            value: "141021"
        }, {
            label: "翼城縣",
            value: "141022"
        }, {
            label: "襄汾縣",
            value: "141023"
        }, {
            label: "洪洞縣",
            value: "141024"
        }, {
            label: "古縣",
            value: "141025"
        }, {
            label: "安澤縣",
            value: "141026"
        }, {
            label: "浮山縣",
            value: "141027"
        }, {
            label: "吉縣",
            value: "141028"
        }, {
            label: "鄉寧縣",
            value: "141029"
        }, {
            label: "大寧縣",
            value: "141030"
        }, {
            label: "隰縣",
            value: "141031"
        }, {
            label: "永和縣",
            value: "141032"
        }, {
            label: "蒲縣",
            value: "141033"
        }, {
            label: "汾西縣",
            value: "141034"
        }, {
            label: "侯馬市",
            value: "141081"
        }, {
            label: "霍州市",
            value: "141082"
        }
        ],
        label: "臨汾市",
        value: "141000"
    }, {
        children: [{
            label: "市轄區",
            value: "141101"
        }, {
            label: "離石區",
            value: "141102"
        }, {
            label: "文水縣",
            value: "141121"
        }, {
            label: "交城縣",
            value: "141122"
        }, {
            label: "興縣",
            value: "141123"
        }, {
            label: "臨縣",
            value: "141124"
        }, {
            label: "柳林縣",
            value: "141125"
        }, {
            label: "石樓縣",
            value: "141126"
        }, {
            label: "嵐縣",
            value: "141127"
        }, {
            label: "方山縣",
            value: "141128"
        }, {
            label: "中陽縣",
            value: "141129"
        }, {
            label: "交口縣",
            value: "141130"
        }, {
            label: "孝義市",
            value: "141181"
        }, {
            label: "汾陽市",
            value: "141182"
        }
        ],
        label: "呂梁市",
        value: "141100"
    }
    ],
    label: "山西省",
    value: "140000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "150101"
        }, {
            label: "新城區",
            value: "150102"
        }, {
            label: "回民區",
            value: "150103"
        }, {
            label: "玉泉區",
            value: "150104"
        }, {
            label: "賽罕區",
            value: "150105"
        }, {
            label: "土默特左旗",
            value: "150121"
        }, {
            label: "托克托縣",
            value: "150122"
        }, {
            label: "和林格爾縣",
            value: "150123"
        }, {
            label: "清水河縣",
            value: "150124"
        }, {
            label: "武川縣",
            value: "150125"
        }
        ],
        label: "呼和浩特市",
        value: "150100"
    }, {
        children: [{
            label: "市轄區",
            value: "150201"
        }, {
            label: "東河區",
            value: "150202"
        }, {
            label: "昆都侖區",
            value: "150203"
        }, {
            label: "青山區",
            value: "150204"
        }, {
            label: "石拐區",
            value: "150205"
        }, {
            label: "白雲鄂博礦區",
            value: "150206"
        }, {
            label: "九原區",
            value: "150207"
        }, {
            label: "土默特右旗",
            value: "150221"
        }, {
            label: "固陽縣",
            value: "150222"
        }, {
            label: "達爾罕茂明安聯合旗",
            value: "150223"
        }
        ],
        label: "包頭市",
        value: "150200"
    }, {
        children: [{
            label: "市轄區",
            value: "150301"
        }, {
            label: "海勃灣區",
            value: "150302"
        }, {
            label: "海南區",
            value: "150303"
        }, {
            label: "烏達區",
            value: "150304"
        }
        ],
        label: "烏海市",
        value: "150300"
    }, {
        children: [{
            label: "市轄區",
            value: "150401"
        }, {
            label: "紅山區",
            value: "150402"
        }, {
            label: "元寶山區",
            value: "150403"
        }, {
            label: "松山區",
            value: "150404"
        }, {
            label: "阿魯科爾沁旗",
            value: "150421"
        }, {
            label: "巴林左旗",
            value: "150422"
        }, {
            label: "巴林右旗",
            value: "150423"
        }, {
            label: "林西縣",
            value: "150424"
        }, {
            label: "克什克騰旗",
            value: "150425"
        }, {
            label: "翁牛特旗",
            value: "150426"
        }, {
            label: "喀喇沁旗",
            value: "150428"
        }, {
            label: "寧城縣",
            value: "150429"
        }, {
            label: "敖漢旗",
            value: "150430"
        }
        ],
        label: "赤峰市",
        value: "150400"
    }, {
        children: [{
            label: "市轄區",
            value: "150501"
        }, {
            label: "科爾沁區",
            value: "150502"
        }, {
            label: "科爾沁左翼中旗",
            value: "150521"
        }, {
            label: "科爾沁左翼後旗",
            value: "150522"
        }, {
            label: "開魯縣",
            value: "150523"
        }, {
            label: "庫倫旗",
            value: "150524"
        }, {
            label: "奈曼旗",
            value: "150525"
        }, {
            label: "紮魯特旗",
            value: "150526"
        }, {
            label: "霍林郭勒市",
            value: "150581"
        }
        ],
        label: "通遼市",
        value: "150500"
    }, {
        children: [{
            label: "市轄區",
            value: "150601"
        }, {
            label: "東勝區",
            value: "150602"
        }, {
            label: "康巴什區",
            value: "150603"
        }, {
            label: "達拉特旗",
            value: "150621"
        }, {
            label: "準格爾旗",
            value: "150622"
        }, {
            label: "鄂托克前旗",
            value: "150623"
        }, {
            label: "鄂托克旗",
            value: "150624"
        }, {
            label: "杭錦旗",
            value: "150625"
        }, {
            label: "烏審旗",
            value: "150626"
        }, {
            label: "伊金霍洛旗",
            value: "150627"
        }
        ],
        label: "鄂爾多斯市",
        value: "150600"
    }, {
        children: [{
            label: "市轄區",
            value: "150701"
        }, {
            label: "海拉爾區",
            value: "150702"
        }, {
            label: "紮賚諾爾區",
            value: "150703"
        }, {
            label: "阿榮旗",
            value: "150721"
        }, {
            label: "莫力達瓦達斡爾族自治旗",
            value: "150722"
        }, {
            label: "鄂倫春自治旗",
            value: "150723"
        }, {
            label: "鄂溫克族自治旗",
            value: "150724"
        }, {
            label: "陳巴爾虎旗",
            value: "150725"
        }, {
            label: "新巴爾虎左旗",
            value: "150726"
        }, {
            label: "新巴爾虎右旗",
            value: "150727"
        }, {
            label: "滿洲裏市",
            value: "150781"
        }, {
            label: "牙克石市",
            value: "150782"
        }, {
            label: "紮蘭屯市",
            value: "150783"
        }, {
            label: "額爾古納市",
            value: "150784"
        }, {
            label: "根河市",
            value: "150785"
        }
        ],
        label: "呼倫貝爾市",
        value: "150700"
    }, {
        children: [{
            label: "市轄區",
            value: "150801"
        }, {
            label: "臨河區",
            value: "150802"
        }, {
            label: "五原縣",
            value: "150821"
        }, {
            label: "磴口縣",
            value: "150822"
        }, {
            label: "烏拉特前旗",
            value: "150823"
        }, {
            label: "烏拉特中旗",
            value: "150824"
        }, {
            label: "烏拉特後旗",
            value: "150825"
        }, {
            label: "杭錦後旗",
            value: "150826"
        }
        ],
        label: "巴彥淖爾市",
        value: "150800"
    }, {
        children: [{
            label: "市轄區",
            value: "150901"
        }, {
            label: "集寧區",
            value: "150902"
        }, {
            label: "卓資縣",
            value: "150921"
        }, {
            label: "化德縣",
            value: "150922"
        }, {
            label: "商都縣",
            value: "150923"
        }, {
            label: "興和縣",
            value: "150924"
        }, {
            label: "涼城縣",
            value: "150925"
        }, {
            label: "察哈爾右翼前旗",
            value: "150926"
        }, {
            label: "察哈爾右翼中旗",
            value: "150927"
        }, {
            label: "察哈爾右翼後旗",
            value: "150928"
        }, {
            label: "四子王旗",
            value: "150929"
        }, {
            label: "豐鎮市",
            value: "150981"
        }
        ],
        label: "烏蘭察布市",
        value: "150900"
    }, {
        children: [{
            label: "烏蘭浩特市",
            value: "152201"
        }, {
            label: "阿爾山市",
            value: "152202"
        }, {
            label: "科爾沁右翼前旗",
            value: "152221"
        }, {
            label: "科爾沁右翼中旗",
            value: "152222"
        }, {
            label: "紮賚特旗",
            value: "152223"
        }, {
            label: "突泉縣",
            value: "152224"
        }
        ],
        label: "興安盟",
        value: "152200"
    }, {
        children: [{
            label: "二連浩特市",
            value: "152501"
        }, {
            label: "錫林浩特市",
            value: "152502"
        }, {
            label: "阿巴嘎旗",
            value: "152522"
        }, {
            label: "蘇尼特左旗",
            value: "152523"
        }, {
            label: "蘇尼特右旗",
            value: "152524"
        }, {
            label: "東烏珠穆沁旗",
            value: "152525"
        }, {
            label: "西烏珠穆沁旗",
            value: "152526"
        }, {
            label: "太仆寺旗",
            value: "152527"
        }, {
            label: "鑲黃旗",
            value: "152528"
        }, {
            label: "正鑲白旗",
            value: "152529"
        }, {
            label: "正藍旗",
            value: "152530"
        }, {
            label: "多倫縣",
            value: "152531"
        }
        ],
        label: "錫林郭勒盟",
        value: "152500"
    }, {
        children: [{
            label: "阿拉善左旗",
            value: "152921"
        }, {
            label: "阿拉善右旗",
            value: "152922"
        }, {
            label: "額濟納旗",
            value: "152923"
        }
        ],
        label: "阿拉善盟",
        value: "152900"
    }
    ],
    label: "內蒙古自治區",
    value: "150000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "210101"
        }, {
            label: "和平區",
            value: "210102"
        }, {
            label: "沈河區",
            value: "210103"
        }, {
            label: "大東區",
            value: "210104"
        }, {
            label: "皇姑區",
            value: "210105"
        }, {
            label: "鐵西區",
            value: "210106"
        }, {
            label: "蘇家屯區",
            value: "210111"
        }, {
            label: "渾南區",
            value: "210112"
        }, {
            label: "沈北新區",
            value: "210113"
        }, {
            label: "於洪區",
            value: "210114"
        }, {
            label: "遼中區",
            value: "210115"
        }, {
            label: "康平縣",
            value: "210123"
        }, {
            label: "法庫縣",
            value: "210124"
        }, {
            label: "新民市",
            value: "210181"
        }
        ],
        label: "沈陽市",
        value: "210100"
    }, {
        children: [{
            label: "市轄區",
            value: "210201"
        }, {
            label: "中山區",
            value: "210202"
        }, {
            label: "西崗區",
            value: "210203"
        }, {
            label: "沙河口區",
            value: "210204"
        }, {
            label: "甘井子區",
            value: "210211"
        }, {
            label: "旅順口區",
            value: "210212"
        }, {
            label: "金州區",
            value: "210213"
        }, {
            label: "普蘭店區",
            value: "210214"
        }, {
            label: "長海縣",
            value: "210224"
        }, {
            label: "瓦房店市",
            value: "210281"
        }, {
            label: "莊河市",
            value: "210283"
        }
        ],
        label: "大連市",
        value: "210200"
    }, {
        children: [{
            label: "市轄區",
            value: "210301"
        }, {
            label: "鐵東區",
            value: "210302"
        }, {
            label: "鐵西區",
            value: "210303"
        }, {
            label: "立山區",
            value: "210304"
        }, {
            label: "千山區",
            value: "210311"
        }, {
            label: "臺安縣",
            value: "210321"
        }, {
            label: "岫巖滿族自治縣",
            value: "210323"
        }, {
            label: "海城市",
            value: "210381"
        }
        ],
        label: "鞍山市",
        value: "210300"
    }, {
        children: [{
            label: "市轄區",
            value: "210401"
        }, {
            label: "新撫區",
            value: "210402"
        }, {
            label: "東洲區",
            value: "210403"
        }, {
            label: "望花區",
            value: "210404"
        }, {
            label: "順城區",
            value: "210411"
        }, {
            label: "撫順縣",
            value: "210421"
        }, {
            label: "新賓滿族自治縣",
            value: "210422"
        }, {
            label: "清原滿族自治縣",
            value: "210423"
        }
        ],
        label: "撫順市",
        value: "210400"
    }, {
        children: [{
            label: "市轄區",
            value: "210401"
        }, {
            label: "新撫區",
            value: "210402"
        }, {
            label: "東洲區",
            value: "210403"
        }, {
            label: "望花區",
            value: "210404"
        }, {
            label: "順城區",
            value: "210411"
        }, {
            label: "撫順縣",
            value: "210421"
        }, {
            label: "新賓滿族自治縣",
            value: "210422"
        }, {
            label: "清原滿族自治縣",
            value: "210423"
        }
        ],
        label: "本溪市",
        value: "210500"
    }, {
        children: [{
            label: "市轄區",
            value: "210601"
        }, {
            label: "元寶區",
            value: "210602"
        }, {
            label: "振興區",
            value: "210603"
        }, {
            label: "振安區",
            value: "210604"
        }, {
            label: "寬甸滿族自治縣",
            value: "210624"
        }, {
            label: "東港市",
            value: "210681"
        }, {
            label: "鳳城市",
            value: "210682"
        }
        ],
        label: "丹東市",
        value: "210600"
    }, {
        children: [{
            label: "市轄區",
            value: "210701"
        }, {
            label: "古塔區",
            value: "210702"
        }, {
            label: "淩河區",
            value: "210703"
        }, {
            label: "太和區",
            value: "210711"
        }, {
            label: "黑山縣",
            value: "210726"
        }, {
            label: "義縣",
            value: "210727"
        }, {
            label: "淩海市",
            value: "210781"
        }, {
            label: "北鎮市",
            value: "210782"
        }
        ],
        label: "錦州市",
        value: "210700"
    }, {
        children: [{
            label: "市轄區",
            value: "210801"
        }, {
            label: "站前區",
            value: "210802"
        }, {
            label: "西市區",
            value: "210803"
        }, {
            label: "鮁魚圈區",
            value: "210804"
        }, {
            label: "老邊區",
            value: "210811"
        }, {
            label: "蓋州市",
            value: "210881"
        }, {
            label: "大石橋市",
            value: "210882"
        }
        ],
        label: "營口市",
        value: "210800"
    }, {
        children: [{
            label: "市轄區",
            value: "210901"
        }, {
            label: "海州區",
            value: "210902"
        }, {
            label: "新邱區",
            value: "210903"
        }, {
            label: "太平區",
            value: "210904"
        }, {
            label: "清河門區",
            value: "210905"
        }, {
            label: "細河區",
            value: "210911"
        }, {
            label: "阜新蒙古族自治縣",
            value: "210921"
        }, {
            label: "彰武縣",
            value: "210922"
        }
        ],
        label: "阜新市",
        value: "210900"
    }, {
        children: [{
            label: "市轄區",
            value: "211001"
        }, {
            label: "白塔區",
            value: "211002"
        }, {
            label: "文聖區",
            value: "211003"
        }, {
            label: "宏偉區",
            value: "211004"
        }, {
            label: "弓長嶺區",
            value: "211005"
        }, {
            label: "太子河區",
            value: "211011"
        }, {
            label: "遼陽縣",
            value: "211021"
        }, {
            label: "燈塔市",
            value: "211081"
        }
        ],
        label: "遼陽市",
        value: "211000"
    }, {
        children: [{
            label: "市轄區",
            value: "211101"
        }, {
            label: "雙臺子區",
            value: "211102"
        }, {
            label: "興隆臺區",
            value: "211103"
        }, {
            label: "大窪區",
            value: "211104"
        }, {
            label: "盤山縣",
            value: "211122"
        }
        ],
        label: "盤錦市",
        value: "211100"
    }, {
        children: [{
            label: "市轄區",
            value: "211201"
        }, {
            label: "銀州區",
            value: "211202"
        }, {
            label: "清河區",
            value: "211204"
        }, {
            label: "鐵嶺縣",
            value: "211221"
        }, {
            label: "西豐縣",
            value: "211223"
        }, {
            label: "昌圖縣",
            value: "211224"
        }, {
            label: "調兵山市",
            value: "211281"
        }, {
            label: "開原市",
            value: "211282"
        }
        ],
        label: "鐵嶺市",
        value: "211200"
    }, {
        children: [{
            label: "市轄區",
            value: "211301"
        }, {
            label: "雙塔區",
            value: "211302"
        }, {
            label: "龍城區",
            value: "211303"
        }, {
            label: "朝陽縣",
            value: "211321"
        }, {
            label: "建平縣",
            value: "211322"
        }, {
            label: "喀喇沁左翼蒙古族自治縣",
            value: "211324"
        }, {
            label: "北票市",
            value: "211381"
        }, {
            label: "淩源市",
            value: "211382"
        }
        ],
        label: "朝陽市",
        value: "211300"
    }, {
        children: [{
            label: "市轄區",
            value: "211401"
        }, {
            label: "連山區",
            value: "211402"
        }, {
            label: "龍港區",
            value: "211403"
        }, {
            label: "南票區",
            value: "211404"
        }, {
            label: "綏中縣",
            value: "211421"
        }, {
            label: "建昌縣",
            value: "211422"
        }, {
            label: "興城市",
            value: "211481"
        }
        ],
        label: "葫蘆島市",
        value: "211400"
    }
    ],
    label: "遼寧省",
    value: "210000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "220101"
        }, {
            label: "南關區",
            value: "220102"
        }, {
            label: "寬城區",
            value: "220103"
        }, {
            label: "朝陽區",
            value: "220104"
        }, {
            label: "二道區",
            value: "220105"
        }, {
            label: "綠園區",
            value: "220106"
        }, {
            label: "雙陽區",
            value: "220112"
        }, {
            label: "九臺區",
            value: "220113"
        }, {
            label: "農安縣",
            value: "220122"
        }, {
            label: "榆樹市",
            value: "220182"
        }, {
            label: "德惠市",
            value: "220183"
        }
        ],
        label: "長春市",
        value: "220100"
    }, {
        children: [{
            label: "市轄區",
            value: "220201"
        }, {
            label: "昌邑區",
            value: "220202"
        }, {
            label: "龍潭區",
            value: "220203"
        }, {
            label: "船營區",
            value: "220204"
        }, {
            label: "豐滿區",
            value: "220211"
        }, {
            label: "永吉縣",
            value: "220221"
        }, {
            label: "蛟河市",
            value: "220281"
        }, {
            label: "樺甸市",
            value: "220282"
        }, {
            label: "舒蘭市",
            value: "220283"
        }, {
            label: "磐石市",
            value: "220284"
        }
        ],
        label: "吉林市",
        value: "220200"
    }, {
        children: [{
            label: "市轄區",
            value: "220301"
        }, {
            label: "鐵西區",
            value: "220302"
        }, {
            label: "鐵東區",
            value: "220303"
        }, {
            label: "梨樹縣",
            value: "220322"
        }, {
            label: "伊通滿族自治縣",
            value: "220323"
        }, {
            label: "公主嶺市",
            value: "220381"
        }, {
            label: "雙遼市",
            value: "220382"
        }
        ],
        label: "四平市",
        value: "220300"
    }, {
        children: [{
            label: "市轄區",
            value: "220401"
        }, {
            label: "龍山區",
            value: "220402"
        }, {
            label: "西安區",
            value: "220403"
        }, {
            label: "東豐縣",
            value: "220421"
        }, {
            label: "東遼縣",
            value: "220422"
        }
        ],
        label: "遼源市",
        value: "220400"
    }, {
        children: [{
            label: "市轄區",
            value: "220501"
        }, {
            label: "東昌區",
            value: "220502"
        }, {
            label: "二道江區",
            value: "220503"
        }, {
            label: "通化縣",
            value: "220521"
        }, {
            label: "輝南縣",
            value: "220523"
        }, {
            label: "柳河縣",
            value: "220524"
        }, {
            label: "梅河口市",
            value: "220581"
        }, {
            label: "集安市",
            value: "220582"
        }
        ],
        label: "通化市",
        value: "220500"
    }, {
        children: [{
            label: "市轄區",
            value: "220601"
        }, {
            label: "渾江區",
            value: "220602"
        }, {
            label: "江源區",
            value: "220605"
        }, {
            label: "撫松縣",
            value: "220621"
        }, {
            label: "靖宇縣",
            value: "220622"
        }, {
            label: "長白朝鮮族自治縣",
            value: "220623"
        }, {
            label: "臨江市",
            value: "220681"
        }
        ],
        label: "白山市",
        value: "220600"
    }, {
        children: [{
            label: "市轄區",
            value: "220701"
        }, {
            label: "寧江區",
            value: "220702"
        }, {
            label: "前郭爾羅斯蒙古族自治縣",
            value: "220721"
        }, {
            label: "長嶺縣",
            value: "220722"
        }, {
            label: "乾安縣",
            value: "220723"
        }, {
            label: "扶余市",
            value: "220781"
        }
        ],
        label: "松原市",
        value: "220700"
    }, {
        children: [{
            label: "市轄區",
            value: "220801"
        }, {
            label: "洮北區",
            value: "220802"
        }, {
            label: "鎮賚縣",
            value: "220821"
        }, {
            label: "通榆縣",
            value: "220822"
        }, {
            label: "洮南市",
            value: "220881"
        }, {
            label: "大安市",
            value: "220882"
        }
        ],
        label: "白城市",
        value: "220800"
    }, {
        children: [{
            label: "延吉市",
            value: "222401"
        }, {
            label: "圖們市",
            value: "222402"
        }, {
            label: "敦化市",
            value: "222403"
        }, {
            label: "琿春市",
            value: "222404"
        }, {
            label: "龍井市",
            value: "222405"
        }, {
            label: "和龍市",
            value: "222406"
        }, {
            label: "汪清縣",
            value: "222424"
        }, {
            label: "安圖縣",
            value: "222426"
        }
        ],
        label: "延邊朝鮮族自治州",
        value: "222400"
    }
    ],
    label: "吉林省",
    value: "220000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "230101"
        }, {
            label: "道裏區",
            value: "230102"
        }, {
            label: "南崗區",
            value: "230103"
        }, {
            label: "道外區",
            value: "230104"
        }, {
            label: "平房區",
            value: "230108"
        }, {
            label: "松北區",
            value: "230109"
        }, {
            label: "香坊區",
            value: "230110"
        }, {
            label: "呼蘭區",
            value: "230111"
        }, {
            label: "阿城區",
            value: "230112"
        }, {
            label: "雙城區",
            value: "230113"
        }, {
            label: "依蘭縣",
            value: "230123"
        }, {
            label: "方正縣",
            value: "230124"
        }, {
            label: "賓縣",
            value: "230125"
        }, {
            label: "巴彥縣",
            value: "230126"
        }, {
            label: "木蘭縣",
            value: "230127"
        }, {
            label: "通河縣",
            value: "230128"
        }, {
            label: "延壽縣",
            value: "230129"
        }, {
            label: "尚誌市",
            value: "230183"
        }, {
            label: "五常市",
            value: "230184"
        }
        ],
        label: "哈爾濱市",
        value: "230100"
    }, {
        children: [{
            label: "市轄區",
            value: "230201"
        }, {
            label: "龍沙區",
            value: "230202"
        }, {
            label: "建華區",
            value: "230203"
        }, {
            label: "鐵鋒區",
            value: "230204"
        }, {
            label: "昂昂溪區",
            value: "230205"
        }, {
            label: "富拉爾基區",
            value: "230206"
        }, {
            label: "碾子山區",
            value: "230207"
        }, {
            label: "梅裏斯達斡爾族區",
            value: "230208"
        }, {
            label: "龍江縣",
            value: "230221"
        }, {
            label: "依安縣",
            value: "230223"
        }, {
            label: "泰來縣",
            value: "230224"
        }, {
            label: "甘南縣",
            value: "230225"
        }, {
            label: "富裕縣",
            value: "230227"
        }, {
            label: "克山縣",
            value: "230229"
        }, {
            label: "克東縣",
            value: "230230"
        }, {
            label: "拜泉縣",
            value: "230231"
        }, {
            label: "訥河市",
            value: "230281"
        }
        ],
        label: "齊齊哈爾市",
        value: "230200"
    }, {
        children: [{
            label: "市轄區",
            value: "230301"
        }, {
            label: "雞冠區",
            value: "230302"
        }, {
            label: "恒山區",
            value: "230303"
        }, {
            label: "滴道區",
            value: "230304"
        }, {
            label: "梨樹區",
            value: "230305"
        }, {
            label: "城子河區",
            value: "230306"
        }, {
            label: "麻山區",
            value: "230307"
        }, {
            label: "雞東縣",
            value: "230321"
        }, {
            label: "虎林市",
            value: "230381"
        }, {
            label: "密山市",
            value: "230382"
        }
        ],
        label: "雞西市",
        value: "230300"
    }, {
        children: [{
            label: "市轄區",
            value: "230401"
        }, {
            label: "向陽區",
            value: "230402"
        }, {
            label: "工農區",
            value: "230403"
        }, {
            label: "南山區",
            value: "230404"
        }, {
            label: "興安區",
            value: "230405"
        }, {
            label: "東山區",
            value: "230406"
        }, {
            label: "興山區",
            value: "230407"
        }, {
            label: "蘿北縣",
            value: "230421"
        }, {
            label: "綏濱縣",
            value: "230422"
        }
        ],
        label: "鶴崗市",
        value: "230400"
    }, {
        children: [{
            label: "市轄區",
            value: "230501"
        }, {
            label: "尖山區",
            value: "230502"
        }, {
            label: "嶺東區",
            value: "230503"
        }, {
            label: "四方臺區",
            value: "230505"
        }, {
            label: "寶山區",
            value: "230506"
        }, {
            label: "集賢縣",
            value: "230521"
        }, {
            label: "友誼縣",
            value: "230522"
        }, {
            label: "寶清縣",
            value: "230523"
        }, {
            label: "饒河縣",
            value: "230524"
        }
        ],
        label: "雙鴨山市",
        value: "230500"
    }, {
        children: [{
            label: "市轄區",
            value: "230601"
        }, {
            label: "薩爾圖區",
            value: "230602"
        }, {
            label: "龍鳳區",
            value: "230603"
        }, {
            label: "讓胡路區",
            value: "230604"
        }, {
            label: "紅崗區",
            value: "230605"
        }, {
            label: "大同區",
            value: "230606"
        }, {
            label: "肇州縣",
            value: "230621"
        }, {
            label: "肇源縣",
            value: "230622"
        }, {
            label: "林甸縣",
            value: "230623"
        }, {
            label: "杜爾伯特蒙古族自治縣",
            value: "230624"
        }
        ],
        label: "大慶市",
        value: "230600"
    }, {
        children: [{
            label: "市轄區",
            value: "230701"
        }, {
            label: "伊春區",
            value: "230702"
        }, {
            label: "南岔區",
            value: "230703"
        }, {
            label: "友好區",
            value: "230704"
        }, {
            label: "西林區",
            value: "230705"
        }, {
            label: "翠巒區",
            value: "230706"
        }, {
            label: "新青區",
            value: "230707"
        }, {
            label: "美溪區",
            value: "230708"
        }, {
            label: "金山屯區",
            value: "230709"
        }, {
            label: "五營區",
            value: "230710"
        }, {
            label: "烏馬河區",
            value: "230711"
        }, {
            label: "湯旺河區",
            value: "230712"
        }, {
            label: "帶嶺區",
            value: "230713"
        }, {
            label: "烏伊嶺區",
            value: "230714"
        }, {
            label: "紅星區",
            value: "230715"
        }, {
            label: "上甘嶺區",
            value: "230716"
        }, {
            label: "嘉蔭縣",
            value: "230722"
        }, {
            label: "鐵力市",
            value: "230781"
        }
        ],
        label: "伊春市",
        value: "230700"
    }, {
        children: [{
            label: "市轄區",
            value: "230801"
        }, {
            label: "向陽區",
            value: "230803"
        }, {
            label: "前進區",
            value: "230804"
        }, {
            label: "東風區",
            value: "230805"
        }, {
            label: "郊區",
            value: "230811"
        }, {
            label: "樺南縣",
            value: "230822"
        }, {
            label: "樺川縣",
            value: "230826"
        }, {
            label: "湯原縣",
            value: "230828"
        }, {
            label: "同江市",
            value: "230881"
        }, {
            label: "富錦市",
            value: "230882"
        }, {
            label: "撫遠市",
            value: "230883"
        }
        ],
        label: "佳木斯市",
        value: "230800"
    }, {
        children: [{
            label: "市轄區",
            value: "230901"
        }, {
            label: "新興區",
            value: "230902"
        }, {
            label: "桃山區",
            value: "230903"
        }, {
            label: "茄子河區",
            value: "230904"
        }, {
            label: "勃利縣",
            value: "230921"
        }
        ],
        label: "七臺河市",
        value: "230900"
    }, {
        children: [{
            label: "市轄區",
            value: "231001"
        }, {
            label: "東安區",
            value: "231002"
        }, {
            label: "陽明區",
            value: "231003"
        }, {
            label: "愛民區",
            value: "231004"
        }, {
            label: "西安區",
            value: "231005"
        }, {
            label: "林口縣",
            value: "231025"
        }, {
            label: "綏芬河市",
            value: "231081"
        }, {
            label: "海林市",
            value: "231083"
        }, {
            label: "寧安市",
            value: "231084"
        }, {
            label: "穆棱市",
            value: "231085"
        }, {
            label: "東寧市",
            value: "231086"
        }
        ],
        label: "牡丹江市",
        value: "231000"
    }, {
        children: [{
            label: "市轄區",
            value: "231101"
        }, {
            label: "愛輝區",
            value: "231102"
        }, {
            label: "嫩江縣",
            value: "231121"
        }, {
            label: "遜克縣",
            value: "231123"
        }, {
            label: "孫吳縣",
            value: "231124"
        }, {
            label: "北安市",
            value: "231181"
        }, {
            label: "五大連池市",
            value: "231182"
        }
        ],
        label: "黑河市",
        value: "231100"
    }, {
        children: [{
            label: "市轄區",
            value: "231201"
        }, {
            label: "北林區",
            value: "231202"
        }, {
            label: "望奎縣",
            value: "231221"
        }, {
            label: "蘭西縣",
            value: "231222"
        }, {
            label: "青岡縣",
            value: "231223"
        }, {
            label: "慶安縣",
            value: "231224"
        }, {
            label: "明水縣",
            value: "231225"
        }, {
            label: "綏棱縣",
            value: "231226"
        }, {
            label: "安達市",
            value: "231281"
        }, {
            label: "肇東市",
            value: "231282"
        }, {
            label: "海倫市",
            value: "231283"
        }
        ],
        label: "綏化市",
        value: "231200"
    }, {
        children: [{
            label: "呼瑪縣",
            value: "232721"
        }, {
            label: "塔河縣",
            value: "232722"
        }, {
            label: "漠河縣",
            value: "232723"
        }
        ],
        label: "大興安嶺地區",
        value: "232700"
    }
    ],
    label: "黑龍江省",
    value: "230000"
}, {
    children: [{
        children: [{
            label: "黃浦區",
            value: "310101"
        }, {
            label: "徐匯區",
            value: "310104"
        }, {
            label: "長寧區",
            value: "310105"
        }, {
            label: "靜安區",
            value: "310106"
        }, {
            label: "普陀區",
            value: "310107"
        }, {
            label: "虹口區",
            value: "310109"
        }, {
            label: "楊浦區",
            value: "310110"
        }, {
            label: "閔行區",
            value: "310112"
        }, {
            label: "寶山區",
            value: "310113"
        }, {
            label: "嘉定區",
            value: "310114"
        }, {
            label: "浦東新區",
            value: "310115"
        }, {
            label: "金山區",
            value: "310116"
        }, {
            label: "松江區",
            value: "310117"
        }, {
            label: "青浦區",
            value: "310118"
        }, {
            label: "奉賢區",
            value: "310120"
        }, {
            label: "崇明區",
            value: "310151"
        }
        ],
        label: "市轄區",
        value: "310100"
    }
    ],
    label: "上海市",
    value: "310000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "320101"
        }, {
            label: "玄武區",
            value: "320102"
        }, {
            label: "秦淮區",
            value: "320104"
        }, {
            label: "建鄴區",
            value: "320105"
        }, {
            label: "鼓樓區",
            value: "320106"
        }, {
            label: "浦口區",
            value: "320111"
        }, {
            label: "棲霞區",
            value: "320113"
        }, {
            label: "雨花臺區",
            value: "320114"
        }, {
            label: "江寧區",
            value: "320115"
        }, {
            label: "六合區",
            value: "320116"
        }, {
            label: "溧水區",
            value: "320117"
        }, {
            label: "高淳區",
            value: "320118"
        }
        ],
        label: "南京市",
        value: "320100"
    }, {
        children: [{
            label: "市轄區",
            value: "320201"
        }, {
            label: "錫山區",
            value: "320205"
        }, {
            label: "惠山區",
            value: "320206"
        }, {
            label: "濱湖區",
            value: "320211"
        }, {
            label: "梁溪區",
            value: "320213"
        }, {
            label: "新吳區",
            value: "320214"
        }, {
            label: "江陰市",
            value: "320281"
        }, {
            label: "宜興市",
            value: "320282"
        }
        ],
        label: "無錫市",
        value: "320200"
    }, {
        children: [{
            label: "市轄區",
            value: "320301"
        }, {
            label: "鼓樓區",
            value: "320302"
        }, {
            label: "雲龍區",
            value: "320303"
        }, {
            label: "賈汪區",
            value: "320305"
        }, {
            label: "泉山區",
            value: "320311"
        }, {
            label: "銅山區",
            value: "320312"
        }, {
            label: "豐縣",
            value: "320321"
        }, {
            label: "沛縣",
            value: "320322"
        }, {
            label: "睢寧縣",
            value: "320324"
        }, {
            label: "新沂市",
            value: "320381"
        }, {
            label: "邳州市",
            value: "320382"
        }
        ],
        label: "徐州市",
        value: "320300"
    }, {
        children: [{
            label: "市轄區",
            value: "320401"
        }, {
            label: "天寧區",
            value: "320402"
        }, {
            label: "鐘樓區",
            value: "320404"
        }, {
            label: "新北區",
            value: "320411"
        }, {
            label: "武進區",
            value: "320412"
        }, {
            label: "金壇區",
            value: "320413"
        }, {
            label: "溧陽市",
            value: "320481"
        }
        ],
        label: "常州市",
        value: "320400"
    }, {
        children: [{
            label: "市轄區",
            value: "320501"
        }, {
            label: "虎丘區",
            value: "320505"
        }, {
            label: "吳中區",
            value: "320506"
        }, {
            label: "相城區",
            value: "320507"
        }, {
            label: "姑蘇區",
            value: "320508"
        }, {
            label: "吳江區",
            value: "320509"
        }, {
            label: "常熟市",
            value: "320581"
        }, {
            label: "張家港市",
            value: "320582"
        }, {
            label: "昆山市",
            value: "320583"
        }, {
            label: "太倉市",
            value: "320585"
        }
        ],
        label: "蘇州市",
        value: "320500"
    }, {
        children: [{
            label: "市轄區",
            value: "320601"
        }, {
            label: "崇川區",
            value: "320602"
        }, {
            label: "港閘區",
            value: "320611"
        }, {
            label: "通州區",
            value: "320612"
        }, {
            label: "海安縣",
            value: "320621"
        }, {
            label: "如東縣",
            value: "320623"
        }, {
            label: "啟東市",
            value: "320681"
        }, {
            label: "如臯市",
            value: "320682"
        }, {
            label: "海門市",
            value: "320684"
        }
        ],
        label: "南通市",
        value: "320600"
    }, {
        children: [{
            label: "市轄區",
            value: "320701"
        }, {
            label: "連雲區",
            value: "320703"
        }, {
            label: "海州區",
            value: "320706"
        }, {
            label: "贛榆區",
            value: "320707"
        }, {
            label: "東海縣",
            value: "320722"
        }, {
            label: "灌雲縣",
            value: "320723"
        }, {
            label: "灌南縣",
            value: "320724"
        }
        ],
        label: "連雲港市",
        value: "320700"
    }, {
        children: [{
            label: "市轄區",
            value: "320801"
        }, {
            label: "淮安區",
            value: "320803"
        }, {
            label: "淮陰區",
            value: "320804"
        }, {
            label: "清江浦區",
            value: "320812"
        }, {
            label: "洪澤區",
            value: "320813"
        }, {
            label: "漣水縣",
            value: "320826"
        }, {
            label: "盱眙縣",
            value: "320830"
        }, {
            label: "金湖縣",
            value: "320831"
        }
        ],
        label: "淮安市",
        value: "320800"
    }, {
        children: [{
            label: "市轄區",
            value: "320901"
        }, {
            label: "亭湖區",
            value: "320902"
        }, {
            label: "鹽都區",
            value: "320903"
        }, {
            label: "大豐區",
            value: "320904"
        }, {
            label: "響水縣",
            value: "320921"
        }, {
            label: "濱海縣",
            value: "320922"
        }, {
            label: "阜寧縣",
            value: "320923"
        }, {
            label: "射陽縣",
            value: "320924"
        }, {
            label: "建湖縣",
            value: "320925"
        }, {
            label: "東臺市",
            value: "320981"
        }
        ],
        label: "鹽城市",
        value: "320900"
    }, {
        children: [{
            label: "市轄區",
            value: "321001"
        }, {
            label: "廣陵區",
            value: "321002"
        }, {
            label: "邗江區",
            value: "321003"
        }, {
            label: "江都區",
            value: "321012"
        }, {
            label: "寶應縣",
            value: "321023"
        }, {
            label: "儀征市",
            value: "321081"
        }, {
            label: "高郵市",
            value: "321084"
        }
        ],
        label: "揚州市",
        value: "321000"
    }, {
        children: [{
            label: "市轄區",
            value: "321101"
        }, {
            label: "京口區",
            value: "321102"
        }, {
            label: "潤州區",
            value: "321111"
        }, {
            label: "丹徒區",
            value: "321112"
        }, {
            label: "丹陽市",
            value: "321181"
        }, {
            label: "揚中市",
            value: "321182"
        }, {
            label: "句容市",
            value: "321183"
        }
        ],
        label: "鎮江市",
        value: "321100"
    }, {
        children: [{
            label: "市轄區",
            value: "321201"
        }, {
            label: "海陵區",
            value: "321202"
        }, {
            label: "高港區",
            value: "321203"
        }, {
            label: "姜堰區",
            value: "321204"
        }, {
            label: "興化市",
            value: "321281"
        }, {
            label: "靖江市",
            value: "321282"
        }, {
            label: "泰興市",
            value: "321283"
        }
        ],
        label: "泰州市",
        value: "321200"
    }, {
        children: [{
            label: "市轄區",
            value: "321301"
        }, {
            label: "宿城區",
            value: "321302"
        }, {
            label: "宿豫區",
            value: "321311"
        }, {
            label: "沭陽縣",
            value: "321322"
        }, {
            label: "泗陽縣",
            value: "321323"
        }, {
            label: "泗洪縣",
            value: "321324"
        }
        ],
        label: "宿遷市",
        value: "321300"
    }
    ],
    label: "江蘇省",
    value: "320000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "330101"
        }, {
            label: "上城區",
            value: "330102"
        }, {
            label: "下城區",
            value: "330103"
        }, {
            label: "江幹區",
            value: "330104"
        }, {
            label: "拱墅區",
            value: "330105"
        }, {
            label: "西湖區",
            value: "330106"
        }, {
            label: "濱江區",
            value: "330108"
        }, {
            label: "蕭山區",
            value: "330109"
        }, {
            label: "余杭區",
            value: "330110"
        }, {
            label: "富陽區",
            value: "330111"
        }, {
            label: "桐廬縣",
            value: "330122"
        }, {
            label: "淳安縣",
            value: "330127"
        }, {
            label: "建德市",
            value: "330182"
        }, {
            label: "臨安市",
            value: "330185"
        }
        ],
        label: "杭州市",
        value: "330100"
    }, {
        children: [{
            label: "市轄區",
            value: "330201"
        }, {
            label: "海曙區",
            value: "330203"
        }, {
            label: "江東區",
            value: "330204"
        }, {
            label: "江北區",
            value: "330205"
        }, {
            label: "北侖區",
            value: "330206"
        }, {
            label: "鎮海區",
            value: "330211"
        }, {
            label: "鄞州區",
            value: "330212"
        }, {
            label: "象山縣",
            value: "330225"
        }, {
            label: "寧海縣",
            value: "330226"
        }, {
            label: "余姚市",
            value: "330281"
        }, {
            label: "慈溪市",
            value: "330282"
        }, {
            label: "奉化市",
            value: "330283"
        }
        ],
        label: "寧波市",
        value: "330200"
    }, {
        children: [{
            label: "市轄區",
            value: "330301"
        }, {
            label: "鹿城區",
            value: "330302"
        }, {
            label: "龍灣區",
            value: "330303"
        }, {
            label: "甌海區",
            value: "330304"
        }, {
            label: "洞頭區",
            value: "330305"
        }, {
            label: "永嘉縣",
            value: "330324"
        }, {
            label: "平陽縣",
            value: "330326"
        }, {
            label: "蒼南縣",
            value: "330327"
        }, {
            label: "文成縣",
            value: "330328"
        }, {
            label: "泰順縣",
            value: "330329"
        }, {
            label: "瑞安市",
            value: "330381"
        }, {
            label: "樂清市",
            value: "330382"
        }
        ],
        label: "溫州市",
        value: "330300"
    }, {
        children: [{
            label: "市轄區",
            value: "330401"
        }, {
            label: "南湖區",
            value: "330402"
        }, {
            label: "秀洲區",
            value: "330411"
        }, {
            label: "嘉善縣",
            value: "330421"
        }, {
            label: "海鹽縣",
            value: "330424"
        }, {
            label: "海寧市",
            value: "330481"
        }, {
            label: "平湖市",
            value: "330482"
        }, {
            label: "桐鄉市",
            value: "330483"
        }
        ],
        label: "嘉興市",
        value: "330400"
    }, {
        children: [{
            label: "市轄區",
            value: "330501"
        }, {
            label: "吳興區",
            value: "330502"
        }, {
            label: "南潯區",
            value: "330503"
        }, {
            label: "德清縣",
            value: "330521"
        }, {
            label: "長興縣",
            value: "330522"
        }, {
            label: "安吉縣",
            value: "330523"
        }
        ],
        label: "湖州市",
        value: "330500"
    }, {
        children: [{
            label: "市轄區",
            value: "330601"
        }, {
            label: "越城區",
            value: "330602"
        }, {
            label: "柯橋區",
            value: "330603"
        }, {
            label: "上虞區",
            value: "330604"
        }, {
            label: "新昌縣",
            value: "330624"
        }, {
            label: "諸暨市",
            value: "330681"
        }, {
            label: "嵊州市",
            value: "330683"
        }
        ],
        label: "紹興市",
        value: "330600"
    }, {
        children: [{
            label: "市轄區",
            value: "330701"
        }, {
            label: "婺城區",
            value: "330702"
        }, {
            label: "金東區",
            value: "330703"
        }, {
            label: "武義縣",
            value: "330723"
        }, {
            label: "浦江縣",
            value: "330726"
        }, {
            label: "磐安縣",
            value: "330727"
        }, {
            label: "蘭溪市",
            value: "330781"
        }, {
            label: "義烏市",
            value: "330782"
        }, {
            label: "東陽市",
            value: "330783"
        }, {
            label: "永康市",
            value: "330784"
        }
        ],
        label: "金華市",
        value: "330700"
    }, {
        children: [{
            label: "市轄區",
            value: "330801"
        }, {
            label: "柯城區",
            value: "330802"
        }, {
            label: "衢江區",
            value: "330803"
        }, {
            label: "常山縣",
            value: "330822"
        }, {
            label: "開化縣",
            value: "330824"
        }, {
            label: "龍遊縣",
            value: "330825"
        }, {
            label: "江山市",
            value: "330881"
        }
        ],
        label: "衢州市",
        value: "330800"
    }, {
        children: [{
            label: "市轄區",
            value: "330901"
        }, {
            label: "定海區",
            value: "330902"
        }, {
            label: "普陀區",
            value: "330903"
        }, {
            label: "岱山縣",
            value: "330921"
        }, {
            label: "嵊泗縣",
            value: "330922"
        }
        ],
        label: "舟山市",
        value: "330900"
    }, {
        children: [{
            label: "市轄區",
            value: "331001"
        }, {
            label: "椒江區",
            value: "331002"
        }, {
            label: "黃巖區",
            value: "331003"
        }, {
            label: "路橋區",
            value: "331004"
        }, {
            label: "玉環縣",
            value: "331021"
        }, {
            label: "三門縣",
            value: "331022"
        }, {
            label: "天臺縣",
            value: "331023"
        }, {
            label: "仙居縣",
            value: "331024"
        }, {
            label: "溫嶺市",
            value: "331081"
        }, {
            label: "臨海市",
            value: "331082"
        }
        ],
        label: "臺州市",
        value: "331000"
    }, {
        children: [{
            label: "市轄區",
            value: "331101"
        }, {
            label: "蓮都區",
            value: "331102"
        }, {
            label: "青田縣",
            value: "331121"
        }, {
            label: "縉雲縣",
            value: "331122"
        }, {
            label: "遂昌縣",
            value: "331123"
        }, {
            label: "松陽縣",
            value: "331124"
        }, {
            label: "雲和縣",
            value: "331125"
        }, {
            label: "慶元縣",
            value: "331126"
        }, {
            label: "景寧畬族自治縣",
            value: "331127"
        }, {
            label: "龍泉市",
            value: "331181"
        }
        ],
        label: "麗水市",
        value: "331100"
    }
    ],
    label: "浙江省",
    value: "330000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "340101"
        }, {
            label: "瑤海區",
            value: "340102"
        }, {
            label: "廬陽區",
            value: "340103"
        }, {
            label: "蜀山區",
            value: "340104"
        }, {
            label: "包河區",
            value: "340111"
        }, {
            label: "長豐縣",
            value: "340121"
        }, {
            label: "肥東縣",
            value: "340122"
        }, {
            label: "肥西縣",
            value: "340123"
        }, {
            label: "廬江縣",
            value: "340124"
        }, {
            label: "巢湖市",
            value: "340181"
        }
        ],
        label: "合肥市",
        value: "340100"
    }, {
        children: [{
            label: "市轄區",
            value: "340201"
        }, {
            label: "鏡湖區",
            value: "340202"
        }, {
            label: "弋江區",
            value: "340203"
        }, {
            label: "鳩江區",
            value: "340207"
        }, {
            label: "三山區",
            value: "340208"
        }, {
            label: "蕪湖縣",
            value: "340221"
        }, {
            label: "繁昌縣",
            value: "340222"
        }, {
            label: "南陵縣",
            value: "340223"
        }, {
            label: "無為縣",
            value: "340225"
        }
        ],
        label: "蕪湖市",
        value: "340200"
    }, {
        children: [{
            label: "市轄區",
            value: "340301"
        }, {
            label: "龍子湖區",
            value: "340302"
        }, {
            label: "蚌山區",
            value: "340303"
        }, {
            label: "禹會區",
            value: "340304"
        }, {
            label: "淮上區",
            value: "340311"
        }, {
            label: "懷遠縣",
            value: "340321"
        }, {
            label: "五河縣",
            value: "340322"
        }, {
            label: "固鎮縣",
            value: "340323"
        }
        ],
        label: "蚌埠市",
        value: "340300"
    }, {
        children: [{
            label: "市轄區",
            value: "340401"
        }, {
            label: "大通區",
            value: "340402"
        }, {
            label: "田家庵區",
            value: "340403"
        }, {
            label: "謝家集區",
            value: "340404"
        }, {
            label: "八公山區",
            value: "340405"
        }, {
            label: "潘集區",
            value: "340406"
        }, {
            label: "鳳臺縣",
            value: "340421"
        }, {
            label: "壽縣",
            value: "340422"
        }
        ],
        label: "淮南市",
        value: "340400"
    }, {
        children: [{
            label: "市轄區",
            value: "340501"
        }, {
            label: "花山區",
            value: "340503"
        }, {
            label: "雨山區",
            value: "340504"
        }, {
            label: "博望區",
            value: "340506"
        }, {
            label: "當塗縣",
            value: "340521"
        }, {
            label: "含山縣",
            value: "340522"
        }, {
            label: "和縣",
            value: "340523"
        }
        ],
        label: "馬鞍山市",
        value: "340500"
    }, {
        children: [{
            label: "市轄區",
            value: "340601"
        }, {
            label: "杜集區",
            value: "340602"
        }, {
            label: "相山區",
            value: "340603"
        }, {
            label: "烈山區",
            value: "340604"
        }, {
            label: "濉溪縣",
            value: "340621"
        }
        ],
        label: "淮北市",
        value: "340600"
    }, {
        children: [{
            label: "市轄區",
            value: "340701"
        }, {
            label: "銅官區",
            value: "340705"
        }, {
            label: "義安區",
            value: "340706"
        }, {
            label: "郊區",
            value: "340711"
        }, {
            label: "樅陽縣",
            value: "340722"
        }
        ],
        label: "銅陵市",
        value: "340700"
    }, {
        children: [{
            label: "市轄區",
            value: "340801"
        }, {
            label: "迎江區",
            value: "340802"
        }, {
            label: "大觀區",
            value: "340803"
        }, {
            label: "宜秀區",
            value: "340811"
        }, {
            label: "懷寧縣",
            value: "340822"
        }, {
            label: "潛山縣",
            value: "340824"
        }, {
            label: "太湖縣",
            value: "340825"
        }, {
            label: "宿松縣",
            value: "340826"
        }, {
            label: "望江縣",
            value: "340827"
        }, {
            label: "嶽西縣",
            value: "340828"
        }, {
            label: "桐城市",
            value: "340881"
        }
        ],
        label: "安慶市",
        value: "340800"
    }, {
        children: [{
            label: "市轄區",
            value: "341001"
        }, {
            label: "屯溪區",
            value: "341002"
        }, {
            label: "黃山區",
            value: "341003"
        }, {
            label: "徽州區",
            value: "341004"
        }, {
            label: "歙縣",
            value: "341021"
        }, {
            label: "休寧縣",
            value: "341022"
        }, {
            label: "黟縣",
            value: "341023"
        }, {
            label: "祁門縣",
            value: "341024"
        }
        ],
        label: "黃山市",
        value: "341000"
    }, {
        children: [{
            label: "市轄區",
            value: "341101"
        }, {
            label: "瑯琊區",
            value: "341102"
        }, {
            label: "南譙區",
            value: "341103"
        }, {
            label: "來安縣",
            value: "341122"
        }, {
            label: "全椒縣",
            value: "341124"
        }, {
            label: "定遠縣",
            value: "341125"
        }, {
            label: "鳳陽縣",
            value: "341126"
        }, {
            label: "天長市",
            value: "341181"
        }, {
            label: "明光市",
            value: "341182"
        }
        ],
        label: "滁州市",
        value: "341100"
    }, {
        children: [{
            label: "市轄區",
            value: "341201"
        }, {
            label: "潁州區",
            value: "341202"
        }, {
            label: "潁東區",
            value: "341203"
        }, {
            label: "潁泉區",
            value: "341204"
        }, {
            label: "臨泉縣",
            value: "341221"
        }, {
            label: "太和縣",
            value: "341222"
        }, {
            label: "阜南縣",
            value: "341225"
        }, {
            label: "潁上縣",
            value: "341226"
        }, {
            label: "界首市",
            value: "341282"
        }
        ],
        label: "阜陽市",
        value: "341200"
    }, {
        children: [{
            label: "市轄區",
            value: "341301"
        }, {
            label: "埇橋區",
            value: "341302"
        }, {
            label: "碭山縣",
            value: "341321"
        }, {
            label: "蕭縣",
            value: "341322"
        }, {
            label: "靈璧縣",
            value: "341323"
        }, {
            label: "泗縣",
            value: "341324"
        }
        ],
        label: "宿州市",
        value: "341300"
    }, {
        children: [{
            label: "市轄區",
            value: "341501"
        }, {
            label: "金安區",
            value: "341502"
        }, {
            label: "裕安區",
            value: "341503"
        }, {
            label: "葉集區",
            value: "341504"
        }, {
            label: "霍邱縣",
            value: "341522"
        }, {
            label: "舒城縣",
            value: "341523"
        }, {
            label: "金寨縣",
            value: "341524"
        }, {
            label: "霍山縣",
            value: "341525"
        }
        ],
        label: "六安市",
        value: "341500"
    }, {
        children: [{
            label: "市轄區",
            value: "341601"
        }, {
            label: "譙城區",
            value: "341602"
        }, {
            label: "渦陽縣",
            value: "341621"
        }, {
            label: "蒙城縣",
            value: "341622"
        }, {
            label: "利辛縣",
            value: "341623"
        }
        ],
        label: "亳州市",
        value: "341600"
    }, {
        children: [{
            label: "市轄區",
            value: "341701"
        }, {
            label: "貴池區",
            value: "341702"
        }, {
            label: "東至縣",
            value: "341721"
        }, {
            label: "石臺縣",
            value: "341722"
        }, {
            label: "青陽縣",
            value: "341723"
        }
        ],
        label: "池州市",
        value: "341700"
    }, {
        children: [{
            label: "市轄區",
            value: "341801"
        }, {
            label: "宣州區",
            value: "341802"
        }, {
            label: "郎溪縣",
            value: "341821"
        }, {
            label: "廣德縣",
            value: "341822"
        }, {
            label: "涇縣",
            value: "341823"
        }, {
            label: "績溪縣",
            value: "341824"
        }, {
            label: "旌德縣",
            value: "341825"
        }, {
            label: "寧國市",
            value: "341881"
        }
        ],
        label: "宣城市",
        value: "341800"
    }
    ],
    label: "安徽省",
    value: "340000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "350101"
        }, {
            label: "鼓樓區",
            value: "350102"
        }, {
            label: "臺江區",
            value: "350103"
        }, {
            label: "倉山區",
            value: "350104"
        }, {
            label: "馬尾區",
            value: "350105"
        }, {
            label: "晉安區",
            value: "350111"
        }, {
            label: "閩侯縣",
            value: "350121"
        }, {
            label: "連江縣",
            value: "350122"
        }, {
            label: "羅源縣",
            value: "350123"
        }, {
            label: "閩清縣",
            value: "350124"
        }, {
            label: "永泰縣",
            value: "350125"
        }, {
            label: "平潭縣",
            value: "350128"
        }, {
            label: "福清市",
            value: "350181"
        }, {
            label: "長樂市",
            value: "350182"
        }
        ],
        label: "福州市",
        value: "350100"
    }, {
        children: [{
            label: "市轄區",
            value: "350201"
        }, {
            label: "思明區",
            value: "350203"
        }, {
            label: "海滄區",
            value: "350205"
        }, {
            label: "湖裏區",
            value: "350206"
        }, {
            label: "集美區",
            value: "350211"
        }, {
            label: "同安區",
            value: "350212"
        }, {
            label: "翔安區",
            value: "350213"
        }
        ],
        label: "廈門市",
        value: "350200"
    }, {
        children: [{
            label: "市轄區",
            value: "350301"
        }, {
            label: "城廂區",
            value: "350302"
        }, {
            label: "涵江區",
            value: "350303"
        }, {
            label: "荔城區",
            value: "350304"
        }, {
            label: "秀嶼區",
            value: "350305"
        }, {
            label: "仙遊縣",
            value: "350322"
        }
        ],
        label: "莆田市",
        value: "350300"
    }, {
        children: [{
            label: "市轄區",
            value: "350401"
        }, {
            label: "梅列區",
            value: "350402"
        }, {
            label: "三元區",
            value: "350403"
        }, {
            label: "明溪縣",
            value: "350421"
        }, {
            label: "清流縣",
            value: "350423"
        }, {
            label: "寧化縣",
            value: "350424"
        }, {
            label: "大田縣",
            value: "350425"
        }, {
            label: "尤溪縣",
            value: "350426"
        }, {
            label: "沙縣",
            value: "350427"
        }, {
            label: "將樂縣",
            value: "350428"
        }, {
            label: "泰寧縣",
            value: "350429"
        }, {
            label: "建寧縣",
            value: "350430"
        }, {
            label: "永安市",
            value: "350481"
        }
        ],
        label: "三明市",
        value: "350400"
    }, {
        children: [{
            label: "市轄區",
            value: "350501"
        }, {
            label: "鯉城區",
            value: "350502"
        }, {
            label: "豐澤區",
            value: "350503"
        }, {
            label: "洛江區",
            value: "350504"
        }, {
            label: "泉港區",
            value: "350505"
        }, {
            label: "惠安縣",
            value: "350521"
        }, {
            label: "安溪縣",
            value: "350524"
        }, {
            label: "永春縣",
            value: "350525"
        }, {
            label: "德化縣",
            value: "350526"
        }, {
            label: "金門縣",
            value: "350527"
        }, {
            label: "石獅市",
            value: "350581"
        }, {
            label: "晉江市",
            value: "350582"
        }, {
            label: "南安市",
            value: "350583"
        }
        ],
        label: "泉州市",
        value: "350500"
    }, {
        children: [{
            label: "市轄區",
            value: "350601"
        }, {
            label: "薌城區",
            value: "350602"
        }, {
            label: "龍文區",
            value: "350603"
        }, {
            label: "雲霄縣",
            value: "350622"
        }, {
            label: "漳浦縣",
            value: "350623"
        }, {
            label: "詔安縣",
            value: "350624"
        }, {
            label: "長泰縣",
            value: "350625"
        }, {
            label: "東山縣",
            value: "350626"
        }, {
            label: "南靖縣",
            value: "350627"
        }, {
            label: "平和縣",
            value: "350628"
        }, {
            label: "華安縣",
            value: "350629"
        }, {
            label: "龍海市",
            value: "350681"
        }
        ],
        label: "漳州市",
        value: "350600"
    }, {
        children: [{
            label: "市轄區",
            value: "350701"
        }, {
            label: "延平區",
            value: "350702"
        }, {
            label: "建陽區",
            value: "350703"
        }, {
            label: "順昌縣",
            value: "350721"
        }, {
            label: "浦城縣",
            value: "350722"
        }, {
            label: "光澤縣",
            value: "350723"
        }, {
            label: "松溪縣",
            value: "350724"
        }, {
            label: "政和縣",
            value: "350725"
        }, {
            label: "邵武市",
            value: "350781"
        }, {
            label: "武夷山市",
            value: "350782"
        }, {
            label: "建甌市",
            value: "350783"
        }
        ],
        label: "南平市",
        value: "350700"
    }, {
        children: [{
            label: "市轄區",
            value: "350801"
        }, {
            label: "新羅區",
            value: "350802"
        }, {
            label: "永定區",
            value: "350803"
        }, {
            label: "長汀縣",
            value: "350821"
        }, {
            label: "上杭縣",
            value: "350823"
        }, {
            label: "武平縣",
            value: "350824"
        }, {
            label: "連城縣",
            value: "350825"
        }, {
            label: "漳平市",
            value: "350881"
        }
        ],
        label: "龍巖市",
        value: "350800"
    }, {
        children: [{
            label: "市轄區",
            value: "350901"
        }, {
            label: "蕉城區",
            value: "350902"
        }, {
            label: "霞浦縣",
            value: "350921"
        }, {
            label: "古田縣",
            value: "350922"
        }, {
            label: "屏南縣",
            value: "350923"
        }, {
            label: "壽寧縣",
            value: "350924"
        }, {
            label: "周寧縣",
            value: "350925"
        }, {
            label: "柘榮縣",
            value: "350926"
        }, {
            label: "福安市",
            value: "350981"
        }, {
            label: "福鼎市",
            value: "350982"
        }
        ],
        label: "寧德市",
        value: "350900"
    }
    ],
    label: "福建省",
    value: "350000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "360101"
        }, {
            label: "東湖區",
            value: "360102"
        }, {
            label: "西湖區",
            value: "360103"
        }, {
            label: "青雲譜區",
            value: "360104"
        }, {
            label: "灣裏區",
            value: "360105"
        }, {
            label: "青山湖區",
            value: "360111"
        }, {
            label: "新建區",
            value: "360112"
        }, {
            label: "南昌縣",
            value: "360121"
        }, {
            label: "安義縣",
            value: "360123"
        }, {
            label: "進賢縣",
            value: "360124"
        }
        ],
        label: "南昌市",
        value: "360100"
    }, {
        children: [{
            label: "市轄區",
            value: "360201"
        }, {
            label: "昌江區",
            value: "360202"
        }, {
            label: "珠山區",
            value: "360203"
        }, {
            label: "浮梁縣",
            value: "360222"
        }, {
            label: "樂平市",
            value: "360281"
        }
        ],
        label: "景德鎮市",
        value: "360200"
    }, {
        children: [{
            label: "市轄區",
            value: "360301"
        }, {
            label: "安源區",
            value: "360302"
        }, {
            label: "湘東區",
            value: "360313"
        }, {
            label: "蓮花縣",
            value: "360321"
        }, {
            label: "上栗縣",
            value: "360322"
        }, {
            label: "蘆溪縣",
            value: "360323"
        }
        ],
        label: "萍鄉市",
        value: "360300"
    }, {
        children: [{
            label: "市轄區",
            value: "360401"
        }, {
            label: "濂溪區",
            value: "360402"
        }, {
            label: "潯陽區",
            value: "360403"
        }, {
            label: "九江縣",
            value: "360421"
        }, {
            label: "武寧縣",
            value: "360423"
        }, {
            label: "修水縣",
            value: "360424"
        }, {
            label: "永修縣",
            value: "360425"
        }, {
            label: "德安縣",
            value: "360426"
        }, {
            label: "都昌縣",
            value: "360428"
        }, {
            label: "湖口縣",
            value: "360429"
        }, {
            label: "彭澤縣",
            value: "360430"
        }, {
            label: "瑞昌市",
            value: "360481"
        }, {
            label: "共青城市",
            value: "360482"
        }, {
            label: "廬山市",
            value: "360483"
        }
        ],
        label: "九江市",
        value: "360400"
    }, {
        children: [{
            label: "市轄區",
            value: "360501"
        }, {
            label: "渝水區",
            value: "360502"
        }, {
            label: "分宜縣",
            value: "360521"
        }
        ],
        label: "新余市",
        value: "360500"
    }, {
        children: [{
            label: "市轄區",
            value: "360601"
        }, {
            label: "月湖區",
            value: "360602"
        }, {
            label: "余江縣",
            value: "360622"
        }, {
            label: "貴溪市",
            value: "360681"
        }
        ],
        label: "鷹潭市",
        value: "360600"
    }, {
        children: [{
            label: "市轄區",
            value: "360701"
        }, {
            label: "章貢區",
            value: "360702"
        }, {
            label: "南康區",
            value: "360703"
        }, {
            label: "贛縣",
            value: "360721"
        }, {
            label: "信豐縣",
            value: "360722"
        }, {
            label: "大余縣",
            value: "360723"
        }, {
            label: "上猶縣",
            value: "360724"
        }, {
            label: "崇義縣",
            value: "360725"
        }, {
            label: "安遠縣",
            value: "360726"
        }, {
            label: "龍南縣",
            value: "360727"
        }, {
            label: "定南縣",
            value: "360728"
        }, {
            label: "全南縣",
            value: "360729"
        }, {
            label: "寧都縣",
            value: "360730"
        }, {
            label: "於都縣",
            value: "360731"
        }, {
            label: "興國縣",
            value: "360732"
        }, {
            label: "會昌縣",
            value: "360733"
        }, {
            label: "尋烏縣",
            value: "360734"
        }, {
            label: "石城縣",
            value: "360735"
        }, {
            label: "瑞金市",
            value: "360781"
        }
        ],
        label: "贛州市",
        value: "360700"
    }, {
        children: [{
            label: "市轄區",
            value: "360801"
        }, {
            label: "吉州區",
            value: "360802"
        }, {
            label: "青原區",
            value: "360803"
        }, {
            label: "吉安縣",
            value: "360821"
        }, {
            label: "吉水縣",
            value: "360822"
        }, {
            label: "峽江縣",
            value: "360823"
        }, {
            label: "新幹縣",
            value: "360824"
        }, {
            label: "永豐縣",
            value: "360825"
        }, {
            label: "泰和縣",
            value: "360826"
        }, {
            label: "遂川縣",
            value: "360827"
        }, {
            label: "萬安縣",
            value: "360828"
        }, {
            label: "安福縣",
            value: "360829"
        }, {
            label: "永新縣",
            value: "360830"
        }, {
            label: "井岡山市",
            value: "360881"
        }
        ],
        label: "吉安市",
        value: "360800"
    }, {
        children: [{
            label: "市轄區",
            value: "360901"
        }, {
            label: "袁州區",
            value: "360902"
        }, {
            label: "奉新縣",
            value: "360921"
        }, {
            label: "萬載縣",
            value: "360922"
        }, {
            label: "上高縣",
            value: "360923"
        }, {
            label: "宜豐縣",
            value: "360924"
        }, {
            label: "靖安縣",
            value: "360925"
        }, {
            label: "銅鼓縣",
            value: "360926"
        }, {
            label: "豐城市",
            value: "360981"
        }, {
            label: "樟樹市",
            value: "360982"
        }, {
            label: "高安市",
            value: "360983"
        }
        ],
        label: "宜春市",
        value: "360900"
    }, {
        children: [{
            label: "市轄區",
            value: "361001"
        }, {
            label: "臨川區",
            value: "361002"
        }, {
            label: "南城縣",
            value: "361021"
        }, {
            label: "黎川縣",
            value: "361022"
        }, {
            label: "南豐縣",
            value: "361023"
        }, {
            label: "崇仁縣",
            value: "361024"
        }, {
            label: "樂安縣",
            value: "361025"
        }, {
            label: "宜黃縣",
            value: "361026"
        }, {
            label: "金溪縣",
            value: "361027"
        }, {
            label: "資溪縣",
            value: "361028"
        }, {
            label: "東鄉縣",
            value: "361029"
        }, {
            label: "廣昌縣",
            value: "361030"
        }
        ],
        label: "撫州市",
        value: "361000"
    }, {
        children: [{
            label: "市轄區",
            value: "361101"
        }, {
            label: "信州區",
            value: "361102"
        }, {
            label: "廣豐區",
            value: "361103"
        }, {
            label: "上饒縣",
            value: "361121"
        }, {
            label: "玉山縣",
            value: "361123"
        }, {
            label: "鉛山縣",
            value: "361124"
        }, {
            label: "橫峰縣",
            value: "361125"
        }, {
            label: "弋陽縣",
            value: "361126"
        }, {
            label: "余幹縣",
            value: "361127"
        }, {
            label: "鄱陽縣",
            value: "361128"
        }, {
            label: "萬年縣",
            value: "361129"
        }, {
            label: "婺源縣",
            value: "361130"
        }, {
            label: "德興市",
            value: "361181"
        }
        ],
        label: "上饒市",
        value: "361100"
    }
    ],
    label: "江西省",
    value: "360000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "370101"
        }, {
            label: "歷下區",
            value: "370102"
        }, {
            label: "市中區",
            value: "370103"
        }, {
            label: "槐蔭區",
            value: "370104"
        }, {
            label: "天橋區",
            value: "370105"
        }, {
            label: "歷城區",
            value: "370112"
        }, {
            label: "長清區",
            value: "370113"
        }, {
            label: "平陰縣",
            value: "370124"
        }, {
            label: "濟陽縣",
            value: "370125"
        }, {
            label: "商河縣",
            value: "370126"
        }, {
            label: "章丘市",
            value: "370181"
        }
        ],
        label: "濟南市",
        value: "370100"
    }, {
        children: [{
            label: "市轄區",
            value: "370201"
        }, {
            label: "市南區",
            value: "370202"
        }, {
            label: "市北區",
            value: "370203"
        }, {
            label: "黃島區",
            value: "370211"
        }, {
            label: "嶗山區",
            value: "370212"
        }, {
            label: "李滄區",
            value: "370213"
        }, {
            label: "城陽區",
            value: "370214"
        }, {
            label: "膠州市",
            value: "370281"
        }, {
            label: "即墨市",
            value: "370282"
        }, {
            label: "平度市",
            value: "370283"
        }, {
            label: "萊西市",
            value: "370285"
        }
        ],
        label: "青島市",
        value: "370200"
    }, {
        children: [{
            label: "市轄區",
            value: "370301"
        }, {
            label: "淄川區",
            value: "370302"
        }, {
            label: "張店區",
            value: "370303"
        }, {
            label: "博山區",
            value: "370304"
        }, {
            label: "臨淄區",
            value: "370305"
        }, {
            label: "周村區",
            value: "370306"
        }, {
            label: "桓臺縣",
            value: "370321"
        }, {
            label: "高青縣",
            value: "370322"
        }, {
            label: "沂源縣",
            value: "370323"
        }
        ],
        label: "淄博市",
        value: "370300"
    }, {
        children: [{
            label: "市轄區",
            value: "370401"
        }, {
            label: "市中區",
            value: "370402"
        }, {
            label: "薛城區",
            value: "370403"
        }, {
            label: "嶧城區",
            value: "370404"
        }, {
            label: "臺兒莊區",
            value: "370405"
        }, {
            label: "山亭區",
            value: "370406"
        }, {
            label: "滕州市",
            value: "370481"
        }
        ],
        label: "棗莊市",
        value: "370400"
    }, {
        children: [{
            label: "市轄區",
            value: "370501"
        }, {
            label: "東營區",
            value: "370502"
        }, {
            label: "河口區",
            value: "370503"
        }, {
            label: "墾利區",
            value: "370505"
        }, {
            label: "利津縣",
            value: "370522"
        }, {
            label: "廣饒縣",
            value: "370523"
        }
        ],
        label: "東營市",
        value: "370500"
    }, {
        children: [{
            label: "市轄區",
            value: "370601"
        }, {
            label: "芝罘區",
            value: "370602"
        }, {
            label: "福山區",
            value: "370611"
        }, {
            label: "牟平區",
            value: "370612"
        }, {
            label: "萊山區",
            value: "370613"
        }, {
            label: "長島縣",
            value: "370634"
        }, {
            label: "龍口市",
            value: "370681"
        }, {
            label: "萊陽市",
            value: "370682"
        }, {
            label: "萊州市",
            value: "370683"
        }, {
            label: "蓬萊市",
            value: "370684"
        }, {
            label: "招遠市",
            value: "370685"
        }, {
            label: "棲霞市",
            value: "370686"
        }, {
            label: "海陽市",
            value: "370687"
        }
        ],
        label: "煙臺市",
        value: "370600"
    }, {
        children: [{
            label: "市轄區",
            value: "370701"
        }, {
            label: "濰城區",
            value: "370702"
        }, {
            label: "寒亭區",
            value: "370703"
        }, {
            label: "坊子區",
            value: "370704"
        }, {
            label: "奎文區",
            value: "370705"
        }, {
            label: "臨朐縣",
            value: "370724"
        }, {
            label: "昌樂縣",
            value: "370725"
        }, {
            label: "青州市",
            value: "370781"
        }, {
            label: "諸城市",
            value: "370782"
        }, {
            label: "壽光市",
            value: "370783"
        }, {
            label: "安丘市",
            value: "370784"
        }, {
            label: "高密市",
            value: "370785"
        }, {
            label: "昌邑市",
            value: "370786"
        }
        ],
        label: "濰坊市",
        value: "370700"
    }, {
        children: [{
            label: "市轄區",
            value: "370801"
        }, {
            label: "任城區",
            value: "370811"
        }, {
            label: "兗州區",
            value: "370812"
        }, {
            label: "微山縣",
            value: "370826"
        }, {
            label: "魚臺縣",
            value: "370827"
        }, {
            label: "金鄉縣",
            value: "370828"
        }, {
            label: "嘉祥縣",
            value: "370829"
        }, {
            label: "汶上縣",
            value: "370830"
        }, {
            label: "泗水縣",
            value: "370831"
        }, {
            label: "梁山縣",
            value: "370832"
        }, {
            label: "曲阜市",
            value: "370881"
        }, {
            label: "鄒城市",
            value: "370883"
        }
        ],
        label: "濟寧市",
        value: "370800"
    }, {
        children: [{
            label: "市轄區",
            value: "370901"
        }, {
            label: "泰山區",
            value: "370902"
        }, {
            label: "岱嶽區",
            value: "370911"
        }, {
            label: "寧陽縣",
            value: "370921"
        }, {
            label: "東平縣",
            value: "370923"
        }, {
            label: "新泰市",
            value: "370982"
        }, {
            label: "肥城市",
            value: "370983"
        }
        ],
        label: "泰安市",
        value: "370900"
    }, {
        children: [{
            label: "市轄區",
            value: "371001"
        }, {
            label: "環翠區",
            value: "371002"
        }, {
            label: "文登區",
            value: "371003"
        }, {
            label: "榮成市",
            value: "371082"
        }, {
            label: "乳山市",
            value: "371083"
        }
        ],
        label: "威海市",
        value: "371000"
    }, {
        children: [{
            label: "市轄區",
            value: "371101"
        }, {
            label: "東港區",
            value: "371102"
        }, {
            label: "嵐山區",
            value: "371103"
        }, {
            label: "五蓮縣",
            value: "371121"
        }, {
            label: "莒縣",
            value: "371122"
        }
        ],
        label: "日照市",
        value: "371100"
    }, {
        children: [{
            label: "市轄區",
            value: "371201"
        }, {
            label: "萊城區",
            value: "371202"
        }, {
            label: "鋼城區",
            value: "371203"
        }
        ],
        label: "萊蕪市",
        value: "371200"
    }, {
        children: [{
            label: "市轄區",
            value: "371301"
        }, {
            label: "蘭山區",
            value: "371302"
        }, {
            label: "羅莊區",
            value: "371311"
        }, {
            label: "河東區",
            value: "371312"
        }, {
            label: "沂南縣",
            value: "371321"
        }, {
            label: "郯城縣",
            value: "371322"
        }, {
            label: "沂水縣",
            value: "371323"
        }, {
            label: "蘭陵縣",
            value: "371324"
        }, {
            label: "費縣",
            value: "371325"
        }, {
            label: "平邑縣",
            value: "371326"
        }, {
            label: "莒南縣",
            value: "371327"
        }, {
            label: "蒙陰縣",
            value: "371328"
        }, {
            label: "臨沭縣",
            value: "371329"
        }
        ],
        label: "臨沂市",
        value: "371300"
    }, {
        children: [{
            label: "市轄區",
            value: "371401"
        }, {
            label: "德城區",
            value: "371402"
        }, {
            label: "陵城區",
            value: "371403"
        }, {
            label: "寧津縣",
            value: "371422"
        }, {
            label: "慶雲縣",
            value: "371423"
        }, {
            label: "臨邑縣",
            value: "371424"
        }, {
            label: "齊河縣",
            value: "371425"
        }, {
            label: "平原縣",
            value: "371426"
        }, {
            label: "夏津縣",
            value: "371427"
        }, {
            label: "武城縣",
            value: "371428"
        }, {
            label: "樂陵市",
            value: "371481"
        }, {
            label: "禹城市",
            value: "371482"
        }
        ],
        label: "德州市",
        value: "371400"
    }, {
        children: [{
            label: "市轄區",
            value: "371501"
        }, {
            label: "東昌府區",
            value: "371502"
        }, {
            label: "陽谷縣",
            value: "371521"
        }, {
            label: "莘縣",
            value: "371522"
        }, {
            label: "茌平縣",
            value: "371523"
        }, {
            label: "東阿縣",
            value: "371524"
        }, {
            label: "冠縣",
            value: "371525"
        }, {
            label: "高唐縣",
            value: "371526"
        }, {
            label: "臨清市",
            value: "371581"
        }
        ],
        label: "聊城市",
        value: "371500"
    }, {
        children: [{
            label: "市轄區",
            value: "371601"
        }, {
            label: "濱城區",
            value: "371602"
        }, {
            label: "沾化區",
            value: "371603"
        }, {
            label: "惠民縣",
            value: "371621"
        }, {
            label: "陽信縣",
            value: "371622"
        }, {
            label: "無棣縣",
            value: "371623"
        }, {
            label: "博興縣",
            value: "371625"
        }, {
            label: "鄒平縣",
            value: "371626"
        }
        ],
        label: "濱州市",
        value: "371600"
    }, {
        children: [{
            label: "市轄區",
            value: "371701"
        }, {
            label: "牡丹區",
            value: "371702"
        }, {
            label: "定陶區",
            value: "371703"
        }, {
            label: "曹縣",
            value: "371721"
        }, {
            label: "單縣",
            value: "371722"
        }, {
            label: "成武縣",
            value: "371723"
        }, {
            label: "巨野縣",
            value: "371724"
        }, {
            label: "鄆城縣",
            value: "371725"
        }, {
            label: "鄄城縣",
            value: "371726"
        }, {
            label: "東明縣",
            value: "371728"
        }
        ],
        label: "菏澤市",
        value: "371700"
    }
    ],
    label: "山東省",
    value: "370000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "410101"
        }, {
            label: "中原區",
            value: "410102"
        }, {
            label: "二七區",
            value: "410103"
        }, {
            label: "管城回族區",
            value: "410104"
        }, {
            label: "金水區",
            value: "410105"
        }, {
            label: "上街區",
            value: "410106"
        }, {
            label: "惠濟區",
            value: "410108"
        }, {
            label: "中牟縣",
            value: "410122"
        }, {
            label: "鞏義市",
            value: "410181"
        }, {
            label: "滎陽市",
            value: "410182"
        }, {
            label: "新密市",
            value: "410183"
        }, {
            label: "新鄭市",
            value: "410184"
        }, {
            label: "登封市",
            value: "410185"
        }
        ],
        label: "鄭州市",
        value: "410100"
    }, {
        children: [{
            label: "市轄區",
            value: "410201"
        }, {
            label: "龍亭區",
            value: "410202"
        }, {
            label: "順河回族區",
            value: "410203"
        }, {
            label: "鼓樓區",
            value: "410204"
        }, {
            label: "禹王臺區",
            value: "410205"
        }, {
            label: "金明區",
            value: "410211"
        }, {
            label: "祥符區",
            value: "410212"
        }, {
            label: "杞縣",
            value: "410221"
        }, {
            label: "通許縣",
            value: "410222"
        }, {
            label: "尉氏縣",
            value: "410223"
        }, {
            label: "蘭考縣",
            value: "410225"
        }
        ],
        label: "開封市",
        value: "410200"
    }, {
        children: [{
            label: "市轄區",
            value: "410301"
        }, {
            label: "老城區",
            value: "410302"
        }, {
            label: "西工區",
            value: "410303"
        }, {
            label: "瀍河回族區",
            value: "410304"
        }, {
            label: "澗西區",
            value: "410305"
        }, {
            label: "吉利區",
            value: "410306"
        }, {
            label: "洛龍區",
            value: "410311"
        }, {
            label: "孟津縣",
            value: "410322"
        }, {
            label: "新安縣",
            value: "410323"
        }, {
            label: "欒川縣",
            value: "410324"
        }, {
            label: "嵩縣",
            value: "410325"
        }, {
            label: "汝陽縣",
            value: "410326"
        }, {
            label: "宜陽縣",
            value: "410327"
        }, {
            label: "洛寧縣",
            value: "410328"
        }, {
            label: "伊川縣",
            value: "410329"
        }, {
            label: "偃師市",
            value: "410381"
        }
        ],
        label: "洛陽市",
        value: "410300"
    }, {
        children: [{
            label: "市轄區",
            value: "410401"
        }, {
            label: "新華區",
            value: "410402"
        }, {
            label: "衛東區",
            value: "410403"
        }, {
            label: "石龍區",
            value: "410404"
        }, {
            label: "湛河區",
            value: "410411"
        }, {
            label: "寶豐縣",
            value: "410421"
        }, {
            label: "葉縣",
            value: "410422"
        }, {
            label: "魯山縣",
            value: "410423"
        }, {
            label: "郟縣",
            value: "410425"
        }, {
            label: "舞鋼市",
            value: "410481"
        }, {
            label: "汝州市",
            value: "410482"
        }
        ],
        label: "平頂山市",
        value: "410400"
    }, {
        children: [{
            label: "市轄區",
            value: "410501"
        }, {
            label: "文峰區",
            value: "410502"
        }, {
            label: "北關區",
            value: "410503"
        }, {
            label: "殷都區",
            value: "410505"
        }, {
            label: "龍安區",
            value: "410506"
        }, {
            label: "安陽縣",
            value: "410522"
        }, {
            label: "湯陰縣",
            value: "410523"
        }, {
            label: "滑縣",
            value: "410526"
        }, {
            label: "內黃縣",
            value: "410527"
        }, {
            label: "林州市",
            value: "410581"
        }
        ],
        label: "安陽市",
        value: "410500"
    }, {
        children: [{
            label: "市轄區",
            value: "410601"
        }, {
            label: "鶴山區",
            value: "410602"
        }, {
            label: "山城區",
            value: "410603"
        }, {
            label: "淇濱區",
            value: "410611"
        }, {
            label: "浚縣",
            value: "410621"
        }, {
            label: "淇縣",
            value: "410622"
        }
        ],
        label: "鶴壁市",
        value: "410600"
    }, {
        children: [{
            label: "市轄區",
            value: "410701"
        }, {
            label: "紅旗區",
            value: "410702"
        }, {
            label: "衛濱區",
            value: "410703"
        }, {
            label: "鳳泉區",
            value: "410704"
        }, {
            label: "牧野區",
            value: "410711"
        }, {
            label: "新鄉縣",
            value: "410721"
        }, {
            label: "獲嘉縣",
            value: "410724"
        }, {
            label: "原陽縣",
            value: "410725"
        }, {
            label: "延津縣",
            value: "410726"
        }, {
            label: "封丘縣",
            value: "410727"
        }, {
            label: "長垣縣",
            value: "410728"
        }, {
            label: "衛輝市",
            value: "410781"
        }, {
            label: "輝縣市",
            value: "410782"
        }
        ],
        label: "新鄉市",
        value: "410700"
    }, {
        children: [{
            label: "市轄區",
            value: "410801"
        }, {
            label: "解放區",
            value: "410802"
        }, {
            label: "中站區",
            value: "410803"
        }, {
            label: "馬村區",
            value: "410804"
        }, {
            label: "山陽區",
            value: "410811"
        }, {
            label: "修武縣",
            value: "410821"
        }, {
            label: "博愛縣",
            value: "410822"
        }, {
            label: "武陟縣",
            value: "410823"
        }, {
            label: "溫縣",
            value: "410825"
        }, {
            label: "沁陽市",
            value: "410882"
        }, {
            label: "孟州市",
            value: "410883"
        }
        ],
        label: "焦作市",
        value: "410800"
    }, {
        children: [{
            label: "市轄區",
            value: "410901"
        }, {
            label: "華龍區",
            value: "410902"
        }, {
            label: "清豐縣",
            value: "410922"
        }, {
            label: "南樂縣",
            value: "410923"
        }, {
            label: "範縣",
            value: "410926"
        }, {
            label: "臺前縣",
            value: "410927"
        }, {
            label: "濮陽縣",
            value: "410928"
        }
        ],
        label: "濮陽市",
        value: "410900"
    }, {
        children: [{
            label: "市轄區",
            value: "411001"
        }, {
            label: "魏都區",
            value: "411002"
        }, {
            label: "許昌縣",
            value: "411023"
        }, {
            label: "鄢陵縣",
            value: "411024"
        }, {
            label: "襄城縣",
            value: "411025"
        }, {
            label: "禹州市",
            value: "411081"
        }, {
            label: "長葛市",
            value: "411082"
        }
        ],
        label: "許昌市",
        value: "411000"
    }, {
        children: [{
            label: "市轄區",
            value: "411101"
        }, {
            label: "源匯區",
            value: "411102"
        }, {
            label: "郾城區",
            value: "411103"
        }, {
            label: "召陵區",
            value: "411104"
        }, {
            label: "舞陽縣",
            value: "411121"
        }, {
            label: "臨潁縣",
            value: "411122"
        }
        ],
        label: "漯河市",
        value: "411100"
    }, {
        children: [{
            label: "市轄區",
            value: "411201"
        }, {
            label: "湖濱區",
            value: "411202"
        }, {
            label: "陜州區",
            value: "411203"
        }, {
            label: "澠池縣",
            value: "411221"
        }, {
            label: "盧氏縣",
            value: "411224"
        }, {
            label: "義馬市",
            value: "411281"
        }, {
            label: "靈寶市",
            value: "411282"
        }
        ],
        label: "三門峽市",
        value: "411200"
    }, {
        children: [{
            label: "市轄區",
            value: "411301"
        }, {
            label: "宛城區",
            value: "411302"
        }, {
            label: "臥龍區",
            value: "411303"
        }, {
            label: "南召縣",
            value: "411321"
        }, {
            label: "方城縣",
            value: "411322"
        }, {
            label: "西峽縣",
            value: "411323"
        }, {
            label: "鎮平縣",
            value: "411324"
        }, {
            label: "內鄉縣",
            value: "411325"
        }, {
            label: "淅川縣",
            value: "411326"
        }, {
            label: "社旗縣",
            value: "411327"
        }, {
            label: "唐河縣",
            value: "411328"
        }, {
            label: "新野縣",
            value: "411329"
        }, {
            label: "桐柏縣",
            value: "411330"
        }, {
            label: "鄧州市",
            value: "411381"
        }
        ],
        label: "南陽市",
        value: "411300"
    }, {
        children: [{
            label: "市轄區",
            value: "411401"
        }, {
            label: "梁園區",
            value: "411402"
        }, {
            label: "睢陽區",
            value: "411403"
        }, {
            label: "民權縣",
            value: "411421"
        }, {
            label: "睢縣",
            value: "411422"
        }, {
            label: "寧陵縣",
            value: "411423"
        }, {
            label: "柘城縣",
            value: "411424"
        }, {
            label: "虞城縣",
            value: "411425"
        }, {
            label: "夏邑縣",
            value: "411426"
        }, {
            label: "永城市",
            value: "411481"
        }
        ],
        label: "商丘市",
        value: "411400"
    }, {
        children: [{
            label: "市轄區",
            value: "411501"
        }, {
            label: "浉河區",
            value: "411502"
        }, {
            label: "平橋區",
            value: "411503"
        }, {
            label: "羅山縣",
            value: "411521"
        }, {
            label: "光山縣",
            value: "411522"
        }, {
            label: "新縣",
            value: "411523"
        }, {
            label: "商城縣",
            value: "411524"
        }, {
            label: "固始縣",
            value: "411525"
        }, {
            label: "潢川縣",
            value: "411526"
        }, {
            label: "淮濱縣",
            value: "411527"
        }, {
            label: "息縣",
            value: "411528"
        }
        ],
        label: "信陽市",
        value: "411500"
    }, {
        children: [{
            label: "市轄區",
            value: "411601"
        }, {
            label: "川匯區",
            value: "411602"
        }, {
            label: "扶溝縣",
            value: "411621"
        }, {
            label: "西華縣",
            value: "411622"
        }, {
            label: "商水縣",
            value: "411623"
        }, {
            label: "沈丘縣",
            value: "411624"
        }, {
            label: "鄲城縣",
            value: "411625"
        }, {
            label: "淮陽縣",
            value: "411626"
        }, {
            label: "太康縣",
            value: "411627"
        }, {
            label: "鹿邑縣",
            value: "411628"
        }, {
            label: "項城市",
            value: "411681"
        }
        ],
        label: "周口市",
        value: "411600"
    }, {
        children: [{
            label: "市轄區",
            value: "411701"
        }, {
            label: "驛城區",
            value: "411702"
        }, {
            label: "西平縣",
            value: "411721"
        }, {
            label: "上蔡縣",
            value: "411722"
        }, {
            label: "平輿縣",
            value: "411723"
        }, {
            label: "正陽縣",
            value: "411724"
        }, {
            label: "確山縣",
            value: "411725"
        }, {
            label: "泌陽縣",
            value: "411726"
        }, {
            label: "汝南縣",
            value: "411727"
        }, {
            label: "遂平縣",
            value: "411728"
        }, {
            label: "新蔡縣",
            value: "411729"
        }
        ],
        label: "駐馬店市",
        value: "411700"
    }, {
        children: [{
            label: "濟源市",
            value: "419001"
        }
        ],
        label: "省直轄縣級行政區劃",
        value: "419000"
    }
    ],
    label: "河南省",
    value: "410000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "420101"
        }, {
            label: "江岸區",
            value: "420102"
        }, {
            label: "江漢區",
            value: "420103"
        }, {
            label: "硚口區",
            value: "420104"
        }, {
            label: "漢陽區",
            value: "420105"
        }, {
            label: "武昌區",
            value: "420106"
        }, {
            label: "青山區",
            value: "420107"
        }, {
            label: "洪山區",
            value: "420111"
        }, {
            label: "東西湖區",
            value: "420112"
        }, {
            label: "漢南區",
            value: "420113"
        }, {
            label: "蔡甸區",
            value: "420114"
        }, {
            label: "江夏區",
            value: "420115"
        }, {
            label: "黃陂區",
            value: "420116"
        }, {
            label: "新洲區",
            value: "420117"
        }
        ],
        label: "武漢市",
        value: "420100"
    }, {
        children: [{
            label: "市轄區",
            value: "420201"
        }, {
            label: "黃石港區",
            value: "420202"
        }, {
            label: "西塞山區",
            value: "420203"
        }, {
            label: "下陸區",
            value: "420204"
        }, {
            label: "鐵山區",
            value: "420205"
        }, {
            label: "陽新縣",
            value: "420222"
        }, {
            label: "大冶市",
            value: "420281"
        }
        ],
        label: "黃石市",
        value: "420200"
    }, {
        children: [{
            label: "市轄區",
            value: "420301"
        }, {
            label: "茅箭區",
            value: "420302"
        }, {
            label: "張灣區",
            value: "420303"
        }, {
            label: "鄖陽區",
            value: "420304"
        }, {
            label: "鄖西縣",
            value: "420322"
        }, {
            label: "竹山縣",
            value: "420323"
        }, {
            label: "竹溪縣",
            value: "420324"
        }, {
            label: "房縣",
            value: "420325"
        }, {
            label: "丹江口市",
            value: "420381"
        }
        ],
        label: "十堰市",
        value: "420300"
    }, {
        children: [{
            label: "市轄區",
            value: "420501"
        }, {
            label: "西陵區",
            value: "420502"
        }, {
            label: "伍家崗區",
            value: "420503"
        }, {
            label: "點軍區",
            value: "420504"
        }, {
            label: "猇亭區",
            value: "420505"
        }, {
            label: "夷陵區",
            value: "420506"
        }, {
            label: "遠安縣",
            value: "420525"
        }, {
            label: "興山縣",
            value: "420526"
        }, {
            label: "秭歸縣",
            value: "420527"
        }, {
            label: "長陽土家族自治縣",
            value: "420528"
        }, {
            label: "五峰土家族自治縣",
            value: "420529"
        }, {
            label: "宜都市",
            value: "420581"
        }, {
            label: "當陽市",
            value: "420582"
        }, {
            label: "枝江市",
            value: "420583"
        }
        ],
        label: "宜昌市",
        value: "420500"
    }, {
        children: [{
            label: "市轄區",
            value: "420601"
        }, {
            label: "襄城區",
            value: "420602"
        }, {
            label: "樊城區",
            value: "420606"
        }, {
            label: "襄州區",
            value: "420607"
        }, {
            label: "南漳縣",
            value: "420624"
        }, {
            label: "谷城縣",
            value: "420625"
        }, {
            label: "保康縣",
            value: "420626"
        }, {
            label: "老河口市",
            value: "420682"
        }, {
            label: "棗陽市",
            value: "420683"
        }, {
            label: "宜城市",
            value: "420684"
        }
        ],
        label: "襄陽市",
        value: "420600"
    }, {
        children: [{
            label: "市轄區",
            value: "420701"
        }, {
            label: "梁子湖區",
            value: "420702"
        }, {
            label: "華容區",
            value: "420703"
        }, {
            label: "鄂城區",
            value: "420704"
        }
        ],
        label: "鄂州市",
        value: "420700"
    }, {
        children: [{
            label: "市轄區",
            value: "420801"
        }, {
            label: "東寶區",
            value: "420802"
        }, {
            label: "掇刀區",
            value: "420804"
        }, {
            label: "京山縣",
            value: "420821"
        }, {
            label: "沙洋縣",
            value: "420822"
        }, {
            label: "鐘祥市",
            value: "420881"
        }
        ],
        label: "荊門市",
        value: "420800"
    }, {
        children: [{
            label: "市轄區",
            value: "420901"
        }, {
            label: "孝南區",
            value: "420902"
        }, {
            label: "孝昌縣",
            value: "420921"
        }, {
            label: "大悟縣",
            value: "420922"
        }, {
            label: "雲夢縣",
            value: "420923"
        }, {
            label: "應城市",
            value: "420981"
        }, {
            label: "安陸市",
            value: "420982"
        }, {
            label: "漢川市",
            value: "420984"
        }
        ],
        label: "孝感市",
        value: "420900"
    }, {
        children: [{
            label: "市轄區",
            value: "421001"
        }, {
            label: "沙市區",
            value: "421002"
        }, {
            label: "荊州區",
            value: "421003"
        }, {
            label: "公安縣",
            value: "421022"
        }, {
            label: "監利縣",
            value: "421023"
        }, {
            label: "江陵縣",
            value: "421024"
        }, {
            label: "石首市",
            value: "421081"
        }, {
            label: "洪湖市",
            value: "421083"
        }, {
            label: "松滋市",
            value: "421087"
        }
        ],
        label: "荊州市",
        value: "421000"
    }, {
        children: [{
            label: "市轄區",
            value: "421101"
        }, {
            label: "黃州區",
            value: "421102"
        }, {
            label: "團風縣",
            value: "421121"
        }, {
            label: "紅安縣",
            value: "421122"
        }, {
            label: "羅田縣",
            value: "421123"
        }, {
            label: "英山縣",
            value: "421124"
        }, {
            label: "浠水縣",
            value: "421125"
        }, {
            label: "蘄春縣",
            value: "421126"
        }, {
            label: "黃梅縣",
            value: "421127"
        }, {
            label: "麻城市",
            value: "421181"
        }, {
            label: "武穴市",
            value: "421182"
        }
        ],
        label: "黃岡市",
        value: "421100"
    }, {
        children: [{
            label: "市轄區",
            value: "421201"
        }, {
            label: "鹹安區",
            value: "421202"
        }, {
            label: "嘉魚縣",
            value: "421221"
        }, {
            label: "通城縣",
            value: "421222"
        }, {
            label: "崇陽縣",
            value: "421223"
        }, {
            label: "通山縣",
            value: "421224"
        }, {
            label: "赤壁市",
            value: "421281"
        }
        ],
        label: "鹹寧市",
        value: "421200"
    }, {
        children: [{
            label: "市轄區",
            value: "421301"
        }, {
            label: "曾都區",
            value: "421303"
        }, {
            label: "隨縣",
            value: "421321"
        }, {
            label: "廣水市",
            value: "421381"
        }
        ],
        label: "隨州市",
        value: "421300"
    }, {
        children: [{
            label: "恩施市",
            value: "422801"
        }, {
            label: "利川市",
            value: "422802"
        }, {
            label: "建始縣",
            value: "422822"
        }, {
            label: "巴東縣",
            value: "422823"
        }, {
            label: "宣恩縣",
            value: "422825"
        }, {
            label: "鹹豐縣",
            value: "422826"
        }, {
            label: "來鳳縣",
            value: "422827"
        }, {
            label: "鶴峰縣",
            value: "422828"
        }
        ],
        label: "恩施土家族苗族自治州",
        value: "422800"
    }, {
        children: [{
            label: "仙桃市",
            value: "429004"
        }, {
            label: "潛江市",
            value: "429005"
        }, {
            label: "天門市",
            value: "429006"
        }, {
            label: "神農架林區",
            value: "429021"
        }
        ],
        label: "省直轄縣級行政區劃",
        value: "429000"
    }
    ],
    label: "湖北省",
    value: "420000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "430101"
        }, {
            label: "芙蓉區",
            value: "430102"
        }, {
            label: "天心區",
            value: "430103"
        }, {
            label: "嶽麓區",
            value: "430104"
        }, {
            label: "開福區",
            value: "430105"
        }, {
            label: "雨花區",
            value: "430111"
        }, {
            label: "望城區",
            value: "430112"
        }, {
            label: "長沙縣",
            value: "430121"
        }, {
            label: "寧鄉縣",
            value: "430124"
        }, {
            label: "瀏陽市",
            value: "430181"
        }
        ],
        label: "長沙市",
        value: "430100"
    }, {
        children: [{
            label: "市轄區",
            value: "430201"
        }, {
            label: "荷塘區",
            value: "430202"
        }, {
            label: "蘆淞區",
            value: "430203"
        }, {
            label: "石峰區",
            value: "430204"
        }, {
            label: "天元區",
            value: "430211"
        }, {
            label: "株洲縣",
            value: "430221"
        }, {
            label: "攸縣",
            value: "430223"
        }, {
            label: "茶陵縣",
            value: "430224"
        }, {
            label: "炎陵縣",
            value: "430225"
        }, {
            label: "醴陵市",
            value: "430281"
        }
        ],
        label: "株洲市",
        value: "430200"
    }, {
        children: [{
            label: "市轄區",
            value: "430301"
        }, {
            label: "雨湖區",
            value: "430302"
        }, {
            label: "嶽塘區",
            value: "430304"
        }, {
            label: "湘潭縣",
            value: "430321"
        }, {
            label: "湘鄉市",
            value: "430381"
        }, {
            label: "韶山市",
            value: "430382"
        }
        ],
        label: "湘潭市",
        value: "430300"
    }, {
        children: [{
            label: "市轄區",
            value: "430401"
        }, {
            label: "珠暉區",
            value: "430405"
        }, {
            label: "雁峰區",
            value: "430406"
        }, {
            label: "石鼓區",
            value: "430407"
        }, {
            label: "蒸湘區",
            value: "430408"
        }, {
            label: "南嶽區",
            value: "430412"
        }, {
            label: "衡陽縣",
            value: "430421"
        }, {
            label: "衡南縣",
            value: "430422"
        }, {
            label: "衡山縣",
            value: "430423"
        }, {
            label: "衡東縣",
            value: "430424"
        }, {
            label: "祁東縣",
            value: "430426"
        }, {
            label: "耒陽市",
            value: "430481"
        }, {
            label: "常寧市",
            value: "430482"
        }
        ],
        label: "衡陽市",
        value: "430400"
    }, {
        children: [{
            label: "市轄區",
            value: "430501"
        }, {
            label: "雙清區",
            value: "430502"
        }, {
            label: "大祥區",
            value: "430503"
        }, {
            label: "北塔區",
            value: "430511"
        }, {
            label: "邵東縣",
            value: "430521"
        }, {
            label: "新邵縣",
            value: "430522"
        }, {
            label: "邵陽縣",
            value: "430523"
        }, {
            label: "隆回縣",
            value: "430524"
        }, {
            label: "洞口縣",
            value: "430525"
        }, {
            label: "綏寧縣",
            value: "430527"
        }, {
            label: "新寧縣",
            value: "430528"
        }, {
            label: "城步苗族自治縣",
            value: "430529"
        }, {
            label: "武岡市",
            value: "430581"
        }
        ],
        label: "邵陽市",
        value: "430500"
    }, {
        children: [{
            label: "市轄區",
            value: "430601"
        }, {
            label: "嶽陽樓區",
            value: "430602"
        }, {
            label: "雲溪區",
            value: "430603"
        }, {
            label: "君山區",
            value: "430611"
        }, {
            label: "嶽陽縣",
            value: "430621"
        }, {
            label: "華容縣",
            value: "430623"
        }, {
            label: "湘陰縣",
            value: "430624"
        }, {
            label: "平江縣",
            value: "430626"
        }, {
            label: "汨羅市",
            value: "430681"
        }, {
            label: "臨湘市",
            value: "430682"
        }
        ],
        label: "嶽陽市",
        value: "430600"
    }, {
        children: [{
            label: "市轄區",
            value: "430701"
        }, {
            label: "武陵區",
            value: "430702"
        }, {
            label: "鼎城區",
            value: "430703"
        }, {
            label: "安鄉縣",
            value: "430721"
        }, {
            label: "漢壽縣",
            value: "430722"
        }, {
            label: "澧縣",
            value: "430723"
        }, {
            label: "臨澧縣",
            value: "430724"
        }, {
            label: "桃源縣",
            value: "430725"
        }, {
            label: "石門縣",
            value: "430726"
        }, {
            label: "津市市",
            value: "430781"
        }
        ],
        label: "常德市",
        value: "430700"
    }, {
        children: [{
            label: "市轄區",
            value: "430801"
        }, {
            label: "永定區",
            value: "430802"
        }, {
            label: "武陵源區",
            value: "430811"
        }, {
            label: "慈利縣",
            value: "430821"
        }, {
            label: "桑植縣",
            value: "430822"
        }
        ],
        label: "張家界市",
        value: "430800"
    }, {
        children: [{
            label: "市轄區",
            value: "430901"
        }, {
            label: "資陽區",
            value: "430902"
        }, {
            label: "赫山區",
            value: "430903"
        }, {
            label: "南縣",
            value: "430921"
        }, {
            label: "桃江縣",
            value: "430922"
        }, {
            label: "安化縣",
            value: "430923"
        }, {
            label: "沅江市",
            value: "430981"
        }
        ],
        label: "益陽市",
        value: "430900"
    }, {
        children: [{
            label: "市轄區",
            value: "431001"
        }, {
            label: "北湖區",
            value: "431002"
        }, {
            label: "蘇仙區",
            value: "431003"
        }, {
            label: "桂陽縣",
            value: "431021"
        }, {
            label: "宜章縣",
            value: "431022"
        }, {
            label: "永興縣",
            value: "431023"
        }, {
            label: "嘉禾縣",
            value: "431024"
        }, {
            label: "臨武縣",
            value: "431025"
        }, {
            label: "汝城縣",
            value: "431026"
        }, {
            label: "桂東縣",
            value: "431027"
        }, {
            label: "安仁縣",
            value: "431028"
        }, {
            label: "資興市",
            value: "431081"
        }
        ],
        label: "郴州市",
        value: "431000"
    }, {
        children: [{
            label: "市轄區",
            value: "431101"
        }, {
            label: "零陵區",
            value: "431102"
        }, {
            label: "冷水灘區",
            value: "431103"
        }, {
            label: "祁陽縣",
            value: "431121"
        }, {
            label: "東安縣",
            value: "431122"
        }, {
            label: "雙牌縣",
            value: "431123"
        }, {
            label: "道縣",
            value: "431124"
        }, {
            label: "江永縣",
            value: "431125"
        }, {
            label: "寧遠縣",
            value: "431126"
        }, {
            label: "藍山縣",
            value: "431127"
        }, {
            label: "新田縣",
            value: "431128"
        }, {
            label: "江華瑤族自治縣",
            value: "431129"
        }
        ],
        label: "永州市",
        value: "431100"
    }, {
        children: [{
            label: "市轄區",
            value: "431201"
        }, {
            label: "鶴城區",
            value: "431202"
        }, {
            label: "中方縣",
            value: "431221"
        }, {
            label: "沅陵縣",
            value: "431222"
        }, {
            label: "辰溪縣",
            value: "431223"
        }, {
            label: "漵浦縣",
            value: "431224"
        }, {
            label: "會同縣",
            value: "431225"
        }, {
            label: "麻陽苗族自治縣",
            value: "431226"
        }, {
            label: "新晃侗族自治縣",
            value: "431227"
        }, {
            label: "芷江侗族自治縣",
            value: "431228"
        }, {
            label: "靖州苗族侗族自治縣",
            value: "431229"
        }, {
            label: "通道侗族自治縣",
            value: "431230"
        }, {
            label: "洪江市",
            value: "431281"
        }
        ],
        label: "懷化市",
        value: "431200"
    }, {
        children: [{
            label: "市轄區",
            value: "431301"
        }, {
            label: "婁星區",
            value: "431302"
        }, {
            label: "雙峰縣",
            value: "431321"
        }, {
            label: "新化縣",
            value: "431322"
        }, {
            label: "冷水江市",
            value: "431381"
        }, {
            label: "漣源市",
            value: "431382"
        }
        ],
        label: "婁底市",
        value: "431300"
    }, {
        children: [{
            label: "吉首市",
            value: "433101"
        }, {
            label: "瀘溪縣",
            value: "433122"
        }, {
            label: "鳳凰縣",
            value: "433123"
        }, {
            label: "花垣縣",
            value: "433124"
        }, {
            label: "保靖縣",
            value: "433125"
        }, {
            label: "古丈縣",
            value: "433126"
        }, {
            label: "永順縣",
            value: "433127"
        }, {
            label: "龍山縣",
            value: "433130"
        }
        ],
        label: "湘西土家族苗族自治州",
        value: "433100"
    }
    ],
    label: "湖南省",
    value: "430000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "440101"
        }, {
            label: "荔灣區",
            value: "440103"
        }, {
            label: "越秀區",
            value: "440104"
        }, {
            label: "海珠區",
            value: "440105"
        }, {
            label: "天河區",
            value: "440106"
        }, {
            label: "白雲區",
            value: "440111"
        }, {
            label: "黃埔區",
            value: "440112"
        }, {
            label: "番禺區",
            value: "440113"
        }, {
            label: "花都區",
            value: "440114"
        }, {
            label: "南沙區",
            value: "440115"
        }, {
            label: "從化區",
            value: "440117"
        }, {
            label: "增城區",
            value: "440118"
        }
        ],
        label: "廣州市",
        value: "440100"
    }, {
        children: [{
            label: "市轄區",
            value: "440201"
        }, {
            label: "武江區",
            value: "440203"
        }, {
            label: "湞江區",
            value: "440204"
        }, {
            label: "曲江區",
            value: "440205"
        }, {
            label: "始興縣",
            value: "440222"
        }, {
            label: "仁化縣",
            value: "440224"
        }, {
            label: "翁源縣",
            value: "440229"
        }, {
            label: "乳源瑤族自治縣",
            value: "440232"
        }, {
            label: "新豐縣",
            value: "440233"
        }, {
            label: "樂昌市",
            value: "440281"
        }, {
            label: "南雄市",
            value: "440282"
        }
        ],
        label: "韶關市",
        value: "440200"
    }, {
        children: [{
            label: "市轄區",
            value: "440301"
        }, {
            label: "羅湖區",
            value: "440303"
        }, {
            label: "福田區",
            value: "440304"
        }, {
            label: "南山區",
            value: "440305"
        }, {
            label: "寶安區",
            value: "440306"
        }, {
            label: "龍崗區",
            value: "440307"
        }, {
            label: "鹽田區",
            value: "440308"
        }
        ],
        label: "深圳市",
        value: "440300"
    }, {
        children: [{
            label: "市轄區",
            value: "440401"
        }, {
            label: "香洲區",
            value: "440402"
        }, {
            label: "鬥門區",
            value: "440403"
        }, {
            label: "金灣區",
            value: "440404"
        }
        ],
        label: "珠海市",
        value: "440400"
    }, {
        children: [{
            label: "市轄區",
            value: "440501"
        }, {
            label: "龍湖區",
            value: "440507"
        }, {
            label: "金平區",
            value: "440511"
        }, {
            label: "濠江區",
            value: "440512"
        }, {
            label: "潮陽區",
            value: "440513"
        }, {
            label: "潮南區",
            value: "440514"
        }, {
            label: "澄海區",
            value: "440515"
        }, {
            label: "南澳縣",
            value: "440523"
        }
        ],
        label: "汕頭市",
        value: "440500"
    }, {
        children: [{
            label: "市轄區",
            value: "440601"
        }, {
            label: "禪城區",
            value: "440604"
        }, {
            label: "南海區",
            value: "440605"
        }, {
            label: "順德區",
            value: "440606"
        }, {
            label: "三水區",
            value: "440607"
        }, {
            label: "高明區",
            value: "440608"
        }
        ],
        label: "佛山市",
        value: "440600"
    }, {
        children: [{
            label: "市轄區",
            value: "440701"
        }, {
            label: "蓬江區",
            value: "440703"
        }, {
            label: "江海區",
            value: "440704"
        }, {
            label: "新會區",
            value: "440705"
        }, {
            label: "臺山市",
            value: "440781"
        }, {
            label: "開平市",
            value: "440783"
        }, {
            label: "鶴山市",
            value: "440784"
        }, {
            label: "恩平市",
            value: "440785"
        }
        ],
        label: "江門市",
        value: "440700"
    }, {
        children: [{
            label: "市轄區",
            value: "440801"
        }, {
            label: "赤坎區",
            value: "440802"
        }, {
            label: "霞山區",
            value: "440803"
        }, {
            label: "坡頭區",
            value: "440804"
        }, {
            label: "麻章區",
            value: "440811"
        }, {
            label: "遂溪縣",
            value: "440823"
        }, {
            label: "徐聞縣",
            value: "440825"
        }, {
            label: "廉江市",
            value: "440881"
        }, {
            label: "雷州市",
            value: "440882"
        }, {
            label: "吳川市",
            value: "440883"
        }
        ],
        label: "湛江市",
        value: "440800"
    }, {
        children: [{
            label: "市轄區",
            value: "440901"
        }, {
            label: "茂南區",
            value: "440902"
        }, {
            label: "電白區",
            value: "440904"
        }, {
            label: "高州市",
            value: "440981"
        }, {
            label: "化州市",
            value: "440982"
        }, {
            label: "信宜市",
            value: "440983"
        }
        ],
        label: "茂名市",
        value: "440900"
    }, {
        children: [{
            label: "市轄區",
            value: "441201"
        }, {
            label: "端州區",
            value: "441202"
        }, {
            label: "鼎湖區",
            value: "441203"
        }, {
            label: "高要區",
            value: "441204"
        }, {
            label: "廣寧縣",
            value: "441223"
        }, {
            label: "懷集縣",
            value: "441224"
        }, {
            label: "封開縣",
            value: "441225"
        }, {
            label: "德慶縣",
            value: "441226"
        }, {
            label: "四會市",
            value: "441284"
        }
        ],
        label: "肇慶市",
        value: "441200"
    }, {
        children: [{
            label: "市轄區",
            value: "441301"
        }, {
            label: "惠城區",
            value: "441302"
        }, {
            label: "惠陽區",
            value: "441303"
        }, {
            label: "博羅縣",
            value: "441322"
        }, {
            label: "惠東縣",
            value: "441323"
        }, {
            label: "龍門縣",
            value: "441324"
        }
        ],
        label: "惠州市",
        value: "441300"
    }, {
        children: [{
            label: "市轄區",
            value: "441401"
        }, {
            label: "梅江區",
            value: "441402"
        }, {
            label: "梅縣區",
            value: "441403"
        }, {
            label: "大埔縣",
            value: "441422"
        }, {
            label: "豐順縣",
            value: "441423"
        }, {
            label: "五華縣",
            value: "441424"
        }, {
            label: "平遠縣",
            value: "441426"
        }, {
            label: "蕉嶺縣",
            value: "441427"
        }, {
            label: "興寧市",
            value: "441481"
        }
        ],
        label: "梅州市",
        value: "441400"
    }, {
        children: [{
            label: "市轄區",
            value: "441501"
        }, {
            label: "城區",
            value: "441502"
        }, {
            label: "海豐縣",
            value: "441521"
        }, {
            label: "陸河縣",
            value: "441523"
        }, {
            label: "陸豐市",
            value: "441581"
        }
        ],
        label: "汕尾市",
        value: "441500"
    }, {
        children: [{
            label: "市轄區",
            value: "441601"
        }, {
            label: "源城區",
            value: "441602"
        }, {
            label: "紫金縣",
            value: "441621"
        }, {
            label: "龍川縣",
            value: "441622"
        }, {
            label: "連平縣",
            value: "441623"
        }, {
            label: "和平縣",
            value: "441624"
        }, {
            label: "東源縣",
            value: "441625"
        }
        ],
        label: "河源市",
        value: "441600"
    }, {
        children: [{
            label: "市轄區",
            value: "441701"
        }, {
            label: "江城區",
            value: "441702"
        }, {
            label: "陽東區",
            value: "441704"
        }, {
            label: "陽西縣",
            value: "441721"
        }, {
            label: "陽春市",
            value: "441781"
        }
        ],
        label: "陽江市",
        value: "441700"
    }, {
        children: [{
            label: "市轄區",
            value: "441801"
        }, {
            label: "清城區",
            value: "441802"
        }, {
            label: "清新區",
            value: "441803"
        }, {
            label: "佛岡縣",
            value: "441821"
        }, {
            label: "陽山縣",
            value: "441823"
        }, {
            label: "連山壯族瑤族自治縣",
            value: "441825"
        }, {
            label: "連南瑤族自治縣",
            value: "441826"
        }, {
            label: "英德市",
            value: "441881"
        }, {
            label: "連州市",
            value: "441882"
        }
        ],
        label: "清遠市",
        value: "441800"
    }, {
        label: "東莞市",
        value: "441900"
    }, {
        label: "中山市",
        value: "442000"
    }, {
        children: [{
            label: "市轄區",
            value: "445101"
        }, {
            label: "湘橋區",
            value: "445102"
        }, {
            label: "潮安區",
            value: "445103"
        }, {
            label: "饒平縣",
            value: "445122"
        }
        ],
        label: "潮州市",
        value: "445100"
    }, {
        children: [{
            label: "市轄區",
            value: "445201"
        }, {
            label: "榕城區",
            value: "445202"
        }, {
            label: "揭東區",
            value: "445203"
        }, {
            label: "揭西縣",
            value: "445222"
        }, {
            label: "惠來縣",
            value: "445224"
        }, {
            label: "普寧市",
            value: "445281"
        }
        ],
        label: "揭陽市",
        value: "445200"
    }, {
        children: [{
            label: "市轄區",
            value: "445301"
        }, {
            label: "雲城區",
            value: "445302"
        }, {
            label: "雲安區",
            value: "445303"
        }, {
            label: "新興縣",
            value: "445321"
        }, {
            label: "郁南縣",
            value: "445322"
        }, {
            label: "羅定市",
            value: "445381"
        }
        ],
        label: "雲浮市",
        value: "445300"
    }
    ],
    label: "廣東省",
    value: "440000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "450101"
        }, {
            label: "興寧區",
            value: "450102"
        }, {
            label: "青秀區",
            value: "450103"
        }, {
            label: "江南區",
            value: "450105"
        }, {
            label: "西鄉塘區",
            value: "450107"
        }, {
            label: "良慶區",
            value: "450108"
        }, {
            label: "邕寧區",
            value: "450109"
        }, {
            label: "武鳴區",
            value: "450110"
        }, {
            label: "隆安縣",
            value: "450123"
        }, {
            label: "馬山縣",
            value: "450124"
        }, {
            label: "上林縣",
            value: "450125"
        }, {
            label: "賓陽縣",
            value: "450126"
        }, {
            label: "橫縣",
            value: "450127"
        }
        ],
        label: "南寧市",
        value: "450100"
    }, {
        children: [{
            label: "市轄區",
            value: "450201"
        }, {
            label: "城中區",
            value: "450202"
        }, {
            label: "魚峰區",
            value: "450203"
        }, {
            label: "柳南區",
            value: "450204"
        }, {
            label: "柳北區",
            value: "450205"
        }, {
            label: "柳江區",
            value: "450206"
        }, {
            label: "柳城縣",
            value: "450222"
        }, {
            label: "鹿寨縣",
            value: "450223"
        }, {
            label: "融安縣",
            value: "450224"
        }, {
            label: "融水苗族自治縣",
            value: "450225"
        }, {
            label: "三江侗族自治縣",
            value: "450226"
        }
        ],
        label: "柳州市",
        value: "450200"
    }, {
        children: [{
            label: "市轄區",
            value: "450301"
        }, {
            label: "秀峰區",
            value: "450302"
        }, {
            label: "疊彩區",
            value: "450303"
        }, {
            label: "象山區",
            value: "450304"
        }, {
            label: "七星區",
            value: "450305"
        }, {
            label: "雁山區",
            value: "450311"
        }, {
            label: "臨桂區",
            value: "450312"
        }, {
            label: "陽朔縣",
            value: "450321"
        }, {
            label: "靈川縣",
            value: "450323"
        }, {
            label: "全州縣",
            value: "450324"
        }, {
            label: "興安縣",
            value: "450325"
        }, {
            label: "永福縣",
            value: "450326"
        }, {
            label: "灌陽縣",
            value: "450327"
        }, {
            label: "龍勝各族自治縣",
            value: "450328"
        }, {
            label: "資源縣",
            value: "450329"
        }, {
            label: "平樂縣",
            value: "450330"
        }, {
            label: "荔浦縣",
            value: "450331"
        }, {
            label: "恭城瑤族自治縣",
            value: "450332"
        }
        ],
        label: "桂林市",
        value: "450300"
    }, {
        children: [{
            label: "市轄區",
            value: "450401"
        }, {
            label: "萬秀區",
            value: "450403"
        }, {
            label: "長洲區",
            value: "450405"
        }, {
            label: "龍圩區",
            value: "450406"
        }, {
            label: "蒼梧縣",
            value: "450421"
        }, {
            label: "藤縣",
            value: "450422"
        }, {
            label: "蒙山縣",
            value: "450423"
        }, {
            label: "岑溪市",
            value: "450481"
        }
        ],
        label: "梧州市",
        value: "450400"
    }, {
        children: [{
            label: "市轄區",
            value: "450501"
        }, {
            label: "海城區",
            value: "450502"
        }, {
            label: "銀海區",
            value: "450503"
        }, {
            label: "鐵山港區",
            value: "450512"
        }, {
            label: "合浦縣",
            value: "450521"
        }
        ],
        label: "北海市",
        value: "450500"
    }, {
        children: [{
            label: "市轄區",
            value: "450601"
        }, {
            label: "港口區",
            value: "450602"
        }, {
            label: "防城區",
            value: "450603"
        }, {
            label: "上思縣",
            value: "450621"
        }, {
            label: "東興市",
            value: "450681"
        }
        ],
        label: "防城港市",
        value: "450600"
    }, {
        children: [{
            label: "市轄區",
            value: "450701"
        }, {
            label: "欽南區",
            value: "450702"
        }, {
            label: "欽北區",
            value: "450703"
        }, {
            label: "靈山縣",
            value: "450721"
        }, {
            label: "浦北縣",
            value: "450722"
        }
        ],
        label: "欽州市",
        value: "450700"
    }, {
        children: [{
            label: "市轄區",
            value: "450801"
        }, {
            label: "港北區",
            value: "450802"
        }, {
            label: "港南區",
            value: "450803"
        }, {
            label: "覃塘區",
            value: "450804"
        }, {
            label: "平南縣",
            value: "450821"
        }, {
            label: "桂平市",
            value: "450881"
        }
        ],
        label: "貴港市",
        value: "450800"
    }, {
        children: [{
            label: "市轄區",
            value: "450901"
        }, {
            label: "玉州區",
            value: "450902"
        }, {
            label: "福綿區",
            value: "450903"
        }, {
            label: "容縣",
            value: "450921"
        }, {
            label: "陸川縣",
            value: "450922"
        }, {
            label: "博白縣",
            value: "450923"
        }, {
            label: "興業縣",
            value: "450924"
        }, {
            label: "北流市",
            value: "450981"
        }
        ],
        label: "玉林市",
        value: "450900"
    }, {
        children: [{
            label: "市轄區",
            value: "451001"
        }, {
            label: "右江區",
            value: "451002"
        }, {
            label: "田陽縣",
            value: "451021"
        }, {
            label: "田東縣",
            value: "451022"
        }, {
            label: "平果縣",
            value: "451023"
        }, {
            label: "德保縣",
            value: "451024"
        }, {
            label: "那坡縣",
            value: "451026"
        }, {
            label: "淩雲縣",
            value: "451027"
        }, {
            label: "樂業縣",
            value: "451028"
        }, {
            label: "田林縣",
            value: "451029"
        }, {
            label: "西林縣",
            value: "451030"
        }, {
            label: "隆林各族自治縣",
            value: "451031"
        }, {
            label: "靖西市",
            value: "451081"
        }
        ],
        label: "百色市",
        value: "451000"
    }, {
        children: [{
            label: "市轄區",
            value: "451101"
        }, {
            label: "八步區",
            value: "451102"
        }, {
            label: "平桂區",
            value: "451103"
        }, {
            label: "昭平縣",
            value: "451121"
        }, {
            label: "鐘山縣",
            value: "451122"
        }, {
            label: "富川瑤族自治縣",
            value: "451123"
        }
        ],
        label: "賀州市",
        value: "451100"
    }, {
        children: [{
            label: "市轄區",
            value: "451201"
        }, {
            label: "金城江區",
            value: "451202"
        }, {
            label: "南丹縣",
            value: "451221"
        }, {
            label: "天峨縣",
            value: "451222"
        }, {
            label: "鳳山縣",
            value: "451223"
        }, {
            label: "東蘭縣",
            value: "451224"
        }, {
            label: "羅城仫佬族自治縣",
            value: "451225"
        }, {
            label: "環江毛南族自治縣",
            value: "451226"
        }, {
            label: "巴馬瑤族自治縣",
            value: "451227"
        }, {
            label: "都安瑤族自治縣",
            value: "451228"
        }, {
            label: "大化瑤族自治縣",
            value: "451229"
        }, {
            label: "宜州市",
            value: "451281"
        }
        ],
        label: "河池市",
        value: "451200"
    }, {
        children: [{
            label: "市轄區",
            value: "451301"
        }, {
            label: "興賓區",
            value: "451302"
        }, {
            label: "忻城縣",
            value: "451321"
        }, {
            label: "象州縣",
            value: "451322"
        }, {
            label: "武宣縣",
            value: "451323"
        }, {
            label: "金秀瑤族自治縣",
            value: "451324"
        }, {
            label: "合山市",
            value: "451381"
        }
        ],
        label: "來賓市",
        value: "451300"
    }, {
        children: [{
            label: "市轄區",
            value: "451401"
        }, {
            label: "江州區",
            value: "451402"
        }, {
            label: "扶綏縣",
            value: "451421"
        }, {
            label: "寧明縣",
            value: "451422"
        }, {
            label: "龍州縣",
            value: "451423"
        }, {
            label: "大新縣",
            value: "451424"
        }, {
            label: "天等縣",
            value: "451425"
        }, {
            label: "憑祥市",
            value: "451481"
        }
        ],
        label: "崇左市",
        value: "451400"
    }
    ],
    label: "廣西壯族自治區",
    value: "450000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "460101"
        }, {
            label: "秀英區",
            value: "460105"
        }, {
            label: "龍華區",
            value: "460106"
        }, {
            label: "瓊山區",
            value: "460107"
        }, {
            label: "美蘭區",
            value: "460108"
        }
        ],
        label: "海口市",
        value: "460100"
    }, {
        children: [{
            label: "市轄區",
            value: "460201"
        }, {
            label: "海棠區",
            value: "460202"
        }, {
            label: "吉陽區",
            value: "460203"
        }, {
            label: "天涯區",
            value: "460204"
        }, {
            label: "崖州區",
            value: "460205"
        }
        ],
        label: "三亞市",
        value: "460200"
    }, {
        children: [],
        label: "三沙市",
        value: "460300"
    }, {
        children: [],
        label: "儋州市",
        value: "460400"
    }, {
        children: [{
            label: "五指山市",
            value: "469001"
        }, {
            label: "瓊海市",
            value: "469002"
        }, {
            label: "文昌市",
            value: "469005"
        }, {
            label: "萬寧市",
            value: "469006"
        }, {
            label: "東方市",
            value: "469007"
        }, {
            label: "定安縣",
            value: "469021"
        }, {
            label: "屯昌縣",
            value: "469022"
        }, {
            label: "澄邁縣",
            value: "469023"
        }, {
            label: "臨高縣",
            value: "469024"
        }, {
            label: "白沙黎族自治縣",
            value: "469025"
        }, {
            label: "昌江黎族自治縣",
            value: "469026"
        }, {
            label: "樂東黎族自治縣",
            value: "469027"
        }, {
            label: "陵水黎族自治縣",
            value: "469028"
        }, {
            label: "保亭黎族苗族自治縣",
            value: "469029"
        }, {
            label: "瓊中黎族苗族自治縣",
            value: "469030"
        }
        ],
        label: "省直轄縣級行政區劃",
        value: "469000"
    }
    ],
    label: "海南省",
    value: "460000"
}, {
    children: [{
        children: [{
            label: "萬州區",
            value: "500101"
        }, {
            label: "涪陵區",
            value: "500102"
        }, {
            label: "渝中區",
            value: "500103"
        }, {
            label: "大渡口區",
            value: "500104"
        }, {
            label: "江北區",
            value: "500105"
        }, {
            label: "沙坪壩區",
            value: "500106"
        }, {
            label: "九龍坡區",
            value: "500107"
        }, {
            label: "南岸區",
            value: "500108"
        }, {
            label: "北碚區",
            value: "500109"
        }, {
            label: "綦江區",
            value: "500110"
        }, {
            label: "大足區",
            value: "500111"
        }, {
            label: "渝北區",
            value: "500112"
        }, {
            label: "巴南區",
            value: "500113"
        }, {
            label: "黔江區",
            value: "500114"
        }, {
            label: "長壽區",
            value: "500115"
        }, {
            label: "江津區",
            value: "500116"
        }, {
            label: "合川區",
            value: "500117"
        }, {
            label: "永川區",
            value: "500118"
        }, {
            label: "南川區",
            value: "500119"
        }, {
            label: "璧山區",
            value: "500120"
        }, {
            label: "銅梁區",
            value: "500151"
        }, {
            label: "潼南區",
            value: "500152"
        }, {
            label: "榮昌區",
            value: "500153"
        }, {
            label: "開州區",
            value: "500154"
        }
        ],
        label: "市轄區",
        value: "500100"
    }, {
        children: [{
            label: "梁平縣",
            value: "500228"
        }, {
            label: "城口縣",
            value: "500229"
        }, {
            label: "豐都縣",
            value: "500230"
        }, {
            label: "墊江縣",
            value: "500231"
        }, {
            label: "武隆縣",
            value: "500232"
        }, {
            label: "忠縣",
            value: "500233"
        }, {
            label: "雲陽縣",
            value: "500235"
        }, {
            label: "奉節縣",
            value: "500236"
        }, {
            label: "巫山縣",
            value: "500237"
        }, {
            label: "巫溪縣",
            value: "500238"
        }, {
            label: "石柱土家族自治縣",
            value: "500240"
        }, {
            label: "秀山土家族苗族自治縣",
            value: "500241"
        }, {
            label: "酉陽土家族苗族自治縣",
            value: "500242"
        }, {
            label: "彭水苗族土家族自治縣",
            value: "500243"
        }
        ],
        label: "縣",
        value: "500200"
    }
    ],
    label: "重慶市",
    value: "500000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "510101"
        }, {
            label: "錦江區",
            value: "510104"
        }, {
            label: "青羊區",
            value: "510105"
        }, {
            label: "金牛區",
            value: "510106"
        }, {
            label: "武侯區",
            value: "510107"
        }, {
            label: "成華區",
            value: "510108"
        }, {
            label: "龍泉驛區",
            value: "510112"
        }, {
            label: "青白江區",
            value: "510113"
        }, {
            label: "新都區",
            value: "510114"
        }, {
            label: "溫江區",
            value: "510115"
        }, {
            label: "雙流區",
            value: "510116"
        }, {
            label: "金堂縣",
            value: "510121"
        }, {
            label: "郫縣",
            value: "510124"
        }, {
            label: "大邑縣",
            value: "510129"
        }, {
            label: "蒲江縣",
            value: "510131"
        }, {
            label: "新津縣",
            value: "510132"
        }, {
            label: "都江堰市",
            value: "510181"
        }, {
            label: "彭州市",
            value: "510182"
        }, {
            label: "邛崍市",
            value: "510183"
        }, {
            label: "崇州市",
            value: "510184"
        }, {
            label: "簡陽市",
            value: "510185"
        }
        ],
        label: "成都市",
        value: "510100"
    }, {
        children: [{
            label: "市轄區",
            value: "510301"
        }, {
            label: "自流井區",
            value: "510302"
        }, {
            label: "貢井區",
            value: "510303"
        }, {
            label: "大安區",
            value: "510304"
        }, {
            label: "沿灘區",
            value: "510311"
        }, {
            label: "榮縣",
            value: "510321"
        }, {
            label: "富順縣",
            value: "510322"
        }
        ],
        label: "自貢市",
        value: "510300"
    }, {
        children: [{
            label: "市轄區",
            value: "510401"
        }, {
            label: "東區",
            value: "510402"
        }, {
            label: "西區",
            value: "510403"
        }, {
            label: "仁和區",
            value: "510411"
        }, {
            label: "米易縣",
            value: "510421"
        }, {
            label: "鹽邊縣",
            value: "510422"
        }
        ],
        label: "攀枝花市",
        value: "510400"
    }, {
        children: [{
            label: "市轄區",
            value: "510501"
        }, {
            label: "江陽區",
            value: "510502"
        }, {
            label: "納溪區",
            value: "510503"
        }, {
            label: "龍馬潭區",
            value: "510504"
        }, {
            label: "瀘縣",
            value: "510521"
        }, {
            label: "合江縣",
            value: "510522"
        }, {
            label: "敘永縣",
            value: "510524"
        }, {
            label: "古藺縣",
            value: "510525"
        }
        ],
        label: "瀘州市",
        value: "510500"
    }, {
        children: [{
            label: "市轄區",
            value: "510601"
        }, {
            label: "旌陽區",
            value: "510603"
        }, {
            label: "中江縣",
            value: "510623"
        }, {
            label: "羅江縣",
            value: "510626"
        }, {
            label: "廣漢市",
            value: "510681"
        }, {
            label: "什邡市",
            value: "510682"
        }, {
            label: "綿竹市",
            value: "510683"
        }
        ],
        label: "德陽市",
        value: "510600"
    }, {
        children: [{
            label: "市轄區",
            value: "510701"
        }, {
            label: "涪城區",
            value: "510703"
        }, {
            label: "遊仙區",
            value: "510704"
        }, {
            label: "安州區",
            value: "510705"
        }, {
            label: "三臺縣",
            value: "510722"
        }, {
            label: "鹽亭縣",
            value: "510723"
        }, {
            label: "梓潼縣",
            value: "510725"
        }, {
            label: "北川羌族自治縣",
            value: "510726"
        }, {
            label: "平武縣",
            value: "510727"
        }, {
            label: "江油市",
            value: "510781"
        }
        ],
        label: "綿陽市",
        value: "510700"
    }, {
        children: [{
            label: "市轄區",
            value: "510801"
        }, {
            label: "利州區",
            value: "510802"
        }, {
            label: "昭化區",
            value: "510811"
        }, {
            label: "朝天區",
            value: "510812"
        }, {
            label: "旺蒼縣",
            value: "510821"
        }, {
            label: "青川縣",
            value: "510822"
        }, {
            label: "劍閣縣",
            value: "510823"
        }, {
            label: "蒼溪縣",
            value: "510824"
        }
        ],
        label: "廣元市",
        value: "510800"
    }, {
        children: [{
            label: "市轄區",
            value: "510901"
        }, {
            label: "船山區",
            value: "510903"
        }, {
            label: "安居區",
            value: "510904"
        }, {
            label: "蓬溪縣",
            value: "510921"
        }, {
            label: "射洪縣",
            value: "510922"
        }, {
            label: "大英縣",
            value: "510923"
        }
        ],
        label: "遂寧市",
        value: "510900"
    }, {
        children: [{
            label: "市轄區",
            value: "511001"
        }, {
            label: "市中區",
            value: "511002"
        }, {
            label: "東興區",
            value: "511011"
        }, {
            label: "威遠縣",
            value: "511024"
        }, {
            label: "資中縣",
            value: "511025"
        }, {
            label: "隆昌縣",
            value: "511028"
        }
        ],
        label: "內江市",
        value: "511000"
    }, {
        children: [{
            label: "市轄區",
            value: "511101"
        }, {
            label: "市中區",
            value: "511102"
        }, {
            label: "沙灣區",
            value: "511111"
        }, {
            label: "五通橋區",
            value: "511112"
        }, {
            label: "金口河區",
            value: "511113"
        }, {
            label: "犍為縣",
            value: "511123"
        }, {
            label: "井研縣",
            value: "511124"
        }, {
            label: "夾江縣",
            value: "511126"
        }, {
            label: "沐川縣",
            value: "511129"
        }, {
            label: "峨邊彜族自治縣",
            value: "511132"
        }, {
            label: "馬邊彜族自治縣",
            value: "511133"
        }, {
            label: "峨眉山市",
            value: "511181"
        }
        ],
        label: "樂山市",
        value: "511100"
    }, {
        children: [{
            label: "市轄區",
            value: "511301"
        }, {
            label: "順慶區",
            value: "511302"
        }, {
            label: "高坪區",
            value: "511303"
        }, {
            label: "嘉陵區",
            value: "511304"
        }, {
            label: "南部縣",
            value: "511321"
        }, {
            label: "營山縣",
            value: "511322"
        }, {
            label: "蓬安縣",
            value: "511323"
        }, {
            label: "儀隴縣",
            value: "511324"
        }, {
            label: "西充縣",
            value: "511325"
        }, {
            label: "閬中市",
            value: "511381"
        }
        ],
        label: "南充市",
        value: "511300"
    }, {
        children: [{
            label: "市轄區",
            value: "511401"
        }, {
            label: "東坡區",
            value: "511402"
        }, {
            label: "彭山區",
            value: "511403"
        }, {
            label: "仁壽縣",
            value: "511421"
        }, {
            label: "洪雅縣",
            value: "511423"
        }, {
            label: "丹棱縣",
            value: "511424"
        }, {
            label: "青神縣",
            value: "511425"
        }
        ],
        label: "眉山市",
        value: "511400"
    }, {
        children: [{
            label: "市轄區",
            value: "511501"
        }, {
            label: "翠屏區",
            value: "511502"
        }, {
            label: "南溪區",
            value: "511503"
        }, {
            label: "宜賓縣",
            value: "511521"
        }, {
            label: "江安縣",
            value: "511523"
        }, {
            label: "長寧縣",
            value: "511524"
        }, {
            label: "高縣",
            value: "511525"
        }, {
            label: "珙縣",
            value: "511526"
        }, {
            label: "筠連縣",
            value: "511527"
        }, {
            label: "興文縣",
            value: "511528"
        }, {
            label: "屏山縣",
            value: "511529"
        }
        ],
        label: "宜賓市",
        value: "511500"
    }, {
        children: [{
            label: "市轄區",
            value: "511601"
        }, {
            label: "廣安區",
            value: "511602"
        }, {
            label: "前鋒區",
            value: "511603"
        }, {
            label: "嶽池縣",
            value: "511621"
        }, {
            label: "武勝縣",
            value: "511622"
        }, {
            label: "鄰水縣",
            value: "511623"
        }, {
            label: "華鎣市",
            value: "511681"
        }
        ],
        label: "廣安市",
        value: "511600"
    }, {
        children: [{
            label: "市轄區",
            value: "511701"
        }, {
            label: "通川區",
            value: "511702"
        }, {
            label: "達川區",
            value: "511703"
        }, {
            label: "宣漢縣",
            value: "511722"
        }, {
            label: "開江縣",
            value: "511723"
        }, {
            label: "大竹縣",
            value: "511724"
        }, {
            label: "渠縣",
            value: "511725"
        }, {
            label: "萬源市",
            value: "511781"
        }
        ],
        label: "達州市",
        value: "511700"
    }, {
        children: [{
            label: "市轄區",
            value: "511801"
        }, {
            label: "雨城區",
            value: "511802"
        }, {
            label: "名山區",
            value: "511803"
        }, {
            label: "滎經縣",
            value: "511822"
        }, {
            label: "漢源縣",
            value: "511823"
        }, {
            label: "石棉縣",
            value: "511824"
        }, {
            label: "天全縣",
            value: "511825"
        }, {
            label: "蘆山縣",
            value: "511826"
        }, {
            label: "寶興縣",
            value: "511827"
        }
        ],
        label: "雅安市",
        value: "511800"
    }, {
        children: [{
            label: "市轄區",
            value: "511901"
        }, {
            label: "巴州區",
            value: "511902"
        }, {
            label: "恩陽區",
            value: "511903"
        }, {
            label: "通江縣",
            value: "511921"
        }, {
            label: "南江縣",
            value: "511922"
        }, {
            label: "平昌縣",
            value: "511923"
        }
        ],
        label: "巴中市",
        value: "511900"
    }, {
        children: [{
            label: "市轄區",
            value: "512001"
        }, {
            label: "雁江區",
            value: "512002"
        }, {
            label: "安嶽縣",
            value: "512021"
        }, {
            label: "樂至縣",
            value: "512022"
        }
        ],
        label: "資陽市",
        value: "512000"
    }, {
        children: [{
            label: "馬爾康市",
            value: "513201"
        }, {
            label: "汶川縣",
            value: "513221"
        }, {
            label: "理縣",
            value: "513222"
        }, {
            label: "茂縣",
            value: "513223"
        }, {
            label: "松潘縣",
            value: "513224"
        }, {
            label: "九寨溝縣",
            value: "513225"
        }, {
            label: "金川縣",
            value: "513226"
        }, {
            label: "小金縣",
            value: "513227"
        }, {
            label: "黑水縣",
            value: "513228"
        }, {
            label: "壤塘縣",
            value: "513230"
        }, {
            label: "阿壩縣",
            value: "513231"
        }, {
            label: "若爾蓋縣",
            value: "513232"
        }, {
            label: "紅原縣",
            value: "513233"
        }
        ],
        label: "阿壩藏族羌族自治州",
        value: "513200"
    }, {
        children: [{
            label: "康定市",
            value: "513301"
        }, {
            label: "瀘定縣",
            value: "513322"
        }, {
            label: "丹巴縣",
            value: "513323"
        }, {
            label: "九龍縣",
            value: "513324"
        }, {
            label: "雅江縣",
            value: "513325"
        }, {
            label: "道孚縣",
            value: "513326"
        }, {
            label: "爐霍縣",
            value: "513327"
        }, {
            label: "甘孜縣",
            value: "513328"
        }, {
            label: "新龍縣",
            value: "513329"
        }, {
            label: "德格縣",
            value: "513330"
        }, {
            label: "白玉縣",
            value: "513331"
        }, {
            label: "石渠縣",
            value: "513332"
        }, {
            label: "色達縣",
            value: "513333"
        }, {
            label: "理塘縣",
            value: "513334"
        }, {
            label: "巴塘縣",
            value: "513335"
        }, {
            label: "鄉城縣",
            value: "513336"
        }, {
            label: "稻城縣",
            value: "513337"
        }, {
            label: "得榮縣",
            value: "513338"
        }
        ],
        label: "甘孜藏族自治州",
        value: "513300"
    }, {
        children: [{
            label: "西昌市",
            value: "513401"
        }, {
            label: "木裏藏族自治縣",
            value: "513422"
        }, {
            label: "鹽源縣",
            value: "513423"
        }, {
            label: "德昌縣",
            value: "513424"
        }, {
            label: "會理縣",
            value: "513425"
        }, {
            label: "會東縣",
            value: "513426"
        }, {
            label: "寧南縣",
            value: "513427"
        }, {
            label: "普格縣",
            value: "513428"
        }, {
            label: "布拖縣",
            value: "513429"
        }, {
            label: "金陽縣",
            value: "513430"
        }, {
            label: "昭覺縣",
            value: "513431"
        }, {
            label: "喜德縣",
            value: "513432"
        }, {
            label: "冕寧縣",
            value: "513433"
        }, {
            label: "越西縣",
            value: "513434"
        }, {
            label: "甘洛縣",
            value: "513435"
        }, {
            label: "美姑縣",
            value: "513436"
        }, {
            label: "雷波縣",
            value: "513437"
        }
        ],
        label: "涼山彜族自治州",
        value: "513400"
    }
    ],
    label: "四川省",
    value: "510000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "520101"
        }, {
            label: "南明區",
            value: "520102"
        }, {
            label: "雲巖區",
            value: "520103"
        }, {
            label: "花溪區",
            value: "520111"
        }, {
            label: "烏當區",
            value: "520112"
        }, {
            label: "白雲區",
            value: "520113"
        }, {
            label: "觀山湖區",
            value: "520115"
        }, {
            label: "開陽縣",
            value: "520121"
        }, {
            label: "息烽縣",
            value: "520122"
        }, {
            label: "修文縣",
            value: "520123"
        }, {
            label: "清鎮市",
            value: "520181"
        }
        ],
        label: "貴陽市",
        value: "520100"
    }, {
        children: [{
            label: "鐘山區",
            value: "520201"
        }, {
            label: "六枝特區",
            value: "520203"
        }, {
            label: "水城縣",
            value: "520221"
        }, {
            label: "盤縣",
            value: "520222"
        }
        ],
        label: "六盤水市",
        value: "520200"
    }, {
        children: [{
            label: "市轄區",
            value: "520301"
        }, {
            label: "紅花崗區",
            value: "520302"
        }, {
            label: "匯川區",
            value: "520303"
        }, {
            label: "播州區",
            value: "520304"
        }, {
            label: "桐梓縣",
            value: "520322"
        }, {
            label: "綏陽縣",
            value: "520323"
        }, {
            label: "正安縣",
            value: "520324"
        }, {
            label: "道真仡佬族苗族自治縣",
            value: "520325"
        }, {
            label: "務川仡佬族苗族自治縣",
            value: "520326"
        }, {
            label: "鳳岡縣",
            value: "520327"
        }, {
            label: "湄潭縣",
            value: "520328"
        }, {
            label: "余慶縣",
            value: "520329"
        }, {
            label: "習水縣",
            value: "520330"
        }, {
            label: "赤水市",
            value: "520381"
        }, {
            label: "仁懷市",
            value: "520382"
        }
        ],
        label: "遵義市",
        value: "520300"
    }, {
        children: [{
            label: "市轄區",
            value: "520401"
        }, {
            label: "西秀區",
            value: "520402"
        }, {
            label: "平壩區",
            value: "520403"
        }, {
            label: "普定縣",
            value: "520422"
        }, {
            label: "鎮寧布依族苗族自治縣",
            value: "520423"
        }, {
            label: "關嶺布依族苗族自治縣",
            value: "520424"
        }, {
            label: "紫雲苗族布依族自治縣",
            value: "520425"
        }
        ],
        label: "安順市",
        value: "520400"
    }, {
        children: [{
            label: "市轄區",
            value: "520501"
        }, {
            label: "七星關區",
            value: "520502"
        }, {
            label: "大方縣",
            value: "520521"
        }, {
            label: "黔西縣",
            value: "520522"
        }, {
            label: "金沙縣",
            value: "520523"
        }, {
            label: "織金縣",
            value: "520524"
        }, {
            label: "納雍縣",
            value: "520525"
        }, {
            label: "威寧彜族回族苗族自治縣",
            value: "520526"
        }, {
            label: "赫章縣",
            value: "520527"
        }
        ],
        label: "畢節市",
        value: "520500"
    }, {
        children: [{
            label: "市轄區",
            value: "520601"
        }, {
            label: "碧江區",
            value: "520602"
        }, {
            label: "萬山區",
            value: "520603"
        }, {
            label: "江口縣",
            value: "520621"
        }, {
            label: "玉屏侗族自治縣",
            value: "520622"
        }, {
            label: "石阡縣",
            value: "520623"
        }, {
            label: "思南縣",
            value: "520624"
        }, {
            label: "印江土家族苗族自治縣",
            value: "520625"
        }, {
            label: "德江縣",
            value: "520626"
        }, {
            label: "沿河土家族自治縣",
            value: "520627"
        }, {
            label: "松桃苗族自治縣",
            value: "520628"
        }
        ],
        label: "銅仁市",
        value: "520600"
    }, {
        children: [{
            label: "興義市",
            value: "522301"
        }, {
            label: "興仁縣",
            value: "522322"
        }, {
            label: "普安縣",
            value: "522323"
        }, {
            label: "晴隆縣",
            value: "522324"
        }, {
            label: "貞豐縣",
            value: "522325"
        }, {
            label: "望謨縣",
            value: "522326"
        }, {
            label: "冊亨縣",
            value: "522327"
        }, {
            label: "安龍縣",
            value: "522328"
        }
        ],
        label: "黔西南布依族苗族自治州",
        value: "522300"
    }, {
        children: [{
            label: "凱裏市",
            value: "522601"
        }, {
            label: "黃平縣",
            value: "522622"
        }, {
            label: "施秉縣",
            value: "522623"
        }, {
            label: "三穗縣",
            value: "522624"
        }, {
            label: "鎮遠縣",
            value: "522625"
        }, {
            label: "岑鞏縣",
            value: "522626"
        }, {
            label: "天柱縣",
            value: "522627"
        }, {
            label: "錦屏縣",
            value: "522628"
        }, {
            label: "劍河縣",
            value: "522629"
        }, {
            label: "臺江縣",
            value: "522630"
        }, {
            label: "黎平縣",
            value: "522631"
        }, {
            label: "榕江縣",
            value: "522632"
        }, {
            label: "從江縣",
            value: "522633"
        }, {
            label: "雷山縣",
            value: "522634"
        }, {
            label: "麻江縣",
            value: "522635"
        }, {
            label: "丹寨縣",
            value: "522636"
        }
        ],
        label: "黔東南苗族侗族自治州",
        value: "522600"
    }, {
        children: [{
            label: "都勻市",
            value: "522701"
        }, {
            label: "福泉市",
            value: "522702"
        }, {
            label: "荔波縣",
            value: "522722"
        }, {
            label: "貴定縣",
            value: "522723"
        }, {
            label: "甕安縣",
            value: "522725"
        }, {
            label: "獨山縣",
            value: "522726"
        }, {
            label: "平塘縣",
            value: "522727"
        }, {
            label: "羅甸縣",
            value: "522728"
        }, {
            label: "長順縣",
            value: "522729"
        }, {
            label: "龍裏縣",
            value: "522730"
        }, {
            label: "惠水縣",
            value: "522731"
        }, {
            label: "三都水族自治縣",
            value: "522732"
        }
        ],
        label: "黔南布依族苗族自治州",
        value: "522700"
    }
    ],
    label: "貴州省",
    value: "520000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "530101"
        }, {
            label: "五華區",
            value: "530102"
        }, {
            label: "盤龍區",
            value: "530103"
        }, {
            label: "官渡區",
            value: "530111"
        }, {
            label: "西山區",
            value: "530112"
        }, {
            label: "東川區",
            value: "530113"
        }, {
            label: "呈貢區",
            value: "530114"
        }, {
            label: "晉寧縣",
            value: "530122"
        }, {
            label: "富民縣",
            value: "530124"
        }, {
            label: "宜良縣",
            value: "530125"
        }, {
            label: "石林彜族自治縣",
            value: "530126"
        }, {
            label: "嵩明縣",
            value: "530127"
        }, {
            label: "祿勸彜族苗族自治縣",
            value: "530128"
        }, {
            label: "尋甸回族彜族自治縣",
            value: "530129"
        }, {
            label: "安寧市",
            value: "530181"
        }
        ],
        label: "昆明市",
        value: "530100"
    }, {
        children: [{
            label: "市轄區",
            value: "530301"
        }, {
            label: "麒麟區",
            value: "530302"
        }, {
            label: "沾益區",
            value: "530303"
        }, {
            label: "馬龍縣",
            value: "530321"
        }, {
            label: "陸良縣",
            value: "530322"
        }, {
            label: "師宗縣",
            value: "530323"
        }, {
            label: "羅平縣",
            value: "530324"
        }, {
            label: "富源縣",
            value: "530325"
        }, {
            label: "會澤縣",
            value: "530326"
        }, {
            label: "宣威市",
            value: "530381"
        }
        ],
        label: "曲靖市",
        value: "530300"
    }, {
        children: [{
            label: "市轄區",
            value: "530401"
        }, {
            label: "紅塔區",
            value: "530402"
        }, {
            label: "江川區",
            value: "530403"
        }, {
            label: "澄江縣",
            value: "530422"
        }, {
            label: "通海縣",
            value: "530423"
        }, {
            label: "華寧縣",
            value: "530424"
        }, {
            label: "易門縣",
            value: "530425"
        }, {
            label: "峨山彜族自治縣",
            value: "530426"
        }, {
            label: "新平彜族傣族自治縣",
            value: "530427"
        }, {
            label: "元江哈尼族彜族傣族自治縣",
            value: "530428"
        }
        ],
        label: "玉溪市",
        value: "530400"
    }, {
        children: [{
            label: "市轄區",
            value: "530501"
        }, {
            label: "隆陽區",
            value: "530502"
        }, {
            label: "施甸縣",
            value: "530521"
        }, {
            label: "龍陵縣",
            value: "530523"
        }, {
            label: "昌寧縣",
            value: "530524"
        }, {
            label: "騰沖市",
            value: "530581"
        }
        ],
        label: "保山市",
        value: "530500"
    }, {
        children: [{
            label: "市轄區",
            value: "530601"
        }, {
            label: "昭陽區",
            value: "530602"
        }, {
            label: "魯甸縣",
            value: "530621"
        }, {
            label: "巧家縣",
            value: "530622"
        }, {
            label: "鹽津縣",
            value: "530623"
        }, {
            label: "大關縣",
            value: "530624"
        }, {
            label: "永善縣",
            value: "530625"
        }, {
            label: "綏江縣",
            value: "530626"
        }, {
            label: "鎮雄縣",
            value: "530627"
        }, {
            label: "彜良縣",
            value: "530628"
        }, {
            label: "威信縣",
            value: "530629"
        }, {
            label: "水富縣",
            value: "530630"
        }
        ],
        label: "昭通市",
        value: "530600"
    }, {
        children: [{
            label: "市轄區",
            value: "530701"
        }, {
            label: "古城區",
            value: "530702"
        }, {
            label: "玉龍納西族自治縣",
            value: "530721"
        }, {
            label: "永勝縣",
            value: "530722"
        }, {
            label: "華坪縣",
            value: "530723"
        }, {
            label: "寧蒗彜族自治縣",
            value: "530724"
        }
        ],
        label: "麗江市",
        value: "530700"
    }, {
        children: [{
            label: "市轄區",
            value: "530801"
        }, {
            label: "思茅區",
            value: "530802"
        }, {
            label: "寧洱哈尼族彜族自治縣",
            value: "530821"
        }, {
            label: "墨江哈尼族自治縣",
            value: "530822"
        }, {
            label: "景東彜族自治縣",
            value: "530823"
        }, {
            label: "景谷傣族彜族自治縣",
            value: "530824"
        }, {
            label: "鎮沅彜族哈尼族拉祜族自治縣",
            value: "530825"
        }, {
            label: "江城哈尼族彜族自治縣",
            value: "530826"
        }, {
            label: "孟連傣族拉祜族佤族自治縣",
            value: "530827"
        }, {
            label: "瀾滄拉祜族自治縣",
            value: "530828"
        }, {
            label: "西盟佤族自治縣",
            value: "530829"
        }
        ],
        label: "普洱市",
        value: "530800"
    }, {
        children: [{
            label: "市轄區",
            value: "530901"
        }, {
            label: "臨翔區",
            value: "530902"
        }, {
            label: "鳳慶縣",
            value: "530921"
        }, {
            label: "雲縣",
            value: "530922"
        }, {
            label: "永德縣",
            value: "530923"
        }, {
            label: "鎮康縣",
            value: "530924"
        }, {
            label: "雙江拉祜族佤族布朗族傣族自治縣",
            value: "530925"
        }, {
            label: "耿馬傣族佤族自治縣",
            value: "530926"
        }, {
            label: "滄源佤族自治縣",
            value: "530927"
        }
        ],
        label: "臨滄市",
        value: "530900"
    }, {
        children: [{
            label: "楚雄市",
            value: "532301"
        }, {
            label: "雙柏縣",
            value: "532322"
        }, {
            label: "牟定縣",
            value: "532323"
        }, {
            label: "南華縣",
            value: "532324"
        }, {
            label: "姚安縣",
            value: "532325"
        }, {
            label: "大姚縣",
            value: "532326"
        }, {
            label: "永仁縣",
            value: "532327"
        }, {
            label: "元謀縣",
            value: "532328"
        }, {
            label: "武定縣",
            value: "532329"
        }, {
            label: "祿豐縣",
            value: "532331"
        }
        ],
        label: "楚雄彜族自治州",
        value: "532300"
    }, {
        children: [{
            label: "個舊市",
            value: "532501"
        }, {
            label: "開遠市",
            value: "532502"
        }, {
            label: "蒙自市",
            value: "532503"
        }, {
            label: "彌勒市",
            value: "532504"
        }, {
            label: "屏邊苗族自治縣",
            value: "532523"
        }, {
            label: "建水縣",
            value: "532524"
        }, {
            label: "石屏縣",
            value: "532525"
        }, {
            label: "瀘西縣",
            value: "532527"
        }, {
            label: "元陽縣",
            value: "532528"
        }, {
            label: "紅河縣",
            value: "532529"
        }, {
            label: "金平苗族瑤族傣族自治縣",
            value: "532530"
        }, {
            label: "綠春縣",
            value: "532531"
        }, {
            label: "河口瑤族自治縣",
            value: "532532"
        }
        ],
        label: "紅河哈尼族彜族自治州",
        value: "532500"
    }, {
        children: [{
            label: "文山市",
            value: "532601"
        }, {
            label: "硯山縣",
            value: "532622"
        }, {
            label: "西疇縣",
            value: "532623"
        }, {
            label: "麻栗坡縣",
            value: "532624"
        }, {
            label: "馬關縣",
            value: "532625"
        }, {
            label: "丘北縣",
            value: "532626"
        }, {
            label: "廣南縣",
            value: "532627"
        }, {
            label: "富寧縣",
            value: "532628"
        }
        ],
        label: "文山壯族苗族自治州",
        value: "532600"
    }, {
        children: [{
            label: "景洪市",
            value: "532801"
        }, {
            label: "猛海縣",
            value: "532822"
        }, {
            label: "猛臘縣",
            value: "532823"
        }
        ],
        label: "西雙版納傣族自治州",
        value: "532800"
    }, {
        children: [{
            label: "大理市",
            value: "532901"
        }, {
            label: "漾濞彜族自治縣",
            value: "532922"
        }, {
            label: "祥雲縣",
            value: "532923"
        }, {
            label: "賓川縣",
            value: "532924"
        }, {
            label: "彌渡縣",
            value: "532925"
        }, {
            label: "南澗彜族自治縣",
            value: "532926"
        }, {
            label: "巍山彜族回族自治縣",
            value: "532927"
        }, {
            label: "永平縣",
            value: "532928"
        }, {
            label: "雲龍縣",
            value: "532929"
        }, {
            label: "洱源縣",
            value: "532930"
        }, {
            label: "劍川縣",
            value: "532931"
        }, {
            label: "鶴慶縣",
            value: "532932"
        }
        ],
        label: "大理白族自治州",
        value: "532900"
    }, {
        children: [{
            label: "瑞麗市",
            value: "533102"
        }, {
            label: "芒市",
            value: "533103"
        }, {
            label: "梁河縣",
            value: "533122"
        }, {
            label: "盈江縣",
            value: "533123"
        }, {
            label: "隴川縣",
            value: "533124"
        }
        ],
        label: "德宏傣族景頗族自治州",
        value: "533100"
    }, {
        children: [{
            label: "瀘水市",
            value: "533301"
        }, {
            label: "福貢縣",
            value: "533323"
        }, {
            label: "貢山獨龍族怒族自治縣",
            value: "533324"
        }, {
            label: "蘭坪白族普米族自治縣",
            value: "533325"
        }
        ],
        label: "怒江傈僳族自治州",
        value: "533300"
    }, {
        children: [{
            label: "香格裏拉市",
            value: "533401"
        }, {
            label: "德欽縣",
            value: "533422"
        }, {
            label: "維西傈僳族自治縣",
            value: "533423"
        }
        ],
        label: "迪慶藏族自治州",
        value: "533400"
    }
    ],
    label: "雲南省",
    value: "530000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "540101"
        }, {
            label: "城關區",
            value: "540102"
        }, {
            label: "堆龍德慶區",
            value: "540103"
        }, {
            label: "林周縣",
            value: "540121"
        }, {
            label: "當雄縣",
            value: "540122"
        }, {
            label: "尼木縣",
            value: "540123"
        }, {
            label: "曲水縣",
            value: "540124"
        }, {
            label: "達孜縣",
            value: "540126"
        }, {
            label: "墨竹工卡縣",
            value: "540127"
        }
        ],
        label: "拉薩市",
        value: "540100"
    }, {
        children: [{
            label: "桑珠孜區",
            value: "540202"
        }, {
            label: "南木林縣",
            value: "540221"
        }, {
            label: "江孜縣",
            value: "540222"
        }, {
            label: "定日縣",
            value: "540223"
        }, {
            label: "薩迦縣",
            value: "540224"
        }, {
            label: "拉孜縣",
            value: "540225"
        }, {
            label: "昂仁縣",
            value: "540226"
        }, {
            label: "謝通門縣",
            value: "540227"
        }, {
            label: "白朗縣",
            value: "540228"
        }, {
            label: "仁布縣",
            value: "540229"
        }, {
            label: "康馬縣",
            value: "540230"
        }, {
            label: "定結縣",
            value: "540231"
        }, {
            label: "仲巴縣",
            value: "540232"
        }, {
            label: "亞東縣",
            value: "540233"
        }, {
            label: "吉隆縣",
            value: "540234"
        }, {
            label: "聶拉木縣",
            value: "540235"
        }, {
            label: "薩嘎縣",
            value: "540236"
        }, {
            label: "崗巴縣",
            value: "540237"
        }
        ],
        label: "日喀則市",
        value: "540200"
    }, {
        children: [{
            label: "卡若區",
            value: "540302"
        }, {
            label: "江達縣",
            value: "540321"
        }, {
            label: "貢覺縣",
            value: "540322"
        }, {
            label: "類烏齊縣",
            value: "540323"
        }, {
            label: "丁青縣",
            value: "540324"
        }, {
            label: "察雅縣",
            value: "540325"
        }, {
            label: "八宿縣",
            value: "540326"
        }, {
            label: "左貢縣",
            value: "540327"
        }, {
            label: "芒康縣",
            value: "540328"
        }, {
            label: "洛隆縣",
            value: "540329"
        }, {
            label: "邊壩縣",
            value: "540330"
        }
        ],
        label: "昌都市",
        value: "540300"
    }, {
        children: [{
            label: "巴宜區",
            value: "540402"
        }, {
            label: "工布江達縣",
            value: "540421"
        }, {
            label: "米林縣",
            value: "540422"
        }, {
            label: "墨脫縣",
            value: "540423"
        }, {
            label: "波密縣",
            value: "540424"
        }, {
            label: "察隅縣",
            value: "540425"
        }, {
            label: "朗縣",
            value: "540426"
        }
        ],
        label: "林芝市",
        value: "540400"
    }, {
        children: [{
            label: "市轄區",
            value: "540501"
        }, {
            label: "乃東區",
            value: "540502"
        }, {
            label: "紮囊縣",
            value: "540521"
        }, {
            label: "貢嘎縣",
            value: "540522"
        }, {
            label: "桑日縣",
            value: "540523"
        }, {
            label: "瓊結縣",
            value: "540524"
        }, {
            label: "曲松縣",
            value: "540525"
        }, {
            label: "措美縣",
            value: "540526"
        }, {
            label: "洛紮縣",
            value: "540527"
        }, {
            label: "加查縣",
            value: "540528"
        }, {
            label: "隆子縣",
            value: "540529"
        }, {
            label: "錯那縣",
            value: "540530"
        }, {
            label: "浪卡子縣",
            value: "540531"
        }
        ],
        label: "山南市",
        value: "540500"
    }, {
        children: [{
            label: "那曲縣",
            value: "542421"
        }, {
            label: "嘉黎縣",
            value: "542422"
        }, {
            label: "比如縣",
            value: "542423"
        }, {
            label: "聶榮縣",
            value: "542424"
        }, {
            label: "安多縣",
            value: "542425"
        }, {
            label: "申紮縣",
            value: "542426"
        }, {
            label: "索縣",
            value: "542427"
        }, {
            label: "班戈縣",
            value: "542428"
        }, {
            label: "巴青縣",
            value: "542429"
        }, {
            label: "尼瑪縣",
            value: "542430"
        }, {
            label: "雙湖縣",
            value: "542431"
        }
        ],
        label: "那曲地區",
        value: "542400"
    }, {
        children: [{
            label: "普蘭縣",
            value: "542521"
        }, {
            label: "劄達縣",
            value: "542522"
        }, {
            label: "噶爾縣",
            value: "542523"
        }, {
            label: "日土縣",
            value: "542524"
        }, {
            label: "革吉縣",
            value: "542525"
        }, {
            label: "改則縣",
            value: "542526"
        }, {
            label: "措勤縣",
            value: "542527"
        }
        ],
        label: "阿裏地區",
        value: "542500"
    }
    ],
    label: "西藏自治區",
    value: "540000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "610101"
        }, {
            label: "新城區",
            value: "610102"
        }, {
            label: "碑林區",
            value: "610103"
        }, {
            label: "蓮湖區",
            value: "610104"
        }, {
            label: "灞橋區",
            value: "610111"
        }, {
            label: "未央區",
            value: "610112"
        }, {
            label: "雁塔區",
            value: "610113"
        }, {
            label: "閻良區",
            value: "610114"
        }, {
            label: "臨潼區",
            value: "610115"
        }, {
            label: "長安區",
            value: "610116"
        }, {
            label: "高陵區",
            value: "610117"
        }, {
            label: "藍田縣",
            value: "610122"
        }, {
            label: "周至縣",
            value: "610124"
        }, {
            label: "戶縣",
            value: "610125"
        }
        ],
        label: "西安市",
        value: "610100"
    }, {
        children: [{
            label: "市轄區",
            value: "610201"
        }, {
            label: "王益區",
            value: "610202"
        }, {
            label: "印臺區",
            value: "610203"
        }, {
            label: "耀州區",
            value: "610204"
        }, {
            label: "宜君縣",
            value: "610222"
        }
        ],
        label: "銅川市",
        value: "610200"
    }, {
        children: [{
            label: "市轄區",
            value: "610301"
        }, {
            label: "渭濱區",
            value: "610302"
        }, {
            label: "金臺區",
            value: "610303"
        }, {
            label: "陳倉區",
            value: "610304"
        }, {
            label: "鳳翔縣",
            value: "610322"
        }, {
            label: "岐山縣",
            value: "610323"
        }, {
            label: "扶風縣",
            value: "610324"
        }, {
            label: "眉縣",
            value: "610326"
        }, {
            label: "隴縣",
            value: "610327"
        }, {
            label: "千陽縣",
            value: "610328"
        }, {
            label: "麟遊縣",
            value: "610329"
        }, {
            label: "鳳縣",
            value: "610330"
        }, {
            label: "太白縣",
            value: "610331"
        }
        ],
        label: "寶雞市",
        value: "610300"
    }, {
        children: [{
            label: "市轄區",
            value: "610401"
        }, {
            label: "秦都區",
            value: "610402"
        }, {
            label: "楊陵區",
            value: "610403"
        }, {
            label: "渭城區",
            value: "610404"
        }, {
            label: "三原縣",
            value: "610422"
        }, {
            label: "涇陽縣",
            value: "610423"
        }, {
            label: "乾縣",
            value: "610424"
        }, {
            label: "禮泉縣",
            value: "610425"
        }, {
            label: "永壽縣",
            value: "610426"
        }, {
            label: "彬縣",
            value: "610427"
        }, {
            label: "長武縣",
            value: "610428"
        }, {
            label: "旬邑縣",
            value: "610429"
        }, {
            label: "淳化縣",
            value: "610430"
        }, {
            label: "武功縣",
            value: "610431"
        }, {
            label: "興平市",
            value: "610481"
        }
        ],
        label: "鹹陽市",
        value: "610400"
    }, {
        children: [{
            label: "市轄區",
            value: "610501"
        }, {
            label: "臨渭區",
            value: "610502"
        }, {
            label: "華州區",
            value: "610503"
        }, {
            label: "潼關縣",
            value: "610522"
        }, {
            label: "大荔縣",
            value: "610523"
        }, {
            label: "合陽縣",
            value: "610524"
        }, {
            label: "澄城縣",
            value: "610525"
        }, {
            label: "蒲城縣",
            value: "610526"
        }, {
            label: "白水縣",
            value: "610527"
        }, {
            label: "富平縣",
            value: "610528"
        }, {
            label: "韓城市",
            value: "610581"
        }, {
            label: "華陰市",
            value: "610582"
        }
        ],
        label: "渭南市",
        value: "610500"
    }, {
        children: [{
            label: "市轄區",
            value: "610601"
        }, {
            label: "寶塔區",
            value: "610602"
        }, {
            label: "安塞區",
            value: "610603"
        }, {
            label: "延長縣",
            value: "610621"
        }, {
            label: "延川縣",
            value: "610622"
        }, {
            label: "子長縣",
            value: "610623"
        }, {
            label: "誌丹縣",
            value: "610625"
        }, {
            label: "吳起縣",
            value: "610626"
        }, {
            label: "甘泉縣",
            value: "610627"
        }, {
            label: "富縣",
            value: "610628"
        }, {
            label: "洛川縣",
            value: "610629"
        }, {
            label: "宜川縣",
            value: "610630"
        }, {
            label: "黃龍縣",
            value: "610631"
        }, {
            label: "黃陵縣",
            value: "610632"
        }
        ],
        label: "延安市",
        value: "610600"
    }, {
        children: [{
            label: "市轄區",
            value: "610701"
        }, {
            label: "漢臺區",
            value: "610702"
        }, {
            label: "南鄭縣",
            value: "610721"
        }, {
            label: "城固縣",
            value: "610722"
        }, {
            label: "洋縣",
            value: "610723"
        }, {
            label: "西鄉縣",
            value: "610724"
        }, {
            label: "勉縣",
            value: "610725"
        }, {
            label: "寧強縣",
            value: "610726"
        }, {
            label: "略陽縣",
            value: "610727"
        }, {
            label: "鎮巴縣",
            value: "610728"
        }, {
            label: "留壩縣",
            value: "610729"
        }, {
            label: "佛坪縣",
            value: "610730"
        }
        ],
        label: "漢中市",
        value: "610700"
    }, {
        children: [{
            label: "市轄區",
            value: "610801"
        }, {
            label: "榆陽區",
            value: "610802"
        }, {
            label: "橫山區",
            value: "610803"
        }, {
            label: "神木縣",
            value: "610821"
        }, {
            label: "府谷縣",
            value: "610822"
        }, {
            label: "靖邊縣",
            value: "610824"
        }, {
            label: "定邊縣",
            value: "610825"
        }, {
            label: "綏德縣",
            value: "610826"
        }, {
            label: "米脂縣",
            value: "610827"
        }, {
            label: "佳縣",
            value: "610828"
        }, {
            label: "吳堡縣",
            value: "610829"
        }, {
            label: "清澗縣",
            value: "610830"
        }, {
            label: "子洲縣",
            value: "610831"
        }
        ],
        label: "榆林市",
        value: "610800"
    }, {
        children: [{
            label: "市轄區",
            value: "610901"
        }, {
            label: "漢濱區",
            value: "610902"
        }, {
            label: "漢陰縣",
            value: "610921"
        }, {
            label: "石泉縣",
            value: "610922"
        }, {
            label: "寧陜縣",
            value: "610923"
        }, {
            label: "紫陽縣",
            value: "610924"
        }, {
            label: "嵐臯縣",
            value: "610925"
        }, {
            label: "平利縣",
            value: "610926"
        }, {
            label: "鎮坪縣",
            value: "610927"
        }, {
            label: "旬陽縣",
            value: "610928"
        }, {
            label: "白河縣",
            value: "610929"
        }
        ],
        label: "安康市",
        value: "610900"
    }, {
        children: [{
            label: "市轄區",
            value: "611001"
        }, {
            label: "商州區",
            value: "611002"
        }, {
            label: "洛南縣",
            value: "611021"
        }, {
            label: "丹鳳縣",
            value: "611022"
        }, {
            label: "商南縣",
            value: "611023"
        }, {
            label: "山陽縣",
            value: "611024"
        }, {
            label: "鎮安縣",
            value: "611025"
        }, {
            label: "柞水縣",
            value: "611026"
        }
        ],
        label: "商洛市",
        value: "611000"
    }
    ],
    label: "陜西省",
    value: "610000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "620101"
        }, {
            label: "城關區",
            value: "620102"
        }, {
            label: "七裏河區",
            value: "620103"
        }, {
            label: "西固區",
            value: "620104"
        }, {
            label: "安寧區",
            value: "620105"
        }, {
            label: "紅古區",
            value: "620111"
        }, {
            label: "永登縣",
            value: "620121"
        }, {
            label: "臯蘭縣",
            value: "620122"
        }, {
            label: "榆中縣",
            value: "620123"
        }
        ],
        label: "蘭州市",
        value: "620100"
    }, {
        children: [{
            label: "市轄區",
            value: "620201"
        }
        ],
        label: "嘉峪關市",
        value: "620200"
    }, {
        children: [{
            label: "市轄區",
            value: "620301"
        }, {
            label: "金川區",
            value: "620302"
        }, {
            label: "永昌縣",
            value: "620321"
        }
        ],
        label: "金昌市",
        value: "620300"
    }, {
        children: [{
            label: "市轄區",
            value: "620401"
        }, {
            label: "白銀區",
            value: "620402"
        }, {
            label: "平川區",
            value: "620403"
        }, {
            label: "靖遠縣",
            value: "620421"
        }, {
            label: "會寧縣",
            value: "620422"
        }, {
            label: "景泰縣",
            value: "620423"
        }
        ],
        label: "白銀市",
        value: "620400"
    }, {
        children: [{
            label: "市轄區",
            value: "620501"
        }, {
            label: "秦州區",
            value: "620502"
        }, {
            label: "麥積區",
            value: "620503"
        }, {
            label: "清水縣",
            value: "620521"
        }, {
            label: "秦安縣",
            value: "620522"
        }, {
            label: "甘谷縣",
            value: "620523"
        }, {
            label: "武山縣",
            value: "620524"
        }, {
            label: "張家川回族自治縣",
            value: "620525"
        }
        ],
        label: "天水市",
        value: "620500"
    }, {
        children: [{
            label: "市轄區",
            value: "620601"
        }, {
            label: "涼州區",
            value: "620602"
        }, {
            label: "民勤縣",
            value: "620621"
        }, {
            label: "古浪縣",
            value: "620622"
        }, {
            label: "天祝藏族自治縣",
            value: "620623"
        }
        ],
        label: "武威市",
        value: "620600"
    }, {
        children: [{
            label: "市轄區",
            value: "620701"
        }, {
            label: "甘州區",
            value: "620702"
        }, {
            label: "肅南裕固族自治縣",
            value: "620721"
        }, {
            label: "民樂縣",
            value: "620722"
        }, {
            label: "臨澤縣",
            value: "620723"
        }, {
            label: "高臺縣",
            value: "620724"
        }, {
            label: "山丹縣",
            value: "620725"
        }
        ],
        label: "張掖市",
        value: "620700"
    }, {
        children: [{
            label: "市轄區",
            value: "620801"
        }, {
            label: "崆峒區",
            value: "620802"
        }, {
            label: "涇川縣",
            value: "620821"
        }, {
            label: "靈臺縣",
            value: "620822"
        }, {
            label: "崇信縣",
            value: "620823"
        }, {
            label: "華亭縣",
            value: "620824"
        }, {
            label: "莊浪縣",
            value: "620825"
        }, {
            label: "靜寧縣",
            value: "620826"
        }
        ],
        label: "平涼市",
        value: "620800"
    }, {
        children: [{
            label: "市轄區",
            value: "620901"
        }, {
            label: "肅州區",
            value: "620902"
        }, {
            label: "金塔縣",
            value: "620921"
        }, {
            label: "瓜州縣",
            value: "620922"
        }, {
            label: "肅北蒙古族自治縣",
            value: "620923"
        }, {
            label: "阿克塞哈薩克族自治縣",
            value: "620924"
        }, {
            label: "玉門市",
            value: "620981"
        }, {
            label: "敦煌市",
            value: "620982"
        }
        ],
        label: "酒泉市",
        value: "620900"
    }, {
        children: [{
            label: "市轄區",
            value: "621001"
        }, {
            label: "西峰區",
            value: "621002"
        }, {
            label: "慶城縣",
            value: "621021"
        }, {
            label: "環縣",
            value: "621022"
        }, {
            label: "華池縣",
            value: "621023"
        }, {
            label: "合水縣",
            value: "621024"
        }, {
            label: "正寧縣",
            value: "621025"
        }, {
            label: "寧縣",
            value: "621026"
        }, {
            label: "鎮原縣",
            value: "621027"
        }
        ],
        label: "慶陽市",
        value: "621000"
    }, {
        children: [{
            label: "市轄區",
            value: "621101"
        }, {
            label: "安定區",
            value: "621102"
        }, {
            label: "通渭縣",
            value: "621121"
        }, {
            label: "隴西縣",
            value: "621122"
        }, {
            label: "渭源縣",
            value: "621123"
        }, {
            label: "臨洮縣",
            value: "621124"
        }, {
            label: "漳縣",
            value: "621125"
        }, {
            label: "岷縣",
            value: "621126"
        }
        ],
        label: "定西市",
        value: "621100"
    }, {
        children: [{
            label: "市轄區",
            value: "621201"
        }, {
            label: "武都區",
            value: "621202"
        }, {
            label: "成縣",
            value: "621221"
        }, {
            label: "文縣",
            value: "621222"
        }, {
            label: "宕昌縣",
            value: "621223"
        }, {
            label: "康縣",
            value: "621224"
        }, {
            label: "西和縣",
            value: "621225"
        }, {
            label: "禮縣",
            value: "621226"
        }, {
            label: "徽縣",
            value: "621227"
        }, {
            label: "兩當縣",
            value: "621228"
        }
        ],
        label: "隴南市",
        value: "621200"
    }, {
        children: [{
            label: "臨夏市",
            value: "622901"
        }, {
            label: "臨夏縣",
            value: "622921"
        }, {
            label: "康樂縣",
            value: "622922"
        }, {
            label: "永靖縣",
            value: "622923"
        }, {
            label: "廣河縣",
            value: "622924"
        }, {
            label: "和政縣",
            value: "622925"
        }, {
            label: "東鄉族自治縣",
            value: "622926"
        }, {
            label: "積石山保安族東鄉族撒拉族自治縣",
            value: "622927"
        }
        ],
        label: "臨夏回族自治州",
        value: "622900"
    }, {
        children: [{
            label: "合作市",
            value: "623001"
        }, {
            label: "臨潭縣",
            value: "623021"
        }, {
            label: "卓尼縣",
            value: "623022"
        }, {
            label: "舟曲縣",
            value: "623023"
        }, {
            label: "叠部縣",
            value: "623024"
        }, {
            label: "瑪曲縣",
            value: "623025"
        }, {
            label: "碌曲縣",
            value: "623026"
        }, {
            label: "夏河縣",
            value: "623027"
        }
        ],
        label: "甘南藏族自治州",
        value: "623000"
    }
    ],
    label: "甘肅省",
    value: "620000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "630101"
        }, {
            label: "城東區",
            value: "630102"
        }, {
            label: "城中區",
            value: "630103"
        }, {
            label: "城西區",
            value: "630104"
        }, {
            label: "城北區",
            value: "630105"
        }, {
            label: "大通回族土族自治縣",
            value: "630121"
        }, {
            label: "湟中縣",
            value: "630122"
        }, {
            label: "湟源縣",
            value: "630123"
        }
        ],
        label: "西寧市",
        value: "630100"
    }, {
        children: [{
            label: "樂都區",
            value: "630202"
        }, {
            label: "平安區",
            value: "630203"
        }, {
            label: "民和回族土族自治縣",
            value: "630222"
        }, {
            label: "互助土族自治縣",
            value: "630223"
        }, {
            label: "化隆回族自治縣",
            value: "630224"
        }, {
            label: "循化撒拉族自治縣",
            value: "630225"
        }
        ],
        label: "海東市",
        value: "630200"
    }, {
        children: [{
            label: "門源回族自治縣",
            value: "632221"
        }, {
            label: "祁連縣",
            value: "632222"
        }, {
            label: "海晏縣",
            value: "632223"
        }, {
            label: "剛察縣",
            value: "632224"
        }
        ],
        label: "海北藏族自治州",
        value: "632200"
    }, {
        children: [{
            label: "同仁縣",
            value: "632321"
        }, {
            label: "尖紮縣",
            value: "632322"
        }, {
            label: "澤庫縣",
            value: "632323"
        }, {
            label: "河南蒙古族自治縣",
            value: "632324"
        }
        ],
        label: "黃南藏族自治州",
        value: "632300"
    }, {
        children: [{
            label: "共和縣",
            value: "632521"
        }, {
            label: "同德縣",
            value: "632522"
        }, {
            label: "貴德縣",
            value: "632523"
        }, {
            label: "興海縣",
            value: "632524"
        }, {
            label: "貴南縣",
            value: "632525"
        }
        ],
        label: "海南藏族自治州",
        value: "632500"
    }, {
        children: [{
            label: "瑪沁縣",
            value: "632621"
        }, {
            label: "班瑪縣",
            value: "632622"
        }, {
            label: "甘德縣",
            value: "632623"
        }, {
            label: "達日縣",
            value: "632624"
        }, {
            label: "久治縣",
            value: "632625"
        }, {
            label: "瑪多縣",
            value: "632626"
        }
        ],
        label: "果洛藏族自治州",
        value: "632600"
    }, {
        children: [{
            label: "玉樹市",
            value: "632701"
        }, {
            label: "雜多縣",
            value: "632722"
        }, {
            label: "稱多縣",
            value: "632723"
        }, {
            label: "治多縣",
            value: "632724"
        }, {
            label: "囊謙縣",
            value: "632725"
        }, {
            label: "曲麻萊縣",
            value: "632726"
        }
        ],
        label: "玉樹藏族自治州",
        value: "632700"
    }, {
        children: [{
            label: "格爾木市",
            value: "632801"
        }, {
            label: "德令哈市",
            value: "632802"
        }, {
            label: "烏蘭縣",
            value: "632821"
        }, {
            label: "都蘭縣",
            value: "632822"
        }, {
            label: "天峻縣",
            value: "632823"
        }
        ],
        label: "海西蒙古族藏族自治州",
        value: "632800"
    }
    ],
    label: "青海省",
    value: "630000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "640101"
        }, {
            label: "興慶區",
            value: "640104"
        }, {
            label: "西夏區",
            value: "640105"
        }, {
            label: "金鳳區",
            value: "640106"
        }, {
            label: "永寧縣",
            value: "640121"
        }, {
            label: "賀蘭縣",
            value: "640122"
        }, {
            label: "靈武市",
            value: "640181"
        }
        ],
        label: "銀川市",
        value: "640100"
    }, {
        children: [{
            label: "市轄區",
            value: "640201"
        }, {
            label: "大武口區",
            value: "640202"
        }, {
            label: "惠農區",
            value: "640205"
        }, {
            label: "平羅縣",
            value: "640221"
        }
        ],
        label: "石嘴山市",
        value: "640200"
    }, {
        children: [{
            label: "市轄區",
            value: "640301"
        }, {
            label: "利通區",
            value: "640302"
        }, {
            label: "紅寺堡區",
            value: "640303"
        }, {
            label: "鹽池縣",
            value: "640323"
        }, {
            label: "同心縣",
            value: "640324"
        }, {
            label: "青銅峽市",
            value: "640381"
        }
        ],
        label: "吳忠市",
        value: "640300"
    }, {
        children: [{
            label: "市轄區",
            value: "640401"
        }, {
            label: "原州區",
            value: "640402"
        }, {
            label: "西吉縣",
            value: "640422"
        }, {
            label: "隆德縣",
            value: "640423"
        }, {
            label: "涇源縣",
            value: "640424"
        }, {
            label: "彭陽縣",
            value: "640425"
        }
        ],
        label: "固原市",
        value: "640400"
    }, {
        children: [{
            label: "市轄區",
            value: "640501"
        }, {
            label: "沙坡頭區",
            value: "640502"
        }, {
            label: "中寧縣",
            value: "640521"
        }, {
            label: "海原縣",
            value: "640522"
        }
        ],
        label: "中衛市",
        value: "640500"
    }
    ],
    label: "寧夏回族自治區",
    value: "640000"
}, {
    children: [{
        children: [{
            label: "市轄區",
            value: "650101"
        }, {
            label: "天山區",
            value: "650102"
        }, {
            label: "沙依巴克區",
            value: "650103"
        }, {
            label: "新市區",
            value: "650104"
        }, {
            label: "水磨溝區",
            value: "650105"
        }, {
            label: "頭屯河區",
            value: "650106"
        }, {
            label: "達阪城區",
            value: "650107"
        }, {
            label: "米東區",
            value: "650109"
        }, {
            label: "烏魯木齊縣",
            value: "650121"
        }
        ],
        label: "烏魯木齊市",
        value: "650100"
    }, {
        children: [{
            label: "市轄區",
            value: "650201"
        }, {
            label: "獨山子區",
            value: "650202"
        }, {
            label: "克拉瑪依區",
            value: "650203"
        }, {
            label: "白堿灘區",
            value: "650204"
        }, {
            label: "烏爾禾區",
            value: "650205"
        }
        ],
        label: "克拉瑪依市",
        value: "650200"
    }, {
        children: [{
            label: "高昌區",
            value: "650402"
        }, {
            label: "鄯善縣",
            value: "650421"
        }, {
            label: "托克遜縣",
            value: "650422"
        }
        ],
        label: "吐魯番市",
        value: "650400"
    }, {
        children: [{
            label: "伊州區",
            value: "650502"
        }, {
            label: "巴裏坤哈薩克自治縣",
            value: "650521"
        }, {
            label: "伊吾縣",
            value: "650522"
        }
        ],
        label: "哈密市",
        value: "650500"
    }, {
        children: [{
            label: "昌吉市",
            value: "652301"
        }, {
            label: "阜康市",
            value: "652302"
        }, {
            label: "呼圖壁縣",
            value: "652323"
        }, {
            label: "瑪納斯縣",
            value: "652324"
        }, {
            label: "奇臺縣",
            value: "652325"
        }, {
            label: "吉木薩爾縣",
            value: "652327"
        }, {
            label: "木壘哈薩克自治縣",
            value: "652328"
        }
        ],
        label: "昌吉回族自治州",
        value: "652300"
    }, {
        children: [{
            label: "博樂市",
            value: "652701"
        }, {
            label: "阿拉山口市",
            value: "652702"
        }, {
            label: "精河縣",
            value: "652722"
        }, {
            label: "溫泉縣",
            value: "652723"
        }
        ],
        label: "博爾塔拉蒙古自治州",
        value: "652700"
    }, {
        children: [{
            label: "庫爾勒市",
            value: "652801"
        }, {
            label: "輪臺縣",
            value: "652822"
        }, {
            label: "尉犁縣",
            value: "652823"
        }, {
            label: "若羌縣",
            value: "652824"
        }, {
            label: "且末縣",
            value: "652825"
        }, {
            label: "焉耆回族自治縣",
            value: "652826"
        }, {
            label: "和靜縣",
            value: "652827"
        }, {
            label: "和碩縣",
            value: "652828"
        }, {
            label: "博湖縣",
            value: "652829"
        }
        ],
        label: "巴音郭楞蒙古自治州",
        value: "652800"
    }, {
        children: [{
            label: "阿克蘇市",
            value: "652901"
        }, {
            label: "溫宿縣",
            value: "652922"
        }, {
            label: "庫車縣",
            value: "652923"
        }, {
            label: "沙雅縣",
            value: "652924"
        }, {
            label: "新和縣",
            value: "652925"
        }, {
            label: "拜城縣",
            value: "652926"
        }, {
            label: "烏什縣",
            value: "652927"
        }, {
            label: "阿瓦提縣",
            value: "652928"
        }, {
            label: "柯坪縣",
            value: "652929"
        }
        ],
        label: "阿克蘇地區",
        value: "652900"
    }, {
        children: [{
            label: "阿圖什市",
            value: "653001"
        }, {
            label: "阿克陶縣",
            value: "653022"
        }, {
            label: "阿合奇縣",
            value: "653023"
        }, {
            label: "烏恰縣",
            value: "653024"
        }
        ],
        label: "克孜勒蘇柯爾克孜自治州",
        value: "653000"
    }, {
        children: [{
            label: "喀什市",
            value: "653101"
        }, {
            label: "疏附縣",
            value: "653121"
        }, {
            label: "疏勒縣",
            value: "653122"
        }, {
            label: "英吉沙縣",
            value: "653123"
        }, {
            label: "澤普縣",
            value: "653124"
        }, {
            label: "莎車縣",
            value: "653125"
        }, {
            label: "葉城縣",
            value: "653126"
        }, {
            label: "麥蓋提縣",
            value: "653127"
        }, {
            label: "嶽普湖縣",
            value: "653128"
        }, {
            label: "伽師縣",
            value: "653129"
        }, {
            label: "巴楚縣",
            value: "653130"
        }, {
            label: "塔什庫爾幹塔吉克自治縣",
            value: "653131"
        }
        ],
        label: "喀什地區",
        value: "653100"
    }, {
        children: [{
            label: "和田市",
            value: "653201"
        }, {
            label: "和田縣",
            value: "653221"
        }, {
            label: "墨玉縣",
            value: "653222"
        }, {
            label: "皮山縣",
            value: "653223"
        }, {
            label: "洛浦縣",
            value: "653224"
        }, {
            label: "策勒縣",
            value: "653225"
        }, {
            label: "於田縣",
            value: "653226"
        }, {
            label: "民豐縣",
            value: "653227"
        }
        ],
        label: "和田地區",
        value: "653200"
    }, {
        children: [{
            label: "伊寧市",
            value: "654002"
        }, {
            label: "奎屯市",
            value: "654003"
        }, {
            label: "霍爾果斯市",
            value: "654004"
        }, {
            label: "伊寧縣",
            value: "654021"
        }, {
            label: "察布查爾錫伯自治縣",
            value: "654022"
        }, {
            label: "霍城縣",
            value: "654023"
        }, {
            label: "鞏留縣",
            value: "654024"
        }, {
            label: "新源縣",
            value: "654025"
        }, {
            label: "昭蘇縣",
            value: "654026"
        }, {
            label: "特克斯縣",
            value: "654027"
        }, {
            label: "尼勒克縣",
            value: "654028"
        }
        ],
        label: "伊犁哈薩克自治州",
        value: "654000"
    }, {
        children: [{
            label: "塔城市",
            value: "654201"
        }, {
            label: "烏蘇市",
            value: "654202"
        }, {
            label: "額敏縣",
            value: "654221"
        }, {
            label: "沙灣縣",
            value: "654223"
        }, {
            label: "托裏縣",
            value: "654224"
        }, {
            label: "裕民縣",
            value: "654225"
        }, {
            label: "和布克賽爾蒙古自治縣",
            value: "654226"
        }
        ],
        label: "塔城地區",
        value: "654200"
    }, {
        children: [{
            label: "阿勒泰市",
            value: "654301"
        }, {
            label: "布爾津縣",
            value: "654321"
        }, {
            label: "富蘊縣",
            value: "654322"
        }, {
            label: "福海縣",
            value: "654323"
        }, {
            label: "哈巴河縣",
            value: "654324"
        }, {
            label: "青河縣",
            value: "654325"
        }, {
            label: "吉木乃縣",
            value: "654326"
        }
        ],
        label: "阿勒泰地區",
        value: "654300"
    }, {
        children: [{
            label: "石河子市",
            value: "659001"
        }, {
            label: "阿拉爾市",
            value: "659002"
        }, {
            label: "圖木舒克市",
            value: "659003"
        }, {
            label: "五家渠市",
            value: "659004"
        }, {
            label: "鐵門關市",
            value: "659006"
        }
        ],
        label: "自治區直轄縣級行政區劃",
        value: "659000"
    }
    ],
    label: "新疆維吾爾自治區",
    value: "650000"
}, {
    label: "臺灣省",
    value: "710000"
}, {
    label: "香港",
    value: "810000",
    children: [
        {
            label: '香港島中西區',
            value: '1',
            children: [
                {
                    label: '金鐘',
                    value: '101',
                },
                {
                    label: '中環',
                    value: '102',
                },
                {
                    label: '上環',
                    value: '103',
                },
                {
                    label: '西環',
                    value: '104',
                },
                {
                    label: '摩星嶺',
                    value: '105',
                },
                {
                    label: '太平山',
                    value: '106',
                },
                {
                    label: '薄扶林北部',
                    value: '107',
                },
                {
                    label: '其他',
                    value: '108',
                },
            ]
        },
        {
            label: '香港島灣仔區',
            value: '2',
            children: [
                {
                    label: '灣仔',
                    value: '201',
                },
                {
                    label: '銅鑼灣',
                    value: '202',
                },
                {
                    label: '跑馬地',
                    value: '203',
                },
                {
                    label: '大坑',
                    value: '204',
                },
                {
                    label: '渣甸山',
                    value: '205',
                },
                {
                    label: '灣仔峽',
                    value: '206',
                },
                {
                    label: '其他',
                    value: '207',
                },
            ]
        },
        {
            label: '香港島東區',
            value: '3',
            children: [
                {
                    label: '銅鑼灣東部',
                    value: '301',
                },
                {
                    label: '炮臺山',
                    value: '302',
                },
                {
                    label: '北角',
                    value: '303',
                },
                {
                    label: '鲗魚湧',
                    value: '304',
                },
                {
                    label: '西灣河',
                    value: '305',
                },
                {
                    label: '筲箕灣',
                    value: '306',
                },
                {
                    label: '柴灣',
                    value: '307',
                },
                {
                    label: '小西灣',
                    value: '308',
                },
                {
                    label: '其他',
                    value: '309',
                },
            ]
        },
        {
            label: '香港島南區',
            value: '4',
            children: [
                {
                    label: '香港仔',
                    value: '401',
                },
                {
                    label: '鴨脷洲',
                    value: '402',
                },
                {
                    label: '鋼線灣',
                    value: '403',
                },
                {
                    label: '薄扶林',
                    value: '404',
                },
                {
                    label: '黃竹坑',
                    value: '405',
                },
                {
                    label: '深水灣',
                    value: '406',
                },
                {
                    label: '淺水灣',
                    value: '407',
                },
                {
                    label: '赤柱',
                    value: '408',
                },
                {
                    label: '大潭',
                    value: '409',
                },
                {
                    label: '石澳',
                    value: '410',
                },
                {
                    label: '其他',
                    value: '411',
                },
            ]
        },
        {
            label: '九龍半島油尖旺區',
            value: '5',
            children: [
                {
                    label: '尖沙咀',
                    value: '501',
                },
                {
                    label: '佐敦',
                    value: '502',
                },
                {
                    label: '油麻地',
                    value: '503',
                },
                {
                    label: '旺角',
                    value: '504',
                },
                {
                    label: '大角咀',
                    value: '505',
                },
                {
                    label: '西九龍填海區',
                    value: '506',
                },
                {
                    label: '其他',
                    value: '507',
                },
            ]
        },
        {
            label: '九龍半島深水埗區',
            value: '6',
            children: [
                {
                    label: '深水埗',
                    value: '601',
                },
                {
                    label: '長沙灣',
                    value: '602',
                },
                {
                    label: '荔枝角',
                    value: '603',
                },
                {
                    label: '美孚新邨',
                    value: '604',
                },
                {
                    label: '蘇屋',
                    value: '605',
                },
                {
                    label: '石硤尾',
                    value: '606',
                },
                {
                    label: '又壹村',
                    value: '607',
                },
                {
                    label: '昂船洲南部',
                    value: '608',
                },
                {
                    label: '其他',
                    value: '609',
                },
            ]
        },
        {
            label: '九龍半島九龍城區',
            value: '7',
            children: [
                {
                    label: '九龍城',
                    value: '701',
                },
                {
                    label: '九龍塘',
                    value: '702',
                },
                {
                    label: '何文田',
                    value: '703',
                },
                {
                    label: '馬頭圍',
                    value: '704',
                },
                {
                    label: '馬頭角',
                    value: '705',
                },
                {
                    label: '土瓜灣',
                    value: '706',
                },
                {
                    label: '紅磡',
                    value: '707',
                },
                {
                    label: '啟德',
                    value: '708',
                },
                {
                    label: '其他',
                    value: '709',
                },
            ]
        },
        {
            label: '九龍半島黃大仙區',
            value: '8',
            children: [
                {
                    label: '黃大仙',
                    value: '801',
                },
                {
                    label: '牛池灣',
                    value: '802',
                },
                {
                    label: '鉆石山',
                    value: '803',
                },
                {
                    label: '慈雲山',
                    value: '804',
                },
                {
                    label: '樂富',
                    value: '805',
                },
                {
                    label: '新蒲崗',
                    value: '806',
                },
                {
                    label: '竹園邨',
                    value: '807',
                },
                {
                    label: '其他',
                    value: '808',
                },
            ]
        },
        {
            label: '九龍半島觀塘區',
            value: '9',
            children: [
                {
                    label: '觀塘市中心',
                    value: '901',
                },
                {
                    label: '牛頭角',
                    value: '902',
                },
                {
                    label: '九龍灣',
                    value: '903',
                },
                {
                    label: '秀茂坪',
                    value: '904',
                },
                {
                    label: '藍田',
                    value: '905',
                },
                {
                    label: '茶果嶺',
                    value: '906',
                },
                {
                    label: '油塘',
                    value: '907',
                },
                {
                    label: '順利邨',
                    value: '908',
                },
                {
                    label: '佐敦谷',
                    value: '909',
                },
                {
                    label: '其他',
                    value: '910',
                },
            ]
        },
        {
            label: '新界北區',
            value: '10',
            children: [
                {
                    label: '上水',
                    value: '1001',
                },
                {
                    label: '粉嶺',
                    value: '1002',
                },
                {
                    label: '沙頭角',
                    value: '1003',
                },
                {
                    label: '打鼓嶺',
                    value: '1004',
                },
                {
                    label: '吉澳',
                    value: '1005',
                },
                {
                    label: '鴨洲',
                    value: '1006',
                },
                {
                    label: '其他',
                    value: '1007',
                },
            ]
        },
        {
            label: '新界大埔區',
            value: '11',
            children: [
                {
                    label: '大埔',
                    value: '1101',
                },
                {
                    label: '大埔滘',
                    value: '1102',
                },
                {
                    label: '汀角',
                    value: '1103',
                },
                {
                    label: '船灣',
                    value: '1104',
                },
                {
                    label: '西貢半島北部',
                    value: '1105',
                },
                {
                    label: '其他',
                    value: '1106',
                },
            ]
        },
        {
            label: '新界沙田區',
            value: '12',
            children: [
                {
                    label: '沙田市中心',
                    value: '1201',
                },
                {
                    label: '大圍',
                    value: '1202',
                },
                {
                    label: '火炭',
                    value: '1203',
                },
                {
                    label: '禾輋西',
                    value: '1204',
                },
                {
                    label: '石門',
                    value: '1205',
                },
                {
                    label: '小瀝源',
                    value: '1206',
                },
                {
                    label: '圓洲角',
                    value: '1207',
                },
                {
                    label: '馬料水',
                    value: '1208',
                },
                {
                    label: '馬鞍山',
                    value: '1209',
                },
                {
                    label: '烏溪沙',
                    value: '1210',
                },
                {
                    label: '其他',
                    value: '1211',
                },
            ]
        },
        {
            label: '新界西貢區',
            value: '13',
            children: [
                {
                    label: '西貢市',
                    value: '1301',
                },
                {
                    label: '清水灣',
                    value: '1302',
                },
                {
                    label: '將軍澳',
                    value: '1303',
                },
                {
                    label: '調景嶺',
                    value: '1304',
                },
                {
                    label: '北潭湧',
                    value: '1305',
                },
                {
                    label: '蠔湧',
                    value: '1306',
                },
                {
                    label: '其他',
                    value: '1307',
                },
            ]
        },
        {
            label: '新界荃灣區',
            value: '14',
            children: [
                {
                    label: '荃灣市中心',
                    value: '1401',
                },
                {
                    label: '川龍',
                    value: '1402',
                },
                {
                    label: '荃景圍',
                    value: '1403',
                },
                {
                    label: '油柑頭',
                    value: '1404',
                },
                {
                    label: '汀九',
                    value: '1405',
                },
                {
                    label: '深井',
                    value: '1406',
                },
                {
                    label: '青龍頭',
                    value: '1407',
                },
                {
                    label: '馬灣',
                    value: '1408',
                },
                {
                    label: '陰澳',
                    value: '1409',
                },
                {
                    label: '竹篙灣',
                    value: '1410',
                },
                {
                    label: '其他',
                    value: '1411',
                },
            ]
        },
        {
            label: '新界屯門區',
            value: '15',
            children: [
                {
                    label: '屯門新市鎮',
                    value: '1501',
                },
                {
                    label: '藍地',
                    value: '1502',
                },
                {
                    label: '亦園',
                    value: '1503',
                },
                {
                    label: '大欖湧',
                    value: '1504',
                },
                {
                    label: '掃管笏',
                    value: '1505',
                },
                {
                    label: '稔灣',
                    value: '1506',
                },
                {
                    label: '龍鼓灘',
                    value: '1507',
                },
                {
                    label: '爛角咀',
                    value: '1508',
                },
                {
                    label: '大小磨刀',
                    value: '1509',
                },
                {
                    label: '匙羹洲',
                    value: '1510',
                },
                {
                    label: '龍鼓洲',
                    value: '1511',
                },
                {
                    label: '沙洲',
                    value: '1512',
                },
                {
                    label: '其他',
                    value: '1513',
                },
            ]
        },
        {
            label: '新界元朗區',
            value: '16',
            children: [
                {
                    label: '天水圍',
                    value: '1601',
                },
                {
                    label: '元朗市',
                    value: '1602',
                },
                {
                    label: '其他',
                    value: '1603',
                },
            ]
        },
        {
            label: '新界葵青區',
            value: '17',
            children: [
                {
                    label: '葵湧區',
                    value: '1701',
                },
                {
                    label: '青衣島',
                    value: '1702',
                },
                {
                    label: '其他',
                    value: '1703',
                },
            ]
        },
        {
            label: '新界離島區',
            value: '18',
            children: [
                {
                    label: '赤鱲角',
                    value: '1801',
                },
                {
                    label: '長洲',
                    value: '1802',
                },
                {
                    label: '喜靈洲',
                    value: '1803',
                },
                {
                    label: '交椅洲',
                    value: '1804',
                },
                {
                    label: '南丫島',
                    value: '1805',
                },
                {
                    label: '大嶼山',
                    value: '1806',
                },
                {
                    label: '坪洲',
                    value: '1807',
                },
                {
                    label: '蒲苔群島',
                    value: '1808',
                },
                {
                    label: '石鼓洲',
                    value: '1809',
                },
                {
                    label: '索罟洲',
                    value: '1810',
                },
                {
                    label: '小鴉洲',
                    value: '1811',
                },
                {
                    label: '大鴉洲',
                    value: '1812',
                },
                {
                    label: '其他',
                    value: '1813',
                },
            ]
        },
    ]
}, {
    label: "澳門特別行政區",
    value: "820000"
}
]


// WEBPACK FOOTER //
// ./src/utils/addr/zh-TW.js